/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * PanLuma API
 * Enterprise productivity application API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type { AddInitiativeCustomerRequest } from '../models/addInitiativeCustomerRequest';

import type { AddWorkItemCustomerRequest } from '../models/addWorkItemCustomerRequest';

import type { AnnouncementTranslationGenerationResult } from '../models/announcementTranslationGenerationResult';

import type { AssignWorkItemToSprintRequest } from '../models/assignWorkItemToSprintRequest';

import type { ChangelogLinkedWorkItemListResponse } from '../models/changelogLinkedWorkItemListResponse';

import type { ChangelogWorkItemLinkCreate } from '../models/changelogWorkItemLinkCreate';

import type { ClearWorkItemDispatchApiV1SoftwareFactoryWorkItemsItemIdClearDispatchPostBody } from '../models/clearWorkItemDispatchApiV1SoftwareFactoryWorkItemsItemIdClearDispatchPostBody';

import type { CreateAnnouncementApiV1SoftwareFactoryAnnouncementsPostBody } from '../models/createAnnouncementApiV1SoftwareFactoryAnnouncementsPostBody';

import type { CreateChangelogEntryApiV1SoftwareFactoryChangelogPostBody } from '../models/createChangelogEntryApiV1SoftwareFactoryChangelogPostBody';

import type { CreateExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesPostBody } from '../models/createExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesPostBody';

import type { CreateInitiativeApiV1SoftwareFactoryInitiativesPostBody } from '../models/createInitiativeApiV1SoftwareFactoryInitiativesPostBody';

import type { CreateMilestoneApiV1SoftwareFactoryMilestonesPostBody } from '../models/createMilestoneApiV1SoftwareFactoryMilestonesPostBody';

import type { CreateWorkItemApiV1SoftwareFactoryWorkItemsPostBody } from '../models/createWorkItemApiV1SoftwareFactoryWorkItemsPostBody';

import type { GenerateAnnouncementTranslationsRequest } from '../models/generateAnnouncementTranslationsRequest';

import type { GetDashboardApiV1SoftwareFactoryDashboardGetParams } from '../models/getDashboardApiV1SoftwareFactoryDashboardGetParams';

import type { GetPortfolioApiV1SoftwareFactoryPortfolioGetParams } from '../models/getPortfolioApiV1SoftwareFactoryPortfolioGetParams';

import type { GetShippingReportApiV1SoftwareFactoryReportsShippingGetParams } from '../models/getShippingReportApiV1SoftwareFactoryReportsShippingGetParams';

import type { GetUndeployedWorkItemCommitsApiV1SoftwareFactoryWorkItemsUndeployedCommitsGetParams } from '../models/getUndeployedWorkItemCommitsApiV1SoftwareFactoryWorkItemsUndeployedCommitsGetParams';

import type { GetWorkItemFilterFacetsApiV1SoftwareFactoryWorkItemsFilterFacetsGetParams } from '../models/getWorkItemFilterFacetsApiV1SoftwareFactoryWorkItemsFilterFacetsGetParams';

import type { HTTPValidationError } from '../models/hTTPValidationError';

import type { InitializeFirstSprintRequest } from '../models/initializeFirstSprintRequest';

import type { LinkCommitsRequest } from '../models/linkCommitsRequest';

import type { ListAnnouncementsApiV1SoftwareFactoryAnnouncementsGetParams } from '../models/listAnnouncementsApiV1SoftwareFactoryAnnouncementsGetParams';

import type { ListChangelogEntriesApiV1SoftwareFactoryChangelogGetParams } from '../models/listChangelogEntriesApiV1SoftwareFactoryChangelogGetParams';

import type { ListDispatchQueueApiV1SoftwareFactoryWorkItemsDispatchQueueGetParams } from '../models/listDispatchQueueApiV1SoftwareFactoryWorkItemsDispatchQueueGetParams';

import type { ListDispatchableItemsApiV1SoftwareFactoryWorkItemsDispatchableGetParams } from '../models/listDispatchableItemsApiV1SoftwareFactoryWorkItemsDispatchableGetParams';

import type { ListExceptionFingerprintsApiV1SoftwareFactoryExceptionsFingerprintsGetParams } from '../models/listExceptionFingerprintsApiV1SoftwareFactoryExceptionsFingerprintsGetParams';

import type { ListInitiativeChildrenApiV1SoftwareFactoryInitiativesInitiativeIdChildrenGetParams } from '../models/listInitiativeChildrenApiV1SoftwareFactoryInitiativesInitiativeIdChildrenGetParams';

import type { ListInitiativesApiV1SoftwareFactoryInitiativesGetParams } from '../models/listInitiativesApiV1SoftwareFactoryInitiativesGetParams';

import type { ListMilestonesApiV1SoftwareFactoryMilestonesGetParams } from '../models/listMilestonesApiV1SoftwareFactoryMilestonesGetParams';

import type { ListModulesApiV1SoftwareFactoryModulesGetParams } from '../models/listModulesApiV1SoftwareFactoryModulesGetParams';

import type { ListMyAnnouncementsApiV1SoftwareFactoryAnnouncementsMeGetParams } from '../models/listMyAnnouncementsApiV1SoftwareFactoryAnnouncementsMeGetParams';

import type { ListSprintsApiV1SoftwareFactorySprintsGetParams } from '../models/listSprintsApiV1SoftwareFactorySprintsGetParams';

import type { ListUnreadChangelogApiV1SoftwareFactoryChangelogUnreadGetParams } from '../models/listUnreadChangelogApiV1SoftwareFactoryChangelogUnreadGetParams';

import type { ListWorkItemChildrenApiV1SoftwareFactoryWorkItemsItemIdChildrenGetParams } from '../models/listWorkItemChildrenApiV1SoftwareFactoryWorkItemsItemIdChildrenGetParams';

import type { ListWorkItemsApiV1SoftwareFactoryWorkItemsGetParams } from '../models/listWorkItemsApiV1SoftwareFactoryWorkItemsGetParams';

import type { MarkDeployedRequest } from '../models/markDeployedRequest';

import type { MarkDispatchedRequest } from '../models/markDispatchedRequest';

import type { MuteExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdMutePutBody } from '../models/muteExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdMutePutBody';

import type { RecordAnnouncementViewApiV1SoftwareFactoryAnnouncementsAnnouncementIdViewPostBody } from '../models/recordAnnouncementViewApiV1SoftwareFactoryAnnouncementsAnnouncementIdViewPostBody';

import type { ScheduleIntoSprintRequest } from '../models/scheduleIntoSprintRequest';

import type { SetAnnouncementInitiativesApiV1SoftwareFactoryAnnouncementsAnnouncementIdInitiativesPutBody } from '../models/setAnnouncementInitiativesApiV1SoftwareFactoryAnnouncementsAnnouncementIdInitiativesPutBody';

import type { SetAnnouncementWorkItemsApiV1SoftwareFactoryAnnouncementsAnnouncementIdWorkItemsPutBody } from '../models/setAnnouncementWorkItemsApiV1SoftwareFactoryAnnouncementsAnnouncementIdWorkItemsPutBody';

import type { SfChangelogTranslationUpsert } from '../models/sfChangelogTranslationUpsert';

import type { SfMilestoneWorkItemLink } from '../models/sfMilestoneWorkItemLink';

import type { SfModule } from '../models/sfModule';

import type { SfModuleCreate } from '../models/sfModuleCreate';

import type { SfModuleListResponse } from '../models/sfModuleListResponse';

import type { SfModuleOkResponse } from '../models/sfModuleOkResponse';

import type { SfModuleReorder } from '../models/sfModuleReorder';

import type { SfModuleUpdate } from '../models/sfModuleUpdate';

import type { SfSprintCreate } from '../models/sfSprintCreate';

import type { SfSprintUpdate } from '../models/sfSprintUpdate';

import type { SfUserAnnouncement } from '../models/sfUserAnnouncement';

import type { SfWorkItemAiSetupListResponse } from '../models/sfWorkItemAiSetupListResponse';

import type { SfWorkItemAiSetupsReplace } from '../models/sfWorkItemAiSetupsReplace';

import type { SfWorkItemBulkCustomerResponse } from '../models/sfWorkItemBulkCustomerResponse';

import type { SfWorkItemBulkCustomerSummaryResponse } from '../models/sfWorkItemBulkCustomerSummaryResponse';

import type { SfWorkItemBulkUpdateResponse } from '../models/sfWorkItemBulkUpdateResponse';

import type { SfWorkItemCycleListResponse } from '../models/sfWorkItemCycleListResponse';

import type { SfWorkItemDispatch } from '../models/sfWorkItemDispatch';

import type { SfWorkItemFilterFacets } from '../models/sfWorkItemFilterFacets';

import type { SoftwareFactoryDashboard } from '../models/softwareFactoryDashboard';

import type { SuggestWorkItemsForInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdAiSuggestWorkItemsPostBody } from '../models/suggestWorkItemsForInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdAiSuggestWorkItemsPostBody';

import type { TaskLinkedWorkItemListResponse } from '../models/taskLinkedWorkItemListResponse';

import type { UndeployedWorkItemCommitsResponse } from '../models/undeployedWorkItemCommitsResponse';

import type { UpdateAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdPutBody } from '../models/updateAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdPutBody';

import type { UpdateChangelogEntryApiV1SoftwareFactoryChangelogEntryIdPutBody } from '../models/updateChangelogEntryApiV1SoftwareFactoryChangelogEntryIdPutBody';

import type { UpdateExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdPutBody } from '../models/updateExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdPutBody';

import type { UpdateInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdPutBody } from '../models/updateInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdPutBody';

import type { UpdateMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdPutBody } from '../models/updateMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdPutBody';

import type { UpdateWorkItemApiV1SoftwareFactoryWorkItemsItemIdPutBody } from '../models/updateWorkItemApiV1SoftwareFactoryWorkItemsItemIdPutBody';

import type { UpdateWorkItemStatusApiV1SoftwareFactoryWorkItemsItemIdStatusPutBody } from '../models/updateWorkItemStatusApiV1SoftwareFactoryWorkItemsItemIdStatusPutBody';

import type { UpsertAnnouncementTranslationApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsLanguagePutBody } from '../models/upsertAnnouncementTranslationApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsLanguagePutBody';

import type { WorkItemBulkCustomerRequest } from '../models/workItemBulkCustomerRequest';

import type { WorkItemBulkUpdateRequest } from '../models/workItemBulkUpdateRequest';

import type { WorkItemChangelogEntryListResponse } from '../models/workItemChangelogEntryListResponse';

import { customInstance } from '../../../shared/api/axiosInstance';

/**
 * List registered software modules/capabilities with optional filters.
 * @summary List Modules
 */
export const listModulesApiV1SoftwareFactoryModulesGet = (
  params?: ListModulesApiV1SoftwareFactoryModulesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<SfModuleListResponse>({
    url: `/api/v1/software-factory/modules`,
    method: 'GET',
    params,
    signal
  });
};

export const getListModulesApiV1SoftwareFactoryModulesGetQueryKey = (
  params?: ListModulesApiV1SoftwareFactoryModulesGetParams
) => {
  return [
    `/api/v1/software-factory/modules`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListModulesApiV1SoftwareFactoryModulesGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listModulesApiV1SoftwareFactoryModulesGet>>,
  TError = HTTPValidationError
>(
  params?: ListModulesApiV1SoftwareFactoryModulesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listModulesApiV1SoftwareFactoryModulesGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListModulesApiV1SoftwareFactoryModulesGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listModulesApiV1SoftwareFactoryModulesGet>>
  > = ({ signal }) => listModulesApiV1SoftwareFactoryModulesGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listModulesApiV1SoftwareFactoryModulesGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListModulesApiV1SoftwareFactoryModulesGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listModulesApiV1SoftwareFactoryModulesGet>>
>;
export type ListModulesApiV1SoftwareFactoryModulesGetQueryError =
  HTTPValidationError;

export function useListModulesApiV1SoftwareFactoryModulesGet<
  TData = Awaited<ReturnType<typeof listModulesApiV1SoftwareFactoryModulesGet>>,
  TError = HTTPValidationError
>(
  params: undefined | ListModulesApiV1SoftwareFactoryModulesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listModulesApiV1SoftwareFactoryModulesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listModulesApiV1SoftwareFactoryModulesGet>>,
          TError,
          Awaited<ReturnType<typeof listModulesApiV1SoftwareFactoryModulesGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListModulesApiV1SoftwareFactoryModulesGet<
  TData = Awaited<ReturnType<typeof listModulesApiV1SoftwareFactoryModulesGet>>,
  TError = HTTPValidationError
>(
  params?: ListModulesApiV1SoftwareFactoryModulesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listModulesApiV1SoftwareFactoryModulesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listModulesApiV1SoftwareFactoryModulesGet>>,
          TError,
          Awaited<ReturnType<typeof listModulesApiV1SoftwareFactoryModulesGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListModulesApiV1SoftwareFactoryModulesGet<
  TData = Awaited<ReturnType<typeof listModulesApiV1SoftwareFactoryModulesGet>>,
  TError = HTTPValidationError
>(
  params?: ListModulesApiV1SoftwareFactoryModulesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listModulesApiV1SoftwareFactoryModulesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Modules
 */

export function useListModulesApiV1SoftwareFactoryModulesGet<
  TData = Awaited<ReturnType<typeof listModulesApiV1SoftwareFactoryModulesGet>>,
  TError = HTTPValidationError
>(
  params?: ListModulesApiV1SoftwareFactoryModulesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listModulesApiV1SoftwareFactoryModulesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListModulesApiV1SoftwareFactoryModulesGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new software module/capability in the registry.
 * @summary Create Module
 */
export const createModuleApiV1SoftwareFactoryModulesPost = (
  sfModuleCreate: SfModuleCreate,
  signal?: AbortSignal
) => {
  return customInstance<SfModule>({
    url: `/api/v1/software-factory/modules`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: sfModuleCreate,
    signal
  });
};

export const getCreateModuleApiV1SoftwareFactoryModulesPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createModuleApiV1SoftwareFactoryModulesPost>>,
    TError,
    { data: SfModuleCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createModuleApiV1SoftwareFactoryModulesPost>>,
  TError,
  { data: SfModuleCreate },
  TContext
> => {
  const mutationKey = ['createModuleApiV1SoftwareFactoryModulesPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createModuleApiV1SoftwareFactoryModulesPost>>,
    { data: SfModuleCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createModuleApiV1SoftwareFactoryModulesPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateModuleApiV1SoftwareFactoryModulesPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createModuleApiV1SoftwareFactoryModulesPost>>
  >;
export type CreateModuleApiV1SoftwareFactoryModulesPostMutationBody =
  SfModuleCreate;
export type CreateModuleApiV1SoftwareFactoryModulesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Module
 */
export const useCreateModuleApiV1SoftwareFactoryModulesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createModuleApiV1SoftwareFactoryModulesPost>>,
      TError,
      { data: SfModuleCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createModuleApiV1SoftwareFactoryModulesPost>>,
  TError,
  { data: SfModuleCreate },
  TContext
> => {
  const mutationOptions =
    getCreateModuleApiV1SoftwareFactoryModulesPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get a single module by ID.
 * @summary Get Module
 */
export const getModuleApiV1SoftwareFactoryModulesModuleIdGet = (
  moduleId: string,
  signal?: AbortSignal
) => {
  return customInstance<SfModule>({
    url: `/api/v1/software-factory/modules/${moduleId}`,
    method: 'GET',
    signal
  });
};

export const getGetModuleApiV1SoftwareFactoryModulesModuleIdGetQueryKey = (
  moduleId?: string
) => {
  return [`/api/v1/software-factory/modules/${moduleId}`] as const;
};

export const getGetModuleApiV1SoftwareFactoryModulesModuleIdGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getModuleApiV1SoftwareFactoryModulesModuleIdGet>
  >,
  TError = HTTPValidationError
>(
  moduleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getModuleApiV1SoftwareFactoryModulesModuleIdGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetModuleApiV1SoftwareFactoryModulesModuleIdGetQueryKey(moduleId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getModuleApiV1SoftwareFactoryModulesModuleIdGet>>
  > = ({ signal }) =>
    getModuleApiV1SoftwareFactoryModulesModuleIdGet(moduleId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!moduleId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getModuleApiV1SoftwareFactoryModulesModuleIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetModuleApiV1SoftwareFactoryModulesModuleIdGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getModuleApiV1SoftwareFactoryModulesModuleIdGet>>
  >;
export type GetModuleApiV1SoftwareFactoryModulesModuleIdGetQueryError =
  HTTPValidationError;

export function useGetModuleApiV1SoftwareFactoryModulesModuleIdGet<
  TData = Awaited<
    ReturnType<typeof getModuleApiV1SoftwareFactoryModulesModuleIdGet>
  >,
  TError = HTTPValidationError
>(
  moduleId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getModuleApiV1SoftwareFactoryModulesModuleIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getModuleApiV1SoftwareFactoryModulesModuleIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getModuleApiV1SoftwareFactoryModulesModuleIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetModuleApiV1SoftwareFactoryModulesModuleIdGet<
  TData = Awaited<
    ReturnType<typeof getModuleApiV1SoftwareFactoryModulesModuleIdGet>
  >,
  TError = HTTPValidationError
>(
  moduleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getModuleApiV1SoftwareFactoryModulesModuleIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getModuleApiV1SoftwareFactoryModulesModuleIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getModuleApiV1SoftwareFactoryModulesModuleIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetModuleApiV1SoftwareFactoryModulesModuleIdGet<
  TData = Awaited<
    ReturnType<typeof getModuleApiV1SoftwareFactoryModulesModuleIdGet>
  >,
  TError = HTTPValidationError
>(
  moduleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getModuleApiV1SoftwareFactoryModulesModuleIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Module
 */

export function useGetModuleApiV1SoftwareFactoryModulesModuleIdGet<
  TData = Awaited<
    ReturnType<typeof getModuleApiV1SoftwareFactoryModulesModuleIdGet>
  >,
  TError = HTTPValidationError
>(
  moduleId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getModuleApiV1SoftwareFactoryModulesModuleIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetModuleApiV1SoftwareFactoryModulesModuleIdGetQueryOptions(
      moduleId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update an existing module's properties.
 * @summary Update Module
 */
export const updateModuleApiV1SoftwareFactoryModulesModuleIdPut = (
  moduleId: string,
  sfModuleUpdate: SfModuleUpdate
) => {
  return customInstance<SfModule>({
    url: `/api/v1/software-factory/modules/${moduleId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: sfModuleUpdate
  });
};

export const getUpdateModuleApiV1SoftwareFactoryModulesModuleIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateModuleApiV1SoftwareFactoryModulesModuleIdPut>
      >,
      TError,
      { moduleId: string; data: SfModuleUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updateModuleApiV1SoftwareFactoryModulesModuleIdPut>
    >,
    TError,
    { moduleId: string; data: SfModuleUpdate },
    TContext
  > => {
    const mutationKey = ['updateModuleApiV1SoftwareFactoryModulesModuleIdPut'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updateModuleApiV1SoftwareFactoryModulesModuleIdPut>
      >,
      { moduleId: string; data: SfModuleUpdate }
    > = (props) => {
      const { moduleId, data } = props ?? {};

      return updateModuleApiV1SoftwareFactoryModulesModuleIdPut(moduleId, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateModuleApiV1SoftwareFactoryModulesModuleIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof updateModuleApiV1SoftwareFactoryModulesModuleIdPut>
    >
  >;
export type UpdateModuleApiV1SoftwareFactoryModulesModuleIdPutMutationBody =
  SfModuleUpdate;
export type UpdateModuleApiV1SoftwareFactoryModulesModuleIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Module
 */
export const useUpdateModuleApiV1SoftwareFactoryModulesModuleIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateModuleApiV1SoftwareFactoryModulesModuleIdPut>
      >,
      TError,
      { moduleId: string; data: SfModuleUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateModuleApiV1SoftwareFactoryModulesModuleIdPut>
  >,
  TError,
  { moduleId: string; data: SfModuleUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateModuleApiV1SoftwareFactoryModulesModuleIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete a module from the registry.
 * @summary Delete Module
 */
export const deleteModuleApiV1SoftwareFactoryModulesModuleIdDelete = (
  moduleId: string
) => {
  return customInstance<SfModuleOkResponse>({
    url: `/api/v1/software-factory/modules/${moduleId}`,
    method: 'DELETE'
  });
};

export const getDeleteModuleApiV1SoftwareFactoryModulesModuleIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteModuleApiV1SoftwareFactoryModulesModuleIdDelete>
      >,
      TError,
      { moduleId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof deleteModuleApiV1SoftwareFactoryModulesModuleIdDelete>
    >,
    TError,
    { moduleId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteModuleApiV1SoftwareFactoryModulesModuleIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof deleteModuleApiV1SoftwareFactoryModulesModuleIdDelete>
      >,
      { moduleId: string }
    > = (props) => {
      const { moduleId } = props ?? {};

      return deleteModuleApiV1SoftwareFactoryModulesModuleIdDelete(moduleId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteModuleApiV1SoftwareFactoryModulesModuleIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof deleteModuleApiV1SoftwareFactoryModulesModuleIdDelete>
    >
  >;

export type DeleteModuleApiV1SoftwareFactoryModulesModuleIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Module
 */
export const useDeleteModuleApiV1SoftwareFactoryModulesModuleIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteModuleApiV1SoftwareFactoryModulesModuleIdDelete>
      >,
      TError,
      { moduleId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof deleteModuleApiV1SoftwareFactoryModulesModuleIdDelete>
  >,
  TError,
  { moduleId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteModuleApiV1SoftwareFactoryModulesModuleIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Reorder modules by providing an ordered list of module IDs.
 * @summary Reorder Modules
 */
export const reorderModulesApiV1SoftwareFactoryModulesReorderPut = (
  sfModuleReorder: SfModuleReorder
) => {
  return customInstance<SfModuleOkResponse>({
    url: `/api/v1/software-factory/modules/reorder`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: sfModuleReorder
  });
};

export const getReorderModulesApiV1SoftwareFactoryModulesReorderPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof reorderModulesApiV1SoftwareFactoryModulesReorderPut>
      >,
      TError,
      { data: SfModuleReorder },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof reorderModulesApiV1SoftwareFactoryModulesReorderPut>
    >,
    TError,
    { data: SfModuleReorder },
    TContext
  > => {
    const mutationKey = ['reorderModulesApiV1SoftwareFactoryModulesReorderPut'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof reorderModulesApiV1SoftwareFactoryModulesReorderPut>
      >,
      { data: SfModuleReorder }
    > = (props) => {
      const { data } = props ?? {};

      return reorderModulesApiV1SoftwareFactoryModulesReorderPut(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ReorderModulesApiV1SoftwareFactoryModulesReorderPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof reorderModulesApiV1SoftwareFactoryModulesReorderPut>
    >
  >;
export type ReorderModulesApiV1SoftwareFactoryModulesReorderPutMutationBody =
  SfModuleReorder;
export type ReorderModulesApiV1SoftwareFactoryModulesReorderPutMutationError =
  HTTPValidationError;

/**
 * @summary Reorder Modules
 */
export const useReorderModulesApiV1SoftwareFactoryModulesReorderPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof reorderModulesApiV1SoftwareFactoryModulesReorderPut>
      >,
      TError,
      { data: SfModuleReorder },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof reorderModulesApiV1SoftwareFactoryModulesReorderPut>
  >,
  TError,
  { data: SfModuleReorder },
  TContext
> => {
  const mutationOptions =
    getReorderModulesApiV1SoftwareFactoryModulesReorderPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * List work items with optional filters for type, status, priority, etc.
 * @summary List Work Items
 */
export const listWorkItemsApiV1SoftwareFactoryWorkItemsGet = (
  params?: ListWorkItemsApiV1SoftwareFactoryWorkItemsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/software-factory/work-items`,
    method: 'GET',
    params,
    signal
  });
};

export const getListWorkItemsApiV1SoftwareFactoryWorkItemsGetQueryKey = (
  params?: ListWorkItemsApiV1SoftwareFactoryWorkItemsGetParams
) => {
  return [
    `/api/v1/software-factory/work-items`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListWorkItemsApiV1SoftwareFactoryWorkItemsGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listWorkItemsApiV1SoftwareFactoryWorkItemsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListWorkItemsApiV1SoftwareFactoryWorkItemsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listWorkItemsApiV1SoftwareFactoryWorkItemsGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListWorkItemsApiV1SoftwareFactoryWorkItemsGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listWorkItemsApiV1SoftwareFactoryWorkItemsGet>>
  > = ({ signal }) =>
    listWorkItemsApiV1SoftwareFactoryWorkItemsGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listWorkItemsApiV1SoftwareFactoryWorkItemsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListWorkItemsApiV1SoftwareFactoryWorkItemsGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listWorkItemsApiV1SoftwareFactoryWorkItemsGet>>
  >;
export type ListWorkItemsApiV1SoftwareFactoryWorkItemsGetQueryError =
  HTTPValidationError;

export function useListWorkItemsApiV1SoftwareFactoryWorkItemsGet<
  TData = Awaited<
    ReturnType<typeof listWorkItemsApiV1SoftwareFactoryWorkItemsGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListWorkItemsApiV1SoftwareFactoryWorkItemsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listWorkItemsApiV1SoftwareFactoryWorkItemsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listWorkItemsApiV1SoftwareFactoryWorkItemsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listWorkItemsApiV1SoftwareFactoryWorkItemsGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListWorkItemsApiV1SoftwareFactoryWorkItemsGet<
  TData = Awaited<
    ReturnType<typeof listWorkItemsApiV1SoftwareFactoryWorkItemsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListWorkItemsApiV1SoftwareFactoryWorkItemsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listWorkItemsApiV1SoftwareFactoryWorkItemsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listWorkItemsApiV1SoftwareFactoryWorkItemsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listWorkItemsApiV1SoftwareFactoryWorkItemsGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListWorkItemsApiV1SoftwareFactoryWorkItemsGet<
  TData = Awaited<
    ReturnType<typeof listWorkItemsApiV1SoftwareFactoryWorkItemsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListWorkItemsApiV1SoftwareFactoryWorkItemsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listWorkItemsApiV1SoftwareFactoryWorkItemsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Work Items
 */

export function useListWorkItemsApiV1SoftwareFactoryWorkItemsGet<
  TData = Awaited<
    ReturnType<typeof listWorkItemsApiV1SoftwareFactoryWorkItemsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListWorkItemsApiV1SoftwareFactoryWorkItemsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listWorkItemsApiV1SoftwareFactoryWorkItemsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListWorkItemsApiV1SoftwareFactoryWorkItemsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new work item (idea, feature, bug, tech_debt, enhancement, test, data, site_reliability, or integration).
 * @summary Create Work Item
 */
export const createWorkItemApiV1SoftwareFactoryWorkItemsPost = (
  createWorkItemApiV1SoftwareFactoryWorkItemsPostBody: CreateWorkItemApiV1SoftwareFactoryWorkItemsPostBody,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/software-factory/work-items`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createWorkItemApiV1SoftwareFactoryWorkItemsPostBody,
    signal
  });
};

export const getCreateWorkItemApiV1SoftwareFactoryWorkItemsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createWorkItemApiV1SoftwareFactoryWorkItemsPost>
      >,
      TError,
      { data: CreateWorkItemApiV1SoftwareFactoryWorkItemsPostBody },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof createWorkItemApiV1SoftwareFactoryWorkItemsPost>>,
    TError,
    { data: CreateWorkItemApiV1SoftwareFactoryWorkItemsPostBody },
    TContext
  > => {
    const mutationKey = ['createWorkItemApiV1SoftwareFactoryWorkItemsPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createWorkItemApiV1SoftwareFactoryWorkItemsPost>
      >,
      { data: CreateWorkItemApiV1SoftwareFactoryWorkItemsPostBody }
    > = (props) => {
      const { data } = props ?? {};

      return createWorkItemApiV1SoftwareFactoryWorkItemsPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateWorkItemApiV1SoftwareFactoryWorkItemsPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createWorkItemApiV1SoftwareFactoryWorkItemsPost>>
  >;
export type CreateWorkItemApiV1SoftwareFactoryWorkItemsPostMutationBody =
  CreateWorkItemApiV1SoftwareFactoryWorkItemsPostBody;
export type CreateWorkItemApiV1SoftwareFactoryWorkItemsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Work Item
 */
export const useCreateWorkItemApiV1SoftwareFactoryWorkItemsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createWorkItemApiV1SoftwareFactoryWorkItemsPost>
      >,
      TError,
      { data: CreateWorkItemApiV1SoftwareFactoryWorkItemsPostBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createWorkItemApiV1SoftwareFactoryWorkItemsPost>>,
  TError,
  { data: CreateWorkItemApiV1SoftwareFactoryWorkItemsPostBody },
  TContext
> => {
  const mutationOptions =
    getCreateWorkItemApiV1SoftwareFactoryWorkItemsPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * List work items a human or agent can dispatch right now.

An item is returned only if ALL hold:
  - status = 'planned'
  - no agent assigned (agent_id IS NULL)
  - not recurring (recurring items are templates, never dispatchable)
  - NOT blocked: every predecessor is 'shipped'. A predecessor is any item
    listing this one in its next_work_items.
  - NOT deploy_blocked: every item in deploy_blocked_by has deployed_at set

Post-dated items ARE returned: a future start_date withholds an item from
AUTO-dispatch only, and dispatching one by hand is a deliberate override.

**Ordering: most dispatchable first, never newest first.** The tech-debt-clamped
effective priority (``GREATEST(priority, 3)`` for ``type='tech_debt'``) ascending,
with items carrying NO priority last; ties broken by board ``position``, then by
``created_at`` ASCENDING (oldest first), then by ``id`` — a total order, so
``offset`` pages through the list without skipping or repeating a row. The
``limit`` therefore selects the TOP of the queue rather than its newest slice: an
old P0 is on page 1. This is the same within-lane order /work-items/dispatch-queue
applies, WITHOUT that endpoint's meta-lane trickle, which is a fairness device for
the auto-dispatch lane alone.

This is the human/agent list. The PanClaude poller uses
/work-items/dispatch-queue instead, which drops the assignee filter and adds
autonomy_level, in-flight and start_date gates.

Omit assignee_email to get all items. Pass comma-separated emails
and/or "null" to filter (e.g. "a@b.com,null" = assigned to a@b.com or unassigned).
Pass autonomy_level repeatedly to restrict to specific autonomy tiers
(e.g. ?autonomy_level=autonomous&autonomy_level=auto_dispatch to batch-dispatch dispatchable items).
 * @summary List Dispatchable Items
 */
export const listDispatchableItemsApiV1SoftwareFactoryWorkItemsDispatchableGet =
  (
    params?: ListDispatchableItemsApiV1SoftwareFactoryWorkItemsDispatchableGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/work-items/dispatchable`,
      method: 'GET',
      params,
      signal
    });
  };

export const getListDispatchableItemsApiV1SoftwareFactoryWorkItemsDispatchableGetQueryKey =
  (
    params?: ListDispatchableItemsApiV1SoftwareFactoryWorkItemsDispatchableGetParams
  ) => {
    return [
      `/api/v1/software-factory/work-items/dispatchable`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListDispatchableItemsApiV1SoftwareFactoryWorkItemsDispatchableGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listDispatchableItemsApiV1SoftwareFactoryWorkItemsDispatchableGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: ListDispatchableItemsApiV1SoftwareFactoryWorkItemsDispatchableGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listDispatchableItemsApiV1SoftwareFactoryWorkItemsDispatchableGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListDispatchableItemsApiV1SoftwareFactoryWorkItemsDispatchableGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listDispatchableItemsApiV1SoftwareFactoryWorkItemsDispatchableGet
        >
      >
    > = ({ signal }) =>
      listDispatchableItemsApiV1SoftwareFactoryWorkItemsDispatchableGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listDispatchableItemsApiV1SoftwareFactoryWorkItemsDispatchableGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListDispatchableItemsApiV1SoftwareFactoryWorkItemsDispatchableGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listDispatchableItemsApiV1SoftwareFactoryWorkItemsDispatchableGet
      >
    >
  >;
export type ListDispatchableItemsApiV1SoftwareFactoryWorkItemsDispatchableGetQueryError =
  HTTPValidationError;

export function useListDispatchableItemsApiV1SoftwareFactoryWorkItemsDispatchableGet<
  TData = Awaited<
    ReturnType<
      typeof listDispatchableItemsApiV1SoftwareFactoryWorkItemsDispatchableGet
    >
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | ListDispatchableItemsApiV1SoftwareFactoryWorkItemsDispatchableGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDispatchableItemsApiV1SoftwareFactoryWorkItemsDispatchableGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listDispatchableItemsApiV1SoftwareFactoryWorkItemsDispatchableGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listDispatchableItemsApiV1SoftwareFactoryWorkItemsDispatchableGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListDispatchableItemsApiV1SoftwareFactoryWorkItemsDispatchableGet<
  TData = Awaited<
    ReturnType<
      typeof listDispatchableItemsApiV1SoftwareFactoryWorkItemsDispatchableGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListDispatchableItemsApiV1SoftwareFactoryWorkItemsDispatchableGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDispatchableItemsApiV1SoftwareFactoryWorkItemsDispatchableGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listDispatchableItemsApiV1SoftwareFactoryWorkItemsDispatchableGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listDispatchableItemsApiV1SoftwareFactoryWorkItemsDispatchableGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListDispatchableItemsApiV1SoftwareFactoryWorkItemsDispatchableGet<
  TData = Awaited<
    ReturnType<
      typeof listDispatchableItemsApiV1SoftwareFactoryWorkItemsDispatchableGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListDispatchableItemsApiV1SoftwareFactoryWorkItemsDispatchableGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDispatchableItemsApiV1SoftwareFactoryWorkItemsDispatchableGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Dispatchable Items
 */

export function useListDispatchableItemsApiV1SoftwareFactoryWorkItemsDispatchableGet<
  TData = Awaited<
    ReturnType<
      typeof listDispatchableItemsApiV1SoftwareFactoryWorkItemsDispatchableGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListDispatchableItemsApiV1SoftwareFactoryWorkItemsDispatchableGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDispatchableItemsApiV1SoftwareFactoryWorkItemsDispatchableGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListDispatchableItemsApiV1SoftwareFactoryWorkItemsDispatchableGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List work items eligible for PanClaude auto-dispatch.

Returns only items that pass EVERY dispatch gate (see
``WorkItemRepository.list_dispatch_queue``):

- **dispatchable status** (``_dispatchable_status``): ``status = 'planned'``. A
  terminal (``shipped``, ``wont_do``) or pre-planned (``new``, ``triaged``) item
  is never queued, and never claimable — re-dispatching one requires an explicit
  transition back to ``planned``.
- **not in-flight** (``_not_in_flight``): never dispatched, OR its slot and
  worktree are both empty — so a reset/re-opened item with a stale
  ``dispatched_at`` is still eligible.
- **not blocked** (``_not_blocked``): has no predecessor (an item listing
  this one in its ``next_work_items``) whose status is not yet ``shipped`` —
  so a chained item stays hidden until ALL its predecessors ship (fan-in).
- **not deploy-blocked** (``_not_deploy_blocked``): every id in its
  ``deploy_blocked_by`` is already live in production (``deployed_at`` stamped) —
  so an expand/contract pair lands in separate prod deploys.
- **not post-dated** (``_not_post_dated``): its ``start_date`` is null or has
  already arrived (``<= dispatch_today()``) — an item scheduled to start in the
  future is withheld until its start date, even when planned + autonomous.

Those five are the whole gate set, and **no item is ever withheld on the grounds
of its type, module or size**. Each gate asks about the ITEM's own readiness and
is released by something changing on it. *Capacity* — how many things may run at
once — is the polling client's question, answerable only from CPU, memory, live
slot count, account quota and merge-queue depth, none of which this service can
see; *composition* — given we can run N, which N — is answered here by ORDERING,
which withholds nothing. Two WIP throttles (a meta-lane cap and an L/XL
serialization) used to sit in this list and were retired on 2026-08-28, after they
returned an empty array for hours over 29 planned, autonomous, dependency-clear
items.

**Ordering.** Within a lane, the tech-debt-clamped effective priority
(``GREATEST(priority, 3)`` for ``type='tech_debt'``), then board position, then
age. Across lanes, a *reserved trickle*: when meta-lane work (tech debt anywhere,
or anything under the ``dev-tooling-workflow`` module) is queued, its
highest-priority item takes every fourth position at the head. It is a floor, not
a ceiling — it can only move a row forward, never hold one back — and it exists
because the P3 clamp would otherwise let a replenishing stream of P2 product work
starve debt indefinitely.

Defaults: ``status=planned`` and ``autonomy_level in (autonomous,
auto_dispatch)``. The ``status`` filter can only NARROW within the dispatchable
allow-list — passing e.g. ``status=shipped`` returns nothing rather than
surfacing a row the claim would refuse. All gates are also enforced by
``mark-dispatched`` so queue visibility and the atomic claim never diverge. The
poller queries this endpoint every 30-60s and claims candidates via POST
.../mark-dispatched.

**The response also reports what was WITHHELD**, so an empty queue is not
ambiguous:

- ``withheld`` — how many candidates (rows matching this request's status /
  autonomy / sharing scope) failed at least one gate. ``{"items": [], "total": 0,
  "withheld": 0}`` means the tenant genuinely has nothing planned;
  ``"withheld": 29`` means 29 items are being held back and the poller should say
  so rather than render "No work". This is what the endpoint could not express on
  2026-08-28, when a rail read "No work" for hours over 29 gated items.
- ``withheld_by_cause`` — present only with ``withheld_breakdown=true``: the same
  population broken down per gate — ``in_flight``, ``blocked``,
  ``deploy_blocked``, ``post_dated``. Counters OVERLAP (an item can be blocked
  *and* post-dated) so they need not sum to ``withheld``; each answers "how many
  would this gate alone hold back".

Both are derived from the same predicate objects the filter above applies
(``DISPATCH_GATES``), in ONE extra aggregate statement, so the summary cannot
describe a different set than the queue actually filtered on. "Candidate" means a
row this request asked about — matching its ``status`` / ``autonomy_level`` /
sharing scope — so a shipped, supervised or recurring row is never reported as
withheld; it was never in the question.
 * @summary List Dispatch Queue
 */
export const listDispatchQueueApiV1SoftwareFactoryWorkItemsDispatchQueueGet = (
  params?: ListDispatchQueueApiV1SoftwareFactoryWorkItemsDispatchQueueGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/software-factory/work-items/dispatch-queue`,
    method: 'GET',
    params,
    signal
  });
};

export const getListDispatchQueueApiV1SoftwareFactoryWorkItemsDispatchQueueGetQueryKey =
  (
    params?: ListDispatchQueueApiV1SoftwareFactoryWorkItemsDispatchQueueGetParams
  ) => {
    return [
      `/api/v1/software-factory/work-items/dispatch-queue`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListDispatchQueueApiV1SoftwareFactoryWorkItemsDispatchQueueGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listDispatchQueueApiV1SoftwareFactoryWorkItemsDispatchQueueGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: ListDispatchQueueApiV1SoftwareFactoryWorkItemsDispatchQueueGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listDispatchQueueApiV1SoftwareFactoryWorkItemsDispatchQueueGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListDispatchQueueApiV1SoftwareFactoryWorkItemsDispatchQueueGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listDispatchQueueApiV1SoftwareFactoryWorkItemsDispatchQueueGet
        >
      >
    > = ({ signal }) =>
      listDispatchQueueApiV1SoftwareFactoryWorkItemsDispatchQueueGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listDispatchQueueApiV1SoftwareFactoryWorkItemsDispatchQueueGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListDispatchQueueApiV1SoftwareFactoryWorkItemsDispatchQueueGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listDispatchQueueApiV1SoftwareFactoryWorkItemsDispatchQueueGet
      >
    >
  >;
export type ListDispatchQueueApiV1SoftwareFactoryWorkItemsDispatchQueueGetQueryError =
  HTTPValidationError;

export function useListDispatchQueueApiV1SoftwareFactoryWorkItemsDispatchQueueGet<
  TData = Awaited<
    ReturnType<
      typeof listDispatchQueueApiV1SoftwareFactoryWorkItemsDispatchQueueGet
    >
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | ListDispatchQueueApiV1SoftwareFactoryWorkItemsDispatchQueueGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDispatchQueueApiV1SoftwareFactoryWorkItemsDispatchQueueGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listDispatchQueueApiV1SoftwareFactoryWorkItemsDispatchQueueGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listDispatchQueueApiV1SoftwareFactoryWorkItemsDispatchQueueGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListDispatchQueueApiV1SoftwareFactoryWorkItemsDispatchQueueGet<
  TData = Awaited<
    ReturnType<
      typeof listDispatchQueueApiV1SoftwareFactoryWorkItemsDispatchQueueGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListDispatchQueueApiV1SoftwareFactoryWorkItemsDispatchQueueGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDispatchQueueApiV1SoftwareFactoryWorkItemsDispatchQueueGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listDispatchQueueApiV1SoftwareFactoryWorkItemsDispatchQueueGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listDispatchQueueApiV1SoftwareFactoryWorkItemsDispatchQueueGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListDispatchQueueApiV1SoftwareFactoryWorkItemsDispatchQueueGet<
  TData = Awaited<
    ReturnType<
      typeof listDispatchQueueApiV1SoftwareFactoryWorkItemsDispatchQueueGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListDispatchQueueApiV1SoftwareFactoryWorkItemsDispatchQueueGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDispatchQueueApiV1SoftwareFactoryWorkItemsDispatchQueueGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Dispatch Queue
 */

export function useListDispatchQueueApiV1SoftwareFactoryWorkItemsDispatchQueueGet<
  TData = Awaited<
    ReturnType<
      typeof listDispatchQueueApiV1SoftwareFactoryWorkItemsDispatchQueueGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListDispatchQueueApiV1SoftwareFactoryWorkItemsDispatchQueueGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listDispatchQueueApiV1SoftwareFactoryWorkItemsDispatchQueueGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListDispatchQueueApiV1SoftwareFactoryWorkItemsDispatchQueueGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Shipped + not-yet-deployed work items with their linked commit SHAs (deploy barrier).

The read side of the CI **reachability backfill**: the deploy recorder fetches this
set and stamps ``deployed_at`` on every WI whose *every* linked commit is an ancestor
of the just-deployed SHA (``git merge-base --is-ancestor``). Reachability is immune to
the re-baselines / force-pushes / pre-config gaps that permanently orphan the
commit-*range* map, so this is what re-covers historic orphans on the next deploy.

Set-based, tenant-scoped, bounded to 500; only WIs with linked commits appear (a WI
with none cannot be proven reachable and never raises the stamping-gap alert), and
only those belonging to the caller's ``repository`` — Software Factory tracks work
for several repos and another repo's SHAs do not resolve in this recorder's history.
Omitting ``repository`` serves the configured default repo, i.e. exactly the
pre-multi-repo behaviour.

Auth: an API key carrying ``software_factory:write`` — the scope the CI deploy key
holds, so no new secret — and ONLY that. It used to admit any JWT as well, on the
stated grounds that the sibling ``mark-deployed`` write endpoint did; that endpoint
stopped doing so in WI 7632207d, and leaving the READ open would have kept the same
hole one route over. `sf_work_items` backs an enforced sharing type, and this reply
is a tenant-wide set of ids and commit SHAs assembled with no ReBAC scope at all, so
under `owner_and_shared` / `team` any authenticated member could enumerate work
items their own list route filters out. Narrowing costs the recorder nothing: the
scope check below already applied to every API-key caller, and no frontend or MCP
consumer exists. The
recorder does not trust the SHAs as safe git refs — it re-validates each is a literal
40-hex id before use (write-time validation in commit_service blocks new bad rows).
See .github/workflows/deploy.yml → "Record deployed work items".
 * @summary Get Undeployed Work Item Commits
 */
export const getUndeployedWorkItemCommitsApiV1SoftwareFactoryWorkItemsUndeployedCommitsGet =
  (
    params?: GetUndeployedWorkItemCommitsApiV1SoftwareFactoryWorkItemsUndeployedCommitsGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<UndeployedWorkItemCommitsResponse>({
      url: `/api/v1/software-factory/work-items/undeployed-commits`,
      method: 'GET',
      params,
      signal
    });
  };

export const getGetUndeployedWorkItemCommitsApiV1SoftwareFactoryWorkItemsUndeployedCommitsGetQueryKey =
  (
    params?: GetUndeployedWorkItemCommitsApiV1SoftwareFactoryWorkItemsUndeployedCommitsGetParams
  ) => {
    return [
      `/api/v1/software-factory/work-items/undeployed-commits`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetUndeployedWorkItemCommitsApiV1SoftwareFactoryWorkItemsUndeployedCommitsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getUndeployedWorkItemCommitsApiV1SoftwareFactoryWorkItemsUndeployedCommitsGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: GetUndeployedWorkItemCommitsApiV1SoftwareFactoryWorkItemsUndeployedCommitsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getUndeployedWorkItemCommitsApiV1SoftwareFactoryWorkItemsUndeployedCommitsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetUndeployedWorkItemCommitsApiV1SoftwareFactoryWorkItemsUndeployedCommitsGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getUndeployedWorkItemCommitsApiV1SoftwareFactoryWorkItemsUndeployedCommitsGet
        >
      >
    > = ({ signal }) =>
      getUndeployedWorkItemCommitsApiV1SoftwareFactoryWorkItemsUndeployedCommitsGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getUndeployedWorkItemCommitsApiV1SoftwareFactoryWorkItemsUndeployedCommitsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetUndeployedWorkItemCommitsApiV1SoftwareFactoryWorkItemsUndeployedCommitsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getUndeployedWorkItemCommitsApiV1SoftwareFactoryWorkItemsUndeployedCommitsGet
      >
    >
  >;
export type GetUndeployedWorkItemCommitsApiV1SoftwareFactoryWorkItemsUndeployedCommitsGetQueryError =
  HTTPValidationError;

export function useGetUndeployedWorkItemCommitsApiV1SoftwareFactoryWorkItemsUndeployedCommitsGet<
  TData = Awaited<
    ReturnType<
      typeof getUndeployedWorkItemCommitsApiV1SoftwareFactoryWorkItemsUndeployedCommitsGet
    >
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | GetUndeployedWorkItemCommitsApiV1SoftwareFactoryWorkItemsUndeployedCommitsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getUndeployedWorkItemCommitsApiV1SoftwareFactoryWorkItemsUndeployedCommitsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getUndeployedWorkItemCommitsApiV1SoftwareFactoryWorkItemsUndeployedCommitsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getUndeployedWorkItemCommitsApiV1SoftwareFactoryWorkItemsUndeployedCommitsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUndeployedWorkItemCommitsApiV1SoftwareFactoryWorkItemsUndeployedCommitsGet<
  TData = Awaited<
    ReturnType<
      typeof getUndeployedWorkItemCommitsApiV1SoftwareFactoryWorkItemsUndeployedCommitsGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: GetUndeployedWorkItemCommitsApiV1SoftwareFactoryWorkItemsUndeployedCommitsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getUndeployedWorkItemCommitsApiV1SoftwareFactoryWorkItemsUndeployedCommitsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getUndeployedWorkItemCommitsApiV1SoftwareFactoryWorkItemsUndeployedCommitsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getUndeployedWorkItemCommitsApiV1SoftwareFactoryWorkItemsUndeployedCommitsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUndeployedWorkItemCommitsApiV1SoftwareFactoryWorkItemsUndeployedCommitsGet<
  TData = Awaited<
    ReturnType<
      typeof getUndeployedWorkItemCommitsApiV1SoftwareFactoryWorkItemsUndeployedCommitsGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: GetUndeployedWorkItemCommitsApiV1SoftwareFactoryWorkItemsUndeployedCommitsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getUndeployedWorkItemCommitsApiV1SoftwareFactoryWorkItemsUndeployedCommitsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Undeployed Work Item Commits
 */

export function useGetUndeployedWorkItemCommitsApiV1SoftwareFactoryWorkItemsUndeployedCommitsGet<
  TData = Awaited<
    ReturnType<
      typeof getUndeployedWorkItemCommitsApiV1SoftwareFactoryWorkItemsUndeployedCommitsGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: GetUndeployedWorkItemCommitsApiV1SoftwareFactoryWorkItemsUndeployedCommitsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getUndeployedWorkItemCommitsApiV1SoftwareFactoryWorkItemsUndeployedCommitsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetUndeployedWorkItemCommitsApiV1SoftwareFactoryWorkItemsUndeployedCommitsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Candidate values for the work-items list's entity-FK filters, with counts.

The Shape-A half of ``docs/design-system/ui-list-pages.md`` § Filter Option Sources:
a filter on a foreign key offers the entities actually IN USE on this list, not the
tenant's whole entity universe, so most choices stop yielding zero rows.

Keyed by the LIST QUERY PARAMETER each facet drives (``module_id``,
``initiative_id``, ``assignee_user_id``, ``customer_organization_id``) so a page
wires a facet to a filter by name.

Two properties worth knowing before you consume it:

* It is computed over the list's **base scope** — tenant + the caller's accessible
  work items — and is NOT re-narrowed by the sibling filters currently applied, so
  the option set does not jitter while a query is composed.
* A value can be ABSENT from it and still be selected (the last link was removed, a
  narrower viewer opened a shared URL). The client keeps the selected value in the
  candidate list regardless — a filter that is active-but-blank misreads as
  inactive.
 * @summary Get Work Item Filter Facets
 */
export const getWorkItemFilterFacetsApiV1SoftwareFactoryWorkItemsFilterFacetsGet =
  (
    params?: GetWorkItemFilterFacetsApiV1SoftwareFactoryWorkItemsFilterFacetsGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<SfWorkItemFilterFacets>({
      url: `/api/v1/software-factory/work-items/filter-facets`,
      method: 'GET',
      params,
      signal
    });
  };

export const getGetWorkItemFilterFacetsApiV1SoftwareFactoryWorkItemsFilterFacetsGetQueryKey =
  (
    params?: GetWorkItemFilterFacetsApiV1SoftwareFactoryWorkItemsFilterFacetsGetParams
  ) => {
    return [
      `/api/v1/software-factory/work-items/filter-facets`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetWorkItemFilterFacetsApiV1SoftwareFactoryWorkItemsFilterFacetsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getWorkItemFilterFacetsApiV1SoftwareFactoryWorkItemsFilterFacetsGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: GetWorkItemFilterFacetsApiV1SoftwareFactoryWorkItemsFilterFacetsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getWorkItemFilterFacetsApiV1SoftwareFactoryWorkItemsFilterFacetsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetWorkItemFilterFacetsApiV1SoftwareFactoryWorkItemsFilterFacetsGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getWorkItemFilterFacetsApiV1SoftwareFactoryWorkItemsFilterFacetsGet
        >
      >
    > = ({ signal }) =>
      getWorkItemFilterFacetsApiV1SoftwareFactoryWorkItemsFilterFacetsGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getWorkItemFilterFacetsApiV1SoftwareFactoryWorkItemsFilterFacetsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetWorkItemFilterFacetsApiV1SoftwareFactoryWorkItemsFilterFacetsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getWorkItemFilterFacetsApiV1SoftwareFactoryWorkItemsFilterFacetsGet
      >
    >
  >;
export type GetWorkItemFilterFacetsApiV1SoftwareFactoryWorkItemsFilterFacetsGetQueryError =
  HTTPValidationError;

export function useGetWorkItemFilterFacetsApiV1SoftwareFactoryWorkItemsFilterFacetsGet<
  TData = Awaited<
    ReturnType<
      typeof getWorkItemFilterFacetsApiV1SoftwareFactoryWorkItemsFilterFacetsGet
    >
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | GetWorkItemFilterFacetsApiV1SoftwareFactoryWorkItemsFilterFacetsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getWorkItemFilterFacetsApiV1SoftwareFactoryWorkItemsFilterFacetsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getWorkItemFilterFacetsApiV1SoftwareFactoryWorkItemsFilterFacetsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getWorkItemFilterFacetsApiV1SoftwareFactoryWorkItemsFilterFacetsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetWorkItemFilterFacetsApiV1SoftwareFactoryWorkItemsFilterFacetsGet<
  TData = Awaited<
    ReturnType<
      typeof getWorkItemFilterFacetsApiV1SoftwareFactoryWorkItemsFilterFacetsGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: GetWorkItemFilterFacetsApiV1SoftwareFactoryWorkItemsFilterFacetsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getWorkItemFilterFacetsApiV1SoftwareFactoryWorkItemsFilterFacetsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getWorkItemFilterFacetsApiV1SoftwareFactoryWorkItemsFilterFacetsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getWorkItemFilterFacetsApiV1SoftwareFactoryWorkItemsFilterFacetsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetWorkItemFilterFacetsApiV1SoftwareFactoryWorkItemsFilterFacetsGet<
  TData = Awaited<
    ReturnType<
      typeof getWorkItemFilterFacetsApiV1SoftwareFactoryWorkItemsFilterFacetsGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: GetWorkItemFilterFacetsApiV1SoftwareFactoryWorkItemsFilterFacetsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getWorkItemFilterFacetsApiV1SoftwareFactoryWorkItemsFilterFacetsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Work Item Filter Facets
 */

export function useGetWorkItemFilterFacetsApiV1SoftwareFactoryWorkItemsFilterFacetsGet<
  TData = Awaited<
    ReturnType<
      typeof getWorkItemFilterFacetsApiV1SoftwareFactoryWorkItemsFilterFacetsGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: GetWorkItemFilterFacetsApiV1SoftwareFactoryWorkItemsFilterFacetsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getWorkItemFilterFacetsApiV1SoftwareFactoryWorkItemsFilterFacetsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetWorkItemFilterFacetsApiV1SoftwareFactoryWorkItemsFilterFacetsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get a single work item by ID.
 * @summary Get Work Item
 */
export const getWorkItemApiV1SoftwareFactoryWorkItemsItemIdGet = (
  itemId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/software-factory/work-items/${itemId}`,
    method: 'GET',
    signal
  });
};

export const getGetWorkItemApiV1SoftwareFactoryWorkItemsItemIdGetQueryKey = (
  itemId?: string
) => {
  return [`/api/v1/software-factory/work-items/${itemId}`] as const;
};

export const getGetWorkItemApiV1SoftwareFactoryWorkItemsItemIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getWorkItemApiV1SoftwareFactoryWorkItemsItemIdGet>
    >,
    TError = HTTPValidationError
  >(
    itemId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<typeof getWorkItemApiV1SoftwareFactoryWorkItemsItemIdGet>
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetWorkItemApiV1SoftwareFactoryWorkItemsItemIdGetQueryKey(itemId);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getWorkItemApiV1SoftwareFactoryWorkItemsItemIdGet>
      >
    > = ({ signal }) =>
      getWorkItemApiV1SoftwareFactoryWorkItemsItemIdGet(itemId, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!itemId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getWorkItemApiV1SoftwareFactoryWorkItemsItemIdGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetWorkItemApiV1SoftwareFactoryWorkItemsItemIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getWorkItemApiV1SoftwareFactoryWorkItemsItemIdGet>
    >
  >;
export type GetWorkItemApiV1SoftwareFactoryWorkItemsItemIdGetQueryError =
  HTTPValidationError;

export function useGetWorkItemApiV1SoftwareFactoryWorkItemsItemIdGet<
  TData = Awaited<
    ReturnType<typeof getWorkItemApiV1SoftwareFactoryWorkItemsItemIdGet>
  >,
  TError = HTTPValidationError
>(
  itemId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getWorkItemApiV1SoftwareFactoryWorkItemsItemIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getWorkItemApiV1SoftwareFactoryWorkItemsItemIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getWorkItemApiV1SoftwareFactoryWorkItemsItemIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetWorkItemApiV1SoftwareFactoryWorkItemsItemIdGet<
  TData = Awaited<
    ReturnType<typeof getWorkItemApiV1SoftwareFactoryWorkItemsItemIdGet>
  >,
  TError = HTTPValidationError
>(
  itemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getWorkItemApiV1SoftwareFactoryWorkItemsItemIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getWorkItemApiV1SoftwareFactoryWorkItemsItemIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getWorkItemApiV1SoftwareFactoryWorkItemsItemIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetWorkItemApiV1SoftwareFactoryWorkItemsItemIdGet<
  TData = Awaited<
    ReturnType<typeof getWorkItemApiV1SoftwareFactoryWorkItemsItemIdGet>
  >,
  TError = HTTPValidationError
>(
  itemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getWorkItemApiV1SoftwareFactoryWorkItemsItemIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Work Item
 */

export function useGetWorkItemApiV1SoftwareFactoryWorkItemsItemIdGet<
  TData = Awaited<
    ReturnType<typeof getWorkItemApiV1SoftwareFactoryWorkItemsItemIdGet>
  >,
  TError = HTTPValidationError
>(
  itemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getWorkItemApiV1SoftwareFactoryWorkItemsItemIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetWorkItemApiV1SoftwareFactoryWorkItemsItemIdGetQueryOptions(
      itemId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update a work item's fields (title, description, priority, assignee, etc.).

A payload touching the dispatch claim must carry `expected_slot` (or
`force_release`) — see the clear-dispatch route for the contract.

Setting `status` on an item in a TERMINAL status (shipped / wont_do) is a
REOPEN, and a reopen always lands in `planned` whatever non-terminal status the
payload named: it opens the next rework cycle and releases the closed cycle's
dispatch claim, and `planned` is the only status the dispatch queue reads.
 * @summary Update Work Item
 */
export const updateWorkItemApiV1SoftwareFactoryWorkItemsItemIdPut = (
  itemId: string,
  updateWorkItemApiV1SoftwareFactoryWorkItemsItemIdPutBody: UpdateWorkItemApiV1SoftwareFactoryWorkItemsItemIdPutBody
) => {
  return customInstance<unknown>({
    url: `/api/v1/software-factory/work-items/${itemId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateWorkItemApiV1SoftwareFactoryWorkItemsItemIdPutBody
  });
};

export const getUpdateWorkItemApiV1SoftwareFactoryWorkItemsItemIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateWorkItemApiV1SoftwareFactoryWorkItemsItemIdPut>
      >,
      TError,
      {
        itemId: string;
        data: UpdateWorkItemApiV1SoftwareFactoryWorkItemsItemIdPutBody;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updateWorkItemApiV1SoftwareFactoryWorkItemsItemIdPut>
    >,
    TError,
    {
      itemId: string;
      data: UpdateWorkItemApiV1SoftwareFactoryWorkItemsItemIdPutBody;
    },
    TContext
  > => {
    const mutationKey = [
      'updateWorkItemApiV1SoftwareFactoryWorkItemsItemIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updateWorkItemApiV1SoftwareFactoryWorkItemsItemIdPut>
      >,
      {
        itemId: string;
        data: UpdateWorkItemApiV1SoftwareFactoryWorkItemsItemIdPutBody;
      }
    > = (props) => {
      const { itemId, data } = props ?? {};

      return updateWorkItemApiV1SoftwareFactoryWorkItemsItemIdPut(itemId, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateWorkItemApiV1SoftwareFactoryWorkItemsItemIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof updateWorkItemApiV1SoftwareFactoryWorkItemsItemIdPut>
    >
  >;
export type UpdateWorkItemApiV1SoftwareFactoryWorkItemsItemIdPutMutationBody =
  UpdateWorkItemApiV1SoftwareFactoryWorkItemsItemIdPutBody;
export type UpdateWorkItemApiV1SoftwareFactoryWorkItemsItemIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Work Item
 */
export const useUpdateWorkItemApiV1SoftwareFactoryWorkItemsItemIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateWorkItemApiV1SoftwareFactoryWorkItemsItemIdPut>
      >,
      TError,
      {
        itemId: string;
        data: UpdateWorkItemApiV1SoftwareFactoryWorkItemsItemIdPutBody;
      },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateWorkItemApiV1SoftwareFactoryWorkItemsItemIdPut>
  >,
  TError,
  {
    itemId: string;
    data: UpdateWorkItemApiV1SoftwareFactoryWorkItemsItemIdPutBody;
  },
  TContext
> => {
  const mutationOptions =
    getUpdateWorkItemApiV1SoftwareFactoryWorkItemsItemIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete a work item.
 * @summary Delete Work Item
 */
export const deleteWorkItemApiV1SoftwareFactoryWorkItemsItemIdDelete = (
  itemId: string
) => {
  return customInstance<unknown>({
    url: `/api/v1/software-factory/work-items/${itemId}`,
    method: 'DELETE'
  });
};

export const getDeleteWorkItemApiV1SoftwareFactoryWorkItemsItemIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteWorkItemApiV1SoftwareFactoryWorkItemsItemIdDelete
        >
      >,
      TError,
      { itemId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof deleteWorkItemApiV1SoftwareFactoryWorkItemsItemIdDelete>
    >,
    TError,
    { itemId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteWorkItemApiV1SoftwareFactoryWorkItemsItemIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteWorkItemApiV1SoftwareFactoryWorkItemsItemIdDelete
        >
      >,
      { itemId: string }
    > = (props) => {
      const { itemId } = props ?? {};

      return deleteWorkItemApiV1SoftwareFactoryWorkItemsItemIdDelete(itemId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteWorkItemApiV1SoftwareFactoryWorkItemsItemIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof deleteWorkItemApiV1SoftwareFactoryWorkItemsItemIdDelete>
    >
  >;

export type DeleteWorkItemApiV1SoftwareFactoryWorkItemsItemIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Work Item
 */
export const useDeleteWorkItemApiV1SoftwareFactoryWorkItemsItemIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteWorkItemApiV1SoftwareFactoryWorkItemsItemIdDelete
        >
      >,
      TError,
      { itemId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof deleteWorkItemApiV1SoftwareFactoryWorkItemsItemIdDelete>
  >,
  TError,
  { itemId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteWorkItemApiV1SoftwareFactoryWorkItemsItemIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Stream a work-item attachment, authorized by tenant + work-item linkage.

The general file-download endpoint (``/files/{id}/download``) enforces
per-file ReBAC. The PanClaude dispatch pipeline authenticates with an API
key whose service user has no ReBAC relation to a human-uploaded file, so it
gets 403 there and cannot deliver attachments into the dispatched worktree
for the agent to read. This endpoint authorizes the way the API key already
can: RLS scopes the file to the caller's tenant, and requiring
``attached_to`` to reference a work item prevents it from serving arbitrary
tenant files. Any identity that can read the tenant's work items can read
their attachments.
 * @summary Download Work Item Attachment
 */
export const downloadWorkItemAttachmentApiV1SoftwareFactoryWorkItemAttachmentsFileIdDownloadGet =
  (fileId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/work-item-attachments/${fileId}/download`,
      method: 'GET',
      signal
    });
  };

export const getDownloadWorkItemAttachmentApiV1SoftwareFactoryWorkItemAttachmentsFileIdDownloadGetQueryKey =
  (fileId?: string) => {
    return [
      `/api/v1/software-factory/work-item-attachments/${fileId}/download`
    ] as const;
  };

export const getDownloadWorkItemAttachmentApiV1SoftwareFactoryWorkItemAttachmentsFileIdDownloadGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof downloadWorkItemAttachmentApiV1SoftwareFactoryWorkItemAttachmentsFileIdDownloadGet
      >
    >,
    TError = HTTPValidationError
  >(
    fileId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof downloadWorkItemAttachmentApiV1SoftwareFactoryWorkItemAttachmentsFileIdDownloadGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getDownloadWorkItemAttachmentApiV1SoftwareFactoryWorkItemAttachmentsFileIdDownloadGetQueryKey(
        fileId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof downloadWorkItemAttachmentApiV1SoftwareFactoryWorkItemAttachmentsFileIdDownloadGet
        >
      >
    > = ({ signal }) =>
      downloadWorkItemAttachmentApiV1SoftwareFactoryWorkItemAttachmentsFileIdDownloadGet(
        fileId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!fileId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof downloadWorkItemAttachmentApiV1SoftwareFactoryWorkItemAttachmentsFileIdDownloadGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type DownloadWorkItemAttachmentApiV1SoftwareFactoryWorkItemAttachmentsFileIdDownloadGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof downloadWorkItemAttachmentApiV1SoftwareFactoryWorkItemAttachmentsFileIdDownloadGet
      >
    >
  >;
export type DownloadWorkItemAttachmentApiV1SoftwareFactoryWorkItemAttachmentsFileIdDownloadGetQueryError =
  HTTPValidationError;

export function useDownloadWorkItemAttachmentApiV1SoftwareFactoryWorkItemAttachmentsFileIdDownloadGet<
  TData = Awaited<
    ReturnType<
      typeof downloadWorkItemAttachmentApiV1SoftwareFactoryWorkItemAttachmentsFileIdDownloadGet
    >
  >,
  TError = HTTPValidationError
>(
  fileId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof downloadWorkItemAttachmentApiV1SoftwareFactoryWorkItemAttachmentsFileIdDownloadGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof downloadWorkItemAttachmentApiV1SoftwareFactoryWorkItemAttachmentsFileIdDownloadGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof downloadWorkItemAttachmentApiV1SoftwareFactoryWorkItemAttachmentsFileIdDownloadGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useDownloadWorkItemAttachmentApiV1SoftwareFactoryWorkItemAttachmentsFileIdDownloadGet<
  TData = Awaited<
    ReturnType<
      typeof downloadWorkItemAttachmentApiV1SoftwareFactoryWorkItemAttachmentsFileIdDownloadGet
    >
  >,
  TError = HTTPValidationError
>(
  fileId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof downloadWorkItemAttachmentApiV1SoftwareFactoryWorkItemAttachmentsFileIdDownloadGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof downloadWorkItemAttachmentApiV1SoftwareFactoryWorkItemAttachmentsFileIdDownloadGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof downloadWorkItemAttachmentApiV1SoftwareFactoryWorkItemAttachmentsFileIdDownloadGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDownloadWorkItemAttachmentApiV1SoftwareFactoryWorkItemAttachmentsFileIdDownloadGet<
  TData = Awaited<
    ReturnType<
      typeof downloadWorkItemAttachmentApiV1SoftwareFactoryWorkItemAttachmentsFileIdDownloadGet
    >
  >,
  TError = HTTPValidationError
>(
  fileId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof downloadWorkItemAttachmentApiV1SoftwareFactoryWorkItemAttachmentsFileIdDownloadGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Download Work Item Attachment
 */

export function useDownloadWorkItemAttachmentApiV1SoftwareFactoryWorkItemAttachmentsFileIdDownloadGet<
  TData = Awaited<
    ReturnType<
      typeof downloadWorkItemAttachmentApiV1SoftwareFactoryWorkItemAttachmentsFileIdDownloadGet
    >
  >,
  TError = HTTPValidationError
>(
  fileId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof downloadWorkItemAttachmentApiV1SoftwareFactoryWorkItemAttachmentsFileIdDownloadGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getDownloadWorkItemAttachmentApiV1SoftwareFactoryWorkItemAttachmentsFileIdDownloadGetQueryOptions(
      fileId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Set the same priority / autonomy / module / initiative / assignee on many items,
over an explicit id list or the whole filter set.

``match_all_filtered`` resolves the SAME filtered query the list page renders
(``WorkItemRepository._apply_filters``) to a bounded id set, then hands it to
the same set-based service method the id path uses — so the two cannot drift
and the audit trail is identical. Bounded by
:data:`WORK_ITEM_BULK_MATCHING_MAX`; over that the call is refused rather than
truncated.

On the ID path an **inaccessible id refuses the whole call** rather than being
dropped from it, matching software factory's only other batched gate
(:func:`_enforce_work_item_write_batch`, behind the changelog link route) and
unlike the tickets and pipeline bulk endpoints, which drop silently and report
a count. The selection there comes from one page the caller is already looking
at, so an id they cannot edit is a stale page rather than a wide net — and a
`{"updated": 19}` for a selection of twenty hides which one was refused. The
escalated path has no enumerated list to refuse and so drops instead; see
:func:`_resolve_bulk_work_item_ids`.
 * @summary Bulk Update Work Items
 */
export const bulkUpdateWorkItemsApiV1SoftwareFactoryWorkItemsBulkUpdatePost = (
  workItemBulkUpdateRequest: WorkItemBulkUpdateRequest,
  signal?: AbortSignal
) => {
  return customInstance<SfWorkItemBulkUpdateResponse>({
    url: `/api/v1/software-factory/work-items/bulk-update`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: workItemBulkUpdateRequest,
    signal
  });
};

export const getBulkUpdateWorkItemsApiV1SoftwareFactoryWorkItemsBulkUpdatePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof bulkUpdateWorkItemsApiV1SoftwareFactoryWorkItemsBulkUpdatePost
        >
      >,
      TError,
      { data: WorkItemBulkUpdateRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof bulkUpdateWorkItemsApiV1SoftwareFactoryWorkItemsBulkUpdatePost
      >
    >,
    TError,
    { data: WorkItemBulkUpdateRequest },
    TContext
  > => {
    const mutationKey = [
      'bulkUpdateWorkItemsApiV1SoftwareFactoryWorkItemsBulkUpdatePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof bulkUpdateWorkItemsApiV1SoftwareFactoryWorkItemsBulkUpdatePost
        >
      >,
      { data: WorkItemBulkUpdateRequest }
    > = (props) => {
      const { data } = props ?? {};

      return bulkUpdateWorkItemsApiV1SoftwareFactoryWorkItemsBulkUpdatePost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type BulkUpdateWorkItemsApiV1SoftwareFactoryWorkItemsBulkUpdatePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof bulkUpdateWorkItemsApiV1SoftwareFactoryWorkItemsBulkUpdatePost
      >
    >
  >;
export type BulkUpdateWorkItemsApiV1SoftwareFactoryWorkItemsBulkUpdatePostMutationBody =
  WorkItemBulkUpdateRequest;
export type BulkUpdateWorkItemsApiV1SoftwareFactoryWorkItemsBulkUpdatePostMutationError =
  HTTPValidationError;

/**
 * @summary Bulk Update Work Items
 */
export const useBulkUpdateWorkItemsApiV1SoftwareFactoryWorkItemsBulkUpdatePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof bulkUpdateWorkItemsApiV1SoftwareFactoryWorkItemsBulkUpdatePost
          >
        >,
        TError,
        { data: WorkItemBulkUpdateRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof bulkUpdateWorkItemsApiV1SoftwareFactoryWorkItemsBulkUpdatePost
      >
    >,
    TError,
    { data: WorkItemBulkUpdateRequest },
    TContext
  > => {
    const mutationOptions =
      getBulkUpdateWorkItemsApiV1SoftwareFactoryWorkItemsBulkUpdatePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * How many of the selected work items already carry this customer reference.

Resolved through the SAME scope as the apply route below — id list or filter
set — and at the SAME permission floor, deliberately: a coverage number
resolved over a different or wider set than the write describes a set the apply
would not touch, and the dialog renders it as if it did. That is why this route
escalates alongside its sibling rather than staying id-only: under an escalated
selection an id-scoped coverage count would silently describe one page.
 * @summary Bulk Work Item Customer Summary
 */
export const bulkWorkItemCustomerSummaryApiV1SoftwareFactoryWorkItemsBulkCustomersSummaryPost =
  (
    workItemBulkCustomerRequest: WorkItemBulkCustomerRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<SfWorkItemBulkCustomerSummaryResponse>({
      url: `/api/v1/software-factory/work-items/bulk-customers/summary`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: workItemBulkCustomerRequest,
      signal
    });
  };

export const getBulkWorkItemCustomerSummaryApiV1SoftwareFactoryWorkItemsBulkCustomersSummaryPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof bulkWorkItemCustomerSummaryApiV1SoftwareFactoryWorkItemsBulkCustomersSummaryPost
        >
      >,
      TError,
      { data: WorkItemBulkCustomerRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof bulkWorkItemCustomerSummaryApiV1SoftwareFactoryWorkItemsBulkCustomersSummaryPost
      >
    >,
    TError,
    { data: WorkItemBulkCustomerRequest },
    TContext
  > => {
    const mutationKey = [
      'bulkWorkItemCustomerSummaryApiV1SoftwareFactoryWorkItemsBulkCustomersSummaryPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof bulkWorkItemCustomerSummaryApiV1SoftwareFactoryWorkItemsBulkCustomersSummaryPost
        >
      >,
      { data: WorkItemBulkCustomerRequest }
    > = (props) => {
      const { data } = props ?? {};

      return bulkWorkItemCustomerSummaryApiV1SoftwareFactoryWorkItemsBulkCustomersSummaryPost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type BulkWorkItemCustomerSummaryApiV1SoftwareFactoryWorkItemsBulkCustomersSummaryPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof bulkWorkItemCustomerSummaryApiV1SoftwareFactoryWorkItemsBulkCustomersSummaryPost
      >
    >
  >;
export type BulkWorkItemCustomerSummaryApiV1SoftwareFactoryWorkItemsBulkCustomersSummaryPostMutationBody =
  WorkItemBulkCustomerRequest;
export type BulkWorkItemCustomerSummaryApiV1SoftwareFactoryWorkItemsBulkCustomersSummaryPostMutationError =
  HTTPValidationError;

/**
 * @summary Bulk Work Item Customer Summary
 */
export const useBulkWorkItemCustomerSummaryApiV1SoftwareFactoryWorkItemsBulkCustomersSummaryPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof bulkWorkItemCustomerSummaryApiV1SoftwareFactoryWorkItemsBulkCustomersSummaryPost
          >
        >,
        TError,
        { data: WorkItemBulkCustomerRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof bulkWorkItemCustomerSummaryApiV1SoftwareFactoryWorkItemsBulkCustomersSummaryPost
      >
    >,
    TError,
    { data: WorkItemBulkCustomerRequest },
    TContext
  > => {
    const mutationOptions =
      getBulkWorkItemCustomerSummaryApiV1SoftwareFactoryWorkItemsBulkCustomersSummaryPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Link or unlink one customer (company / contact / deal) across a selection,
over an explicit id list or the whole filter set.

Both directions ship together (``docs/design-system/ui-list-pages.md`` §6), and
both escalate: an escalated "add" the user regrets is undone by an escalated
"remove" against the same filter set, which is what makes offering the
escalation on a LINK affordable at all. Both arms of the write are set-based —
one multi-row INSERT ``ON CONFLICT DO NOTHING``, or one projected SELECT plus
one DELETE — so the row count is not what bounds this route;
:data:`WORK_ITEM_BULK_MATCHING_MAX` is shared with its sibling so the two
cannot answer differently about the same escalated selection.
 * @summary Bulk Change Work Item Customer
 */
export const bulkChangeWorkItemCustomerApiV1SoftwareFactoryWorkItemsBulkCustomersPost =
  (
    workItemBulkCustomerRequest: WorkItemBulkCustomerRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<SfWorkItemBulkCustomerResponse>({
      url: `/api/v1/software-factory/work-items/bulk-customers`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: workItemBulkCustomerRequest,
      signal
    });
  };

export const getBulkChangeWorkItemCustomerApiV1SoftwareFactoryWorkItemsBulkCustomersPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof bulkChangeWorkItemCustomerApiV1SoftwareFactoryWorkItemsBulkCustomersPost
        >
      >,
      TError,
      { data: WorkItemBulkCustomerRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof bulkChangeWorkItemCustomerApiV1SoftwareFactoryWorkItemsBulkCustomersPost
      >
    >,
    TError,
    { data: WorkItemBulkCustomerRequest },
    TContext
  > => {
    const mutationKey = [
      'bulkChangeWorkItemCustomerApiV1SoftwareFactoryWorkItemsBulkCustomersPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof bulkChangeWorkItemCustomerApiV1SoftwareFactoryWorkItemsBulkCustomersPost
        >
      >,
      { data: WorkItemBulkCustomerRequest }
    > = (props) => {
      const { data } = props ?? {};

      return bulkChangeWorkItemCustomerApiV1SoftwareFactoryWorkItemsBulkCustomersPost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type BulkChangeWorkItemCustomerApiV1SoftwareFactoryWorkItemsBulkCustomersPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof bulkChangeWorkItemCustomerApiV1SoftwareFactoryWorkItemsBulkCustomersPost
      >
    >
  >;
export type BulkChangeWorkItemCustomerApiV1SoftwareFactoryWorkItemsBulkCustomersPostMutationBody =
  WorkItemBulkCustomerRequest;
export type BulkChangeWorkItemCustomerApiV1SoftwareFactoryWorkItemsBulkCustomersPostMutationError =
  HTTPValidationError;

/**
 * @summary Bulk Change Work Item Customer
 */
export const useBulkChangeWorkItemCustomerApiV1SoftwareFactoryWorkItemsBulkCustomersPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof bulkChangeWorkItemCustomerApiV1SoftwareFactoryWorkItemsBulkCustomersPost
          >
        >,
        TError,
        { data: WorkItemBulkCustomerRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof bulkChangeWorkItemCustomerApiV1SoftwareFactoryWorkItemsBulkCustomersPost
      >
    >,
    TError,
    { data: WorkItemBulkCustomerRequest },
    TContext
  > => {
    const mutationOptions =
      getBulkChangeWorkItemCustomerApiV1SoftwareFactoryWorkItemsBulkCustomersPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Transition a work item to any status.

Valid statuses: new, triaged, planned, in_progress, shipped, wont_do.
Any status can transition to any other status — there are no restrictions.
The response includes a `next_status` field suggesting the natural progression.

ONE coercion: leaving a terminal status (shipped / wont_do) is a REOPEN, and a
reopen always lands in `planned` whatever non-terminal status was asked for —
it opens the next rework cycle and releases the closed cycle's dispatch claim,
and `planned` is the only status the dispatch queue reads. Ask for
`in_progress` on a shipped item and the response (and the transition record)
say `planned`.

Optional fields in the JSON body (alongside "status"):
- notes: text to record why this transition happened
- completion_notes: rich-text HTML recording what was actually DONE — the
  ship-time write-up that the item's detail page renders. Distinct from
  `notes`, which is a one-line reason attached to THIS transition only. Send
  real tags (`<p>`, `<h3>`, `<ul>`), never HTML entities (`&lt;p&gt;`), which
  are stored and rendered as literal text.
- commit_shas: list of git commit SHA strings to link (e.g. ["abc123", "def456"])
- assignee_user_id, agent_id, agent_label, branch_name, pr_url, pr_number,
  size, autonomy_level, priority, module_id, initiative_id, wont_do_reason
- preferred_provider, preferred_model, preferred_thinking_level (dispatch hints —
  a projection of the item's primary AI setup)
- effort_hours, effort_agent_id, effort_agent_label, effort_llm_model,
  effort_skill_slug, effort_input_tokens, effort_output_tokens
- ai_setups: the FULL ordered list of the item's AI setups, replacing what is
  stored. This is where a ship records how each AI configuration performed —
  each entry takes provider, model, thinking_level, custom_prompt plus
  wall_seconds, working_seconds, user_input_requests, tokens_up, tokens_down,
  cost_amount, cost_currency, outcome, ai_review_score, human_review_score.
  Send an entry's existing `id` to update it in place; omit it to add a new one.
- create_changelog, changelog_title, changelog_category (for shipped transitions)
 * @summary Update Work Item Status
 */
export const updateWorkItemStatusApiV1SoftwareFactoryWorkItemsItemIdStatusPut =
  (
    itemId: string,
    updateWorkItemStatusApiV1SoftwareFactoryWorkItemsItemIdStatusPutBody: UpdateWorkItemStatusApiV1SoftwareFactoryWorkItemsItemIdStatusPutBody
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/work-items/${itemId}/status`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateWorkItemStatusApiV1SoftwareFactoryWorkItemsItemIdStatusPutBody
    });
  };

export const getUpdateWorkItemStatusApiV1SoftwareFactoryWorkItemsItemIdStatusPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateWorkItemStatusApiV1SoftwareFactoryWorkItemsItemIdStatusPut
        >
      >,
      TError,
      {
        itemId: string;
        data: UpdateWorkItemStatusApiV1SoftwareFactoryWorkItemsItemIdStatusPutBody;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateWorkItemStatusApiV1SoftwareFactoryWorkItemsItemIdStatusPut
      >
    >,
    TError,
    {
      itemId: string;
      data: UpdateWorkItemStatusApiV1SoftwareFactoryWorkItemsItemIdStatusPutBody;
    },
    TContext
  > => {
    const mutationKey = [
      'updateWorkItemStatusApiV1SoftwareFactoryWorkItemsItemIdStatusPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateWorkItemStatusApiV1SoftwareFactoryWorkItemsItemIdStatusPut
        >
      >,
      {
        itemId: string;
        data: UpdateWorkItemStatusApiV1SoftwareFactoryWorkItemsItemIdStatusPutBody;
      }
    > = (props) => {
      const { itemId, data } = props ?? {};

      return updateWorkItemStatusApiV1SoftwareFactoryWorkItemsItemIdStatusPut(
        itemId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateWorkItemStatusApiV1SoftwareFactoryWorkItemsItemIdStatusPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateWorkItemStatusApiV1SoftwareFactoryWorkItemsItemIdStatusPut
      >
    >
  >;
export type UpdateWorkItemStatusApiV1SoftwareFactoryWorkItemsItemIdStatusPutMutationBody =
  UpdateWorkItemStatusApiV1SoftwareFactoryWorkItemsItemIdStatusPutBody;
export type UpdateWorkItemStatusApiV1SoftwareFactoryWorkItemsItemIdStatusPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Work Item Status
 */
export const useUpdateWorkItemStatusApiV1SoftwareFactoryWorkItemsItemIdStatusPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateWorkItemStatusApiV1SoftwareFactoryWorkItemsItemIdStatusPut
          >
        >,
        TError,
        {
          itemId: string;
          data: UpdateWorkItemStatusApiV1SoftwareFactoryWorkItemsItemIdStatusPutBody;
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateWorkItemStatusApiV1SoftwareFactoryWorkItemsItemIdStatusPut
      >
    >,
    TError,
    {
      itemId: string;
      data: UpdateWorkItemStatusApiV1SoftwareFactoryWorkItemsItemIdStatusPutBody;
    },
    TContext
  > => {
    const mutationOptions =
      getUpdateWorkItemStatusApiV1SoftwareFactoryWorkItemsItemIdStatusPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List a work item's AI setups — the configurations it is run with, and how each performed.

Routed through WorkItemService so the read passes the SAME visibility gate as the
work item itself: the setups carry operator-authored prompts and per-run spend, and
the repository filters only by tenant + work item.
 * @summary List Work Item Ai Setups
 */
export const listWorkItemAiSetupsApiV1SoftwareFactoryWorkItemsItemIdAiSetupsGet =
  (itemId: string, signal?: AbortSignal) => {
    return customInstance<SfWorkItemAiSetupListResponse>({
      url: `/api/v1/software-factory/work-items/${itemId}/ai-setups`,
      method: 'GET',
      signal
    });
  };

export const getListWorkItemAiSetupsApiV1SoftwareFactoryWorkItemsItemIdAiSetupsGetQueryKey =
  (itemId?: string) => {
    return [`/api/v1/software-factory/work-items/${itemId}/ai-setups`] as const;
  };

export const getListWorkItemAiSetupsApiV1SoftwareFactoryWorkItemsItemIdAiSetupsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listWorkItemAiSetupsApiV1SoftwareFactoryWorkItemsItemIdAiSetupsGet
      >
    >,
    TError = HTTPValidationError
  >(
    itemId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listWorkItemAiSetupsApiV1SoftwareFactoryWorkItemsItemIdAiSetupsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListWorkItemAiSetupsApiV1SoftwareFactoryWorkItemsItemIdAiSetupsGetQueryKey(
        itemId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listWorkItemAiSetupsApiV1SoftwareFactoryWorkItemsItemIdAiSetupsGet
        >
      >
    > = ({ signal }) =>
      listWorkItemAiSetupsApiV1SoftwareFactoryWorkItemsItemIdAiSetupsGet(
        itemId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!itemId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listWorkItemAiSetupsApiV1SoftwareFactoryWorkItemsItemIdAiSetupsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListWorkItemAiSetupsApiV1SoftwareFactoryWorkItemsItemIdAiSetupsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listWorkItemAiSetupsApiV1SoftwareFactoryWorkItemsItemIdAiSetupsGet
      >
    >
  >;
export type ListWorkItemAiSetupsApiV1SoftwareFactoryWorkItemsItemIdAiSetupsGetQueryError =
  HTTPValidationError;

export function useListWorkItemAiSetupsApiV1SoftwareFactoryWorkItemsItemIdAiSetupsGet<
  TData = Awaited<
    ReturnType<
      typeof listWorkItemAiSetupsApiV1SoftwareFactoryWorkItemsItemIdAiSetupsGet
    >
  >,
  TError = HTTPValidationError
>(
  itemId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listWorkItemAiSetupsApiV1SoftwareFactoryWorkItemsItemIdAiSetupsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listWorkItemAiSetupsApiV1SoftwareFactoryWorkItemsItemIdAiSetupsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listWorkItemAiSetupsApiV1SoftwareFactoryWorkItemsItemIdAiSetupsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListWorkItemAiSetupsApiV1SoftwareFactoryWorkItemsItemIdAiSetupsGet<
  TData = Awaited<
    ReturnType<
      typeof listWorkItemAiSetupsApiV1SoftwareFactoryWorkItemsItemIdAiSetupsGet
    >
  >,
  TError = HTTPValidationError
>(
  itemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listWorkItemAiSetupsApiV1SoftwareFactoryWorkItemsItemIdAiSetupsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listWorkItemAiSetupsApiV1SoftwareFactoryWorkItemsItemIdAiSetupsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listWorkItemAiSetupsApiV1SoftwareFactoryWorkItemsItemIdAiSetupsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListWorkItemAiSetupsApiV1SoftwareFactoryWorkItemsItemIdAiSetupsGet<
  TData = Awaited<
    ReturnType<
      typeof listWorkItemAiSetupsApiV1SoftwareFactoryWorkItemsItemIdAiSetupsGet
    >
  >,
  TError = HTTPValidationError
>(
  itemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listWorkItemAiSetupsApiV1SoftwareFactoryWorkItemsItemIdAiSetupsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Work Item Ai Setups
 */

export function useListWorkItemAiSetupsApiV1SoftwareFactoryWorkItemsItemIdAiSetupsGet<
  TData = Awaited<
    ReturnType<
      typeof listWorkItemAiSetupsApiV1SoftwareFactoryWorkItemsItemIdAiSetupsGet
    >
  >,
  TError = HTTPValidationError
>(
  itemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listWorkItemAiSetupsApiV1SoftwareFactoryWorkItemsItemIdAiSetupsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListWorkItemAiSetupsApiV1SoftwareFactoryWorkItemsItemIdAiSetupsGetQueryOptions(
      itemId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Replace a work item's AI setups with the ordered list in `items`.

List order becomes `position`; position 0 is the PRIMARY setup and is projected
onto the item's preferred_provider / preferred_model / preferred_thinking_level
(the flat dispatch hints PanClaude reads). Send an entry's existing `id` to
update it in place — omitting it adds a new row, and any stored row not named in
the list is removed.

Per entry: provider (required), model, thinking_level, custom_prompt, and the
measured result — wall_seconds, working_seconds, user_input_requests, tokens_up,
tokens_down, cost_amount, cost_currency, outcome, ai_review_score,
human_review_score.
 * @summary Replace Work Item Ai Setups
 */
export const replaceWorkItemAiSetupsApiV1SoftwareFactoryWorkItemsItemIdAiSetupsPut =
  (itemId: string, sfWorkItemAiSetupsReplace: SfWorkItemAiSetupsReplace) => {
    return customInstance<SfWorkItemAiSetupListResponse>({
      url: `/api/v1/software-factory/work-items/${itemId}/ai-setups`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: sfWorkItemAiSetupsReplace
    });
  };

export const getReplaceWorkItemAiSetupsApiV1SoftwareFactoryWorkItemsItemIdAiSetupsPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof replaceWorkItemAiSetupsApiV1SoftwareFactoryWorkItemsItemIdAiSetupsPut
        >
      >,
      TError,
      { itemId: string; data: SfWorkItemAiSetupsReplace },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof replaceWorkItemAiSetupsApiV1SoftwareFactoryWorkItemsItemIdAiSetupsPut
      >
    >,
    TError,
    { itemId: string; data: SfWorkItemAiSetupsReplace },
    TContext
  > => {
    const mutationKey = [
      'replaceWorkItemAiSetupsApiV1SoftwareFactoryWorkItemsItemIdAiSetupsPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof replaceWorkItemAiSetupsApiV1SoftwareFactoryWorkItemsItemIdAiSetupsPut
        >
      >,
      { itemId: string; data: SfWorkItemAiSetupsReplace }
    > = (props) => {
      const { itemId, data } = props ?? {};

      return replaceWorkItemAiSetupsApiV1SoftwareFactoryWorkItemsItemIdAiSetupsPut(
        itemId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ReplaceWorkItemAiSetupsApiV1SoftwareFactoryWorkItemsItemIdAiSetupsPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof replaceWorkItemAiSetupsApiV1SoftwareFactoryWorkItemsItemIdAiSetupsPut
      >
    >
  >;
export type ReplaceWorkItemAiSetupsApiV1SoftwareFactoryWorkItemsItemIdAiSetupsPutMutationBody =
  SfWorkItemAiSetupsReplace;
export type ReplaceWorkItemAiSetupsApiV1SoftwareFactoryWorkItemsItemIdAiSetupsPutMutationError =
  HTTPValidationError;

/**
 * @summary Replace Work Item Ai Setups
 */
export const useReplaceWorkItemAiSetupsApiV1SoftwareFactoryWorkItemsItemIdAiSetupsPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof replaceWorkItemAiSetupsApiV1SoftwareFactoryWorkItemsItemIdAiSetupsPut
          >
        >,
        TError,
        { itemId: string; data: SfWorkItemAiSetupsReplace },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof replaceWorkItemAiSetupsApiV1SoftwareFactoryWorkItemsItemIdAiSetupsPut
      >
    >,
    TError,
    { itemId: string; data: SfWorkItemAiSetupsReplace },
    TContext
  > => {
    const mutationOptions =
      getReplaceWorkItemAiSetupsApiV1SoftwareFactoryWorkItemsItemIdAiSetupsPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List a work item's REWORK CYCLES — one record per pass at it, oldest first.

A cycle opens when the item is created or reopened (leaves a terminal status for
an active one) and closes on entry into `shipped`/`wont_do`. Each carries that
pass's own ship date, branch, PR, slot identity, effort, tokens, deploy stamp and
AI-setup results, so a reopen → re-ship no longer overwrites the previous pass's
record. The work item's own delivery columns remain the LATEST cycle's values.

Routed through WorkItemService so the read passes the same visibility gate as the
work item itself: a cycle carries operator-authored prompts and per-run spend.
 * @summary List Work Item Cycles
 */
export const listWorkItemCyclesApiV1SoftwareFactoryWorkItemsItemIdCyclesGet = (
  itemId: string,
  signal?: AbortSignal
) => {
  return customInstance<SfWorkItemCycleListResponse>({
    url: `/api/v1/software-factory/work-items/${itemId}/cycles`,
    method: 'GET',
    signal
  });
};

export const getListWorkItemCyclesApiV1SoftwareFactoryWorkItemsItemIdCyclesGetQueryKey =
  (itemId?: string) => {
    return [`/api/v1/software-factory/work-items/${itemId}/cycles`] as const;
  };

export const getListWorkItemCyclesApiV1SoftwareFactoryWorkItemsItemIdCyclesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listWorkItemCyclesApiV1SoftwareFactoryWorkItemsItemIdCyclesGet
      >
    >,
    TError = HTTPValidationError
  >(
    itemId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listWorkItemCyclesApiV1SoftwareFactoryWorkItemsItemIdCyclesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListWorkItemCyclesApiV1SoftwareFactoryWorkItemsItemIdCyclesGetQueryKey(
        itemId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listWorkItemCyclesApiV1SoftwareFactoryWorkItemsItemIdCyclesGet
        >
      >
    > = ({ signal }) =>
      listWorkItemCyclesApiV1SoftwareFactoryWorkItemsItemIdCyclesGet(
        itemId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!itemId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listWorkItemCyclesApiV1SoftwareFactoryWorkItemsItemIdCyclesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListWorkItemCyclesApiV1SoftwareFactoryWorkItemsItemIdCyclesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listWorkItemCyclesApiV1SoftwareFactoryWorkItemsItemIdCyclesGet
      >
    >
  >;
export type ListWorkItemCyclesApiV1SoftwareFactoryWorkItemsItemIdCyclesGetQueryError =
  HTTPValidationError;

export function useListWorkItemCyclesApiV1SoftwareFactoryWorkItemsItemIdCyclesGet<
  TData = Awaited<
    ReturnType<
      typeof listWorkItemCyclesApiV1SoftwareFactoryWorkItemsItemIdCyclesGet
    >
  >,
  TError = HTTPValidationError
>(
  itemId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listWorkItemCyclesApiV1SoftwareFactoryWorkItemsItemIdCyclesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listWorkItemCyclesApiV1SoftwareFactoryWorkItemsItemIdCyclesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listWorkItemCyclesApiV1SoftwareFactoryWorkItemsItemIdCyclesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListWorkItemCyclesApiV1SoftwareFactoryWorkItemsItemIdCyclesGet<
  TData = Awaited<
    ReturnType<
      typeof listWorkItemCyclesApiV1SoftwareFactoryWorkItemsItemIdCyclesGet
    >
  >,
  TError = HTTPValidationError
>(
  itemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listWorkItemCyclesApiV1SoftwareFactoryWorkItemsItemIdCyclesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listWorkItemCyclesApiV1SoftwareFactoryWorkItemsItemIdCyclesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listWorkItemCyclesApiV1SoftwareFactoryWorkItemsItemIdCyclesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListWorkItemCyclesApiV1SoftwareFactoryWorkItemsItemIdCyclesGet<
  TData = Awaited<
    ReturnType<
      typeof listWorkItemCyclesApiV1SoftwareFactoryWorkItemsItemIdCyclesGet
    >
  >,
  TError = HTTPValidationError
>(
  itemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listWorkItemCyclesApiV1SoftwareFactoryWorkItemsItemIdCyclesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Work Item Cycles
 */

export function useListWorkItemCyclesApiV1SoftwareFactoryWorkItemsItemIdCyclesGet<
  TData = Awaited<
    ReturnType<
      typeof listWorkItemCyclesApiV1SoftwareFactoryWorkItemsItemIdCyclesGet
    >
  >,
  TError = HTTPValidationError
>(
  itemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listWorkItemCyclesApiV1SoftwareFactoryWorkItemsItemIdCyclesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListWorkItemCyclesApiV1SoftwareFactoryWorkItemsItemIdCyclesGetQueryOptions(
      itemId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List status transitions for a work item.
 * @summary List Work Item Transitions
 */
export const listWorkItemTransitionsApiV1SoftwareFactoryWorkItemsItemIdTransitionsGet =
  (itemId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/work-items/${itemId}/transitions`,
      method: 'GET',
      signal
    });
  };

export const getListWorkItemTransitionsApiV1SoftwareFactoryWorkItemsItemIdTransitionsGetQueryKey =
  (itemId?: string) => {
    return [
      `/api/v1/software-factory/work-items/${itemId}/transitions`
    ] as const;
  };

export const getListWorkItemTransitionsApiV1SoftwareFactoryWorkItemsItemIdTransitionsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listWorkItemTransitionsApiV1SoftwareFactoryWorkItemsItemIdTransitionsGet
      >
    >,
    TError = HTTPValidationError
  >(
    itemId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listWorkItemTransitionsApiV1SoftwareFactoryWorkItemsItemIdTransitionsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListWorkItemTransitionsApiV1SoftwareFactoryWorkItemsItemIdTransitionsGetQueryKey(
        itemId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listWorkItemTransitionsApiV1SoftwareFactoryWorkItemsItemIdTransitionsGet
        >
      >
    > = ({ signal }) =>
      listWorkItemTransitionsApiV1SoftwareFactoryWorkItemsItemIdTransitionsGet(
        itemId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!itemId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listWorkItemTransitionsApiV1SoftwareFactoryWorkItemsItemIdTransitionsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListWorkItemTransitionsApiV1SoftwareFactoryWorkItemsItemIdTransitionsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listWorkItemTransitionsApiV1SoftwareFactoryWorkItemsItemIdTransitionsGet
      >
    >
  >;
export type ListWorkItemTransitionsApiV1SoftwareFactoryWorkItemsItemIdTransitionsGetQueryError =
  HTTPValidationError;

export function useListWorkItemTransitionsApiV1SoftwareFactoryWorkItemsItemIdTransitionsGet<
  TData = Awaited<
    ReturnType<
      typeof listWorkItemTransitionsApiV1SoftwareFactoryWorkItemsItemIdTransitionsGet
    >
  >,
  TError = HTTPValidationError
>(
  itemId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listWorkItemTransitionsApiV1SoftwareFactoryWorkItemsItemIdTransitionsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listWorkItemTransitionsApiV1SoftwareFactoryWorkItemsItemIdTransitionsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listWorkItemTransitionsApiV1SoftwareFactoryWorkItemsItemIdTransitionsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListWorkItemTransitionsApiV1SoftwareFactoryWorkItemsItemIdTransitionsGet<
  TData = Awaited<
    ReturnType<
      typeof listWorkItemTransitionsApiV1SoftwareFactoryWorkItemsItemIdTransitionsGet
    >
  >,
  TError = HTTPValidationError
>(
  itemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listWorkItemTransitionsApiV1SoftwareFactoryWorkItemsItemIdTransitionsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listWorkItemTransitionsApiV1SoftwareFactoryWorkItemsItemIdTransitionsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listWorkItemTransitionsApiV1SoftwareFactoryWorkItemsItemIdTransitionsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListWorkItemTransitionsApiV1SoftwareFactoryWorkItemsItemIdTransitionsGet<
  TData = Awaited<
    ReturnType<
      typeof listWorkItemTransitionsApiV1SoftwareFactoryWorkItemsItemIdTransitionsGet
    >
  >,
  TError = HTTPValidationError
>(
  itemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listWorkItemTransitionsApiV1SoftwareFactoryWorkItemsItemIdTransitionsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Work Item Transitions
 */

export function useListWorkItemTransitionsApiV1SoftwareFactoryWorkItemsItemIdTransitionsGet<
  TData = Awaited<
    ReturnType<
      typeof listWorkItemTransitionsApiV1SoftwareFactoryWorkItemsItemIdTransitionsGet
    >
  >,
  TError = HTTPValidationError
>(
  itemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listWorkItemTransitionsApiV1SoftwareFactoryWorkItemsItemIdTransitionsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListWorkItemTransitionsApiV1SoftwareFactoryWorkItemsItemIdTransitionsGetQueryOptions(
      itemId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Upvote a work item. Each user can vote once per item.
 * @summary Vote On Work Item
 */
export const voteOnWorkItemApiV1SoftwareFactoryWorkItemsItemIdVotePost = (
  itemId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/software-factory/work-items/${itemId}/vote`,
    method: 'POST',
    signal
  });
};

export const getVoteOnWorkItemApiV1SoftwareFactoryWorkItemsItemIdVotePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof voteOnWorkItemApiV1SoftwareFactoryWorkItemsItemIdVotePost
        >
      >,
      TError,
      { itemId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof voteOnWorkItemApiV1SoftwareFactoryWorkItemsItemIdVotePost
      >
    >,
    TError,
    { itemId: string },
    TContext
  > => {
    const mutationKey = [
      'voteOnWorkItemApiV1SoftwareFactoryWorkItemsItemIdVotePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof voteOnWorkItemApiV1SoftwareFactoryWorkItemsItemIdVotePost
        >
      >,
      { itemId: string }
    > = (props) => {
      const { itemId } = props ?? {};

      return voteOnWorkItemApiV1SoftwareFactoryWorkItemsItemIdVotePost(itemId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type VoteOnWorkItemApiV1SoftwareFactoryWorkItemsItemIdVotePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof voteOnWorkItemApiV1SoftwareFactoryWorkItemsItemIdVotePost
      >
    >
  >;

export type VoteOnWorkItemApiV1SoftwareFactoryWorkItemsItemIdVotePostMutationError =
  HTTPValidationError;

/**
 * @summary Vote On Work Item
 */
export const useVoteOnWorkItemApiV1SoftwareFactoryWorkItemsItemIdVotePost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof voteOnWorkItemApiV1SoftwareFactoryWorkItemsItemIdVotePost
        >
      >,
      TError,
      { itemId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof voteOnWorkItemApiV1SoftwareFactoryWorkItemsItemIdVotePost>
  >,
  TError,
  { itemId: string },
  TContext
> => {
  const mutationOptions =
    getVoteOnWorkItemApiV1SoftwareFactoryWorkItemsItemIdVotePostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Remove the current user's vote from a work item.
 * @summary Remove Vote On Work Item
 */
export const removeVoteOnWorkItemApiV1SoftwareFactoryWorkItemsItemIdVoteDelete =
  (itemId: string) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/work-items/${itemId}/vote`,
      method: 'DELETE'
    });
  };

export const getRemoveVoteOnWorkItemApiV1SoftwareFactoryWorkItemsItemIdVoteDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof removeVoteOnWorkItemApiV1SoftwareFactoryWorkItemsItemIdVoteDelete
        >
      >,
      TError,
      { itemId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof removeVoteOnWorkItemApiV1SoftwareFactoryWorkItemsItemIdVoteDelete
      >
    >,
    TError,
    { itemId: string },
    TContext
  > => {
    const mutationKey = [
      'removeVoteOnWorkItemApiV1SoftwareFactoryWorkItemsItemIdVoteDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof removeVoteOnWorkItemApiV1SoftwareFactoryWorkItemsItemIdVoteDelete
        >
      >,
      { itemId: string }
    > = (props) => {
      const { itemId } = props ?? {};

      return removeVoteOnWorkItemApiV1SoftwareFactoryWorkItemsItemIdVoteDelete(
        itemId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RemoveVoteOnWorkItemApiV1SoftwareFactoryWorkItemsItemIdVoteDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof removeVoteOnWorkItemApiV1SoftwareFactoryWorkItemsItemIdVoteDelete
      >
    >
  >;

export type RemoveVoteOnWorkItemApiV1SoftwareFactoryWorkItemsItemIdVoteDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Remove Vote On Work Item
 */
export const useRemoveVoteOnWorkItemApiV1SoftwareFactoryWorkItemsItemIdVoteDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof removeVoteOnWorkItemApiV1SoftwareFactoryWorkItemsItemIdVoteDelete
          >
        >,
        TError,
        { itemId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof removeVoteOnWorkItemApiV1SoftwareFactoryWorkItemsItemIdVoteDelete
      >
    >,
    TError,
    { itemId: string },
    TContext
  > => {
    const mutationOptions =
      getRemoveVoteOnWorkItemApiV1SoftwareFactoryWorkItemsItemIdVoteDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Reset the schedule baseline to the item's current planned dates.

The baseline is normally captured automatically on first commitment; this is
the deliberate "re-baseline" action that overwrites it (e.g. after re-planning).
Requires the item to have a planned end_date.
 * @summary Rebaseline Work Item
 */
export const rebaselineWorkItemApiV1SoftwareFactoryWorkItemsItemIdRebaselinePost =
  (itemId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/work-items/${itemId}/rebaseline`,
      method: 'POST',
      signal
    });
  };

export const getRebaselineWorkItemApiV1SoftwareFactoryWorkItemsItemIdRebaselinePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof rebaselineWorkItemApiV1SoftwareFactoryWorkItemsItemIdRebaselinePost
        >
      >,
      TError,
      { itemId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof rebaselineWorkItemApiV1SoftwareFactoryWorkItemsItemIdRebaselinePost
      >
    >,
    TError,
    { itemId: string },
    TContext
  > => {
    const mutationKey = [
      'rebaselineWorkItemApiV1SoftwareFactoryWorkItemsItemIdRebaselinePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof rebaselineWorkItemApiV1SoftwareFactoryWorkItemsItemIdRebaselinePost
        >
      >,
      { itemId: string }
    > = (props) => {
      const { itemId } = props ?? {};

      return rebaselineWorkItemApiV1SoftwareFactoryWorkItemsItemIdRebaselinePost(
        itemId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RebaselineWorkItemApiV1SoftwareFactoryWorkItemsItemIdRebaselinePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof rebaselineWorkItemApiV1SoftwareFactoryWorkItemsItemIdRebaselinePost
      >
    >
  >;

export type RebaselineWorkItemApiV1SoftwareFactoryWorkItemsItemIdRebaselinePostMutationError =
  HTTPValidationError;

/**
 * @summary Rebaseline Work Item
 */
export const useRebaselineWorkItemApiV1SoftwareFactoryWorkItemsItemIdRebaselinePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof rebaselineWorkItemApiV1SoftwareFactoryWorkItemsItemIdRebaselinePost
          >
        >,
        TError,
        { itemId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof rebaselineWorkItemApiV1SoftwareFactoryWorkItemsItemIdRebaselinePost
      >
    >,
    TError,
    { itemId: string },
    TContext
  > => {
    const mutationOptions =
      getRebaselineWorkItemApiV1SoftwareFactoryWorkItemsItemIdRebaselinePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Dispatch a work item to an AI agent: assign the agent, resolve the skill,
and move it to in_progress.

The body is TYPED (`work_item_dispatch.schema.json`), and that is load-bearing
rather than tidiness: it was a bare `data: dict`, which publishes no named
properties into the OpenAPI document, so every caller generated from that
document — the MCP tool an AI agent drives, the orval TS client — offered the
path parameter and nothing else. Against a service that refuses the call
without `agent_id` or `agent_label`, that made this route unconditionally
unsatisfiable over MCP: a 400 naming two fields the schema never offered.

Requires agent_id or agent_label. Refuses with **409 CONFLICT** (the message
names which condition failed) if the item is:
  - blocked — a predecessor is not yet 'shipped'. Its worktree would branch
    from a main that lacks the predecessor's code.
  - deploy_blocked — an item in deploy_blocked_by is not yet live in prod.
  - already in flight — status is in_progress, or a slot already holds it.
    Re-open it to 'planned' (which clears the dispatch metadata) to dispatch
    again.
Refuses with 400 if the item is recurring (templates are never dispatchable).

A future start_date (post_dated) does NOT block this route — that gate applies
to auto-dispatch only, and dispatching early by hand is a deliberate override.
These are exactly the items GET /work-items/dispatchable returns.

On success stamps dispatched_at and increments dispatch_attempt_count. It does
not set dispatched_to_slot/dispatched_worktree — only the poller's
/mark-dispatched claim knows those.
 * @summary Dispatch Work Item
 */
export const dispatchWorkItemApiV1SoftwareFactoryWorkItemsItemIdDispatchPost = (
  itemId: string,
  sfWorkItemDispatch: SfWorkItemDispatch,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/software-factory/work-items/${itemId}/dispatch`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: sfWorkItemDispatch,
    signal
  });
};

export const getDispatchWorkItemApiV1SoftwareFactoryWorkItemsItemIdDispatchPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof dispatchWorkItemApiV1SoftwareFactoryWorkItemsItemIdDispatchPost
        >
      >,
      TError,
      { itemId: string; data: SfWorkItemDispatch },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof dispatchWorkItemApiV1SoftwareFactoryWorkItemsItemIdDispatchPost
      >
    >,
    TError,
    { itemId: string; data: SfWorkItemDispatch },
    TContext
  > => {
    const mutationKey = [
      'dispatchWorkItemApiV1SoftwareFactoryWorkItemsItemIdDispatchPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof dispatchWorkItemApiV1SoftwareFactoryWorkItemsItemIdDispatchPost
        >
      >,
      { itemId: string; data: SfWorkItemDispatch }
    > = (props) => {
      const { itemId, data } = props ?? {};

      return dispatchWorkItemApiV1SoftwareFactoryWorkItemsItemIdDispatchPost(
        itemId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DispatchWorkItemApiV1SoftwareFactoryWorkItemsItemIdDispatchPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof dispatchWorkItemApiV1SoftwareFactoryWorkItemsItemIdDispatchPost
      >
    >
  >;
export type DispatchWorkItemApiV1SoftwareFactoryWorkItemsItemIdDispatchPostMutationBody =
  SfWorkItemDispatch;
export type DispatchWorkItemApiV1SoftwareFactoryWorkItemsItemIdDispatchPostMutationError =
  HTTPValidationError;

/**
 * @summary Dispatch Work Item
 */
export const useDispatchWorkItemApiV1SoftwareFactoryWorkItemsItemIdDispatchPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof dispatchWorkItemApiV1SoftwareFactoryWorkItemsItemIdDispatchPost
          >
        >,
        TError,
        { itemId: string; data: SfWorkItemDispatch },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof dispatchWorkItemApiV1SoftwareFactoryWorkItemsItemIdDispatchPost
      >
    >,
    TError,
    { itemId: string; data: SfWorkItemDispatch },
    TContext
  > => {
    const mutationOptions =
      getDispatchWorkItemApiV1SoftwareFactoryWorkItemsItemIdDispatchPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Atomically claim a work item for PanClaude dispatch.

The first caller succeeds and gets the updated work item. Concurrent callers
receive 409 Conflict. Also transitions status from planned → in_progress.

An optional `agent_label` rides along on the claim and is stored on the row
exactly as the manual /dispatch seam stores it, so the list and detail
endpoints report which fleet is building an auto-dispatched item. It takes no
part in the compare-and-set: the claim's predicates are unchanged and
ownership is still decided by `dispatched_to_slot`.
 * @summary Mark Work Item Dispatched
 */
export const markWorkItemDispatchedApiV1SoftwareFactoryWorkItemsItemIdMarkDispatchedPost =
  (
    itemId: string,
    markDispatchedRequest: MarkDispatchedRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/work-items/${itemId}/mark-dispatched`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: markDispatchedRequest,
      signal
    });
  };

export const getMarkWorkItemDispatchedApiV1SoftwareFactoryWorkItemsItemIdMarkDispatchedPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof markWorkItemDispatchedApiV1SoftwareFactoryWorkItemsItemIdMarkDispatchedPost
        >
      >,
      TError,
      { itemId: string; data: MarkDispatchedRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof markWorkItemDispatchedApiV1SoftwareFactoryWorkItemsItemIdMarkDispatchedPost
      >
    >,
    TError,
    { itemId: string; data: MarkDispatchedRequest },
    TContext
  > => {
    const mutationKey = [
      'markWorkItemDispatchedApiV1SoftwareFactoryWorkItemsItemIdMarkDispatchedPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof markWorkItemDispatchedApiV1SoftwareFactoryWorkItemsItemIdMarkDispatchedPost
        >
      >,
      { itemId: string; data: MarkDispatchedRequest }
    > = (props) => {
      const { itemId, data } = props ?? {};

      return markWorkItemDispatchedApiV1SoftwareFactoryWorkItemsItemIdMarkDispatchedPost(
        itemId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type MarkWorkItemDispatchedApiV1SoftwareFactoryWorkItemsItemIdMarkDispatchedPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof markWorkItemDispatchedApiV1SoftwareFactoryWorkItemsItemIdMarkDispatchedPost
      >
    >
  >;
export type MarkWorkItemDispatchedApiV1SoftwareFactoryWorkItemsItemIdMarkDispatchedPostMutationBody =
  MarkDispatchedRequest;
export type MarkWorkItemDispatchedApiV1SoftwareFactoryWorkItemsItemIdMarkDispatchedPostMutationError =
  HTTPValidationError;

/**
 * @summary Mark Work Item Dispatched
 */
export const useMarkWorkItemDispatchedApiV1SoftwareFactoryWorkItemsItemIdMarkDispatchedPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof markWorkItemDispatchedApiV1SoftwareFactoryWorkItemsItemIdMarkDispatchedPost
          >
        >,
        TError,
        { itemId: string; data: MarkDispatchedRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof markWorkItemDispatchedApiV1SoftwareFactoryWorkItemsItemIdMarkDispatchedPost
      >
    >,
    TError,
    { itemId: string; data: MarkDispatchedRequest },
    TContext
  > => {
    const mutationOptions =
      getMarkWorkItemDispatchedApiV1SoftwareFactoryWorkItemsItemIdMarkDispatchedPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Clear dispatch metadata so a stuck/orphaned item can be re-dispatched.

Does not change status; the caller decides how to put the item back in the
queue. Typically used by PanClaude when it detects a slot crashed mid-run.
Admin-only: clearing dispatch can abort another agent's in-flight run.

Releasing a LIVE claim requires proof the caller holds it — `expected_slot`, or
an explicit `force_release`. Note this seam alone cannot re-open an item for
dispatch (it leaves the status untouched, and only 'planned' is dispatchable);
the transition into 'planned' does that, and carries the same guard.
 * @summary Clear Work Item Dispatch
 */
export const clearWorkItemDispatchApiV1SoftwareFactoryWorkItemsItemIdClearDispatchPost =
  (
    itemId: string,
    clearWorkItemDispatchApiV1SoftwareFactoryWorkItemsItemIdClearDispatchPostBody: ClearWorkItemDispatchApiV1SoftwareFactoryWorkItemsItemIdClearDispatchPostBody,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/work-items/${itemId}/clear-dispatch`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: clearWorkItemDispatchApiV1SoftwareFactoryWorkItemsItemIdClearDispatchPostBody,
      signal
    });
  };

export const getClearWorkItemDispatchApiV1SoftwareFactoryWorkItemsItemIdClearDispatchPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof clearWorkItemDispatchApiV1SoftwareFactoryWorkItemsItemIdClearDispatchPost
        >
      >,
      TError,
      {
        itemId: string;
        data: ClearWorkItemDispatchApiV1SoftwareFactoryWorkItemsItemIdClearDispatchPostBody;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof clearWorkItemDispatchApiV1SoftwareFactoryWorkItemsItemIdClearDispatchPost
      >
    >,
    TError,
    {
      itemId: string;
      data: ClearWorkItemDispatchApiV1SoftwareFactoryWorkItemsItemIdClearDispatchPostBody;
    },
    TContext
  > => {
    const mutationKey = [
      'clearWorkItemDispatchApiV1SoftwareFactoryWorkItemsItemIdClearDispatchPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof clearWorkItemDispatchApiV1SoftwareFactoryWorkItemsItemIdClearDispatchPost
        >
      >,
      {
        itemId: string;
        data: ClearWorkItemDispatchApiV1SoftwareFactoryWorkItemsItemIdClearDispatchPostBody;
      }
    > = (props) => {
      const { itemId, data } = props ?? {};

      return clearWorkItemDispatchApiV1SoftwareFactoryWorkItemsItemIdClearDispatchPost(
        itemId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ClearWorkItemDispatchApiV1SoftwareFactoryWorkItemsItemIdClearDispatchPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof clearWorkItemDispatchApiV1SoftwareFactoryWorkItemsItemIdClearDispatchPost
      >
    >
  >;
export type ClearWorkItemDispatchApiV1SoftwareFactoryWorkItemsItemIdClearDispatchPostMutationBody =
  ClearWorkItemDispatchApiV1SoftwareFactoryWorkItemsItemIdClearDispatchPostBody;
export type ClearWorkItemDispatchApiV1SoftwareFactoryWorkItemsItemIdClearDispatchPostMutationError =
  HTTPValidationError;

/**
 * @summary Clear Work Item Dispatch
 */
export const useClearWorkItemDispatchApiV1SoftwareFactoryWorkItemsItemIdClearDispatchPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof clearWorkItemDispatchApiV1SoftwareFactoryWorkItemsItemIdClearDispatchPost
          >
        >,
        TError,
        {
          itemId: string;
          data: ClearWorkItemDispatchApiV1SoftwareFactoryWorkItemsItemIdClearDispatchPostBody;
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof clearWorkItemDispatchApiV1SoftwareFactoryWorkItemsItemIdClearDispatchPost
      >
    >,
    TError,
    {
      itemId: string;
      data: ClearWorkItemDispatchApiV1SoftwareFactoryWorkItemsItemIdClearDispatchPostBody;
    },
    TContext
  > => {
    const mutationOptions =
      getClearWorkItemDispatchApiV1SoftwareFactoryWorkItemsItemIdClearDispatchPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Record that work items are now LIVE and stable in production (deploy barrier).

Stamps ``deployed_at`` idempotently on the given items — the deploy-barrier
release that lets any contract WI gated on them (via ``deploy_blocked_by``)
become dispatchable. Called by the deploy pipeline after an ECS rollout reaches
steady-state on a SHA whose commit range includes these items (see
.github/workflows/deploy.yml → "Record deployed work items"). Re-running is a
no-op (only not-yet-deployed items are touched).

Multi-repo: each repository has its own recorder, so an id whose module belongs to
a repository other than the caller's ``repository`` is refused — absent from
``confirmed``, which the recorder's ``confirmed_count == sent`` check already treats
as fail-closed. ``deployed_sha`` and the resolved repository are stored on the row
as evidence of which build made the item live.

Auth: an API key carrying ``software_factory:write`` — and ONLY that. It used to
admit any JWT as well, because ``require_scope`` grants every scope to an
interactive session; on an endpoint with no interactive caller that arm was the
whole authorization, and ``work_item_ids`` carries no ReBAC of its own, so any
authenticated member of the tenant could stamp ``deployed_at``, release
``deploy_blocked_by`` barriers, emit ``work_item.deployed``, and read
``marked_deployed`` / ``confirmed`` back as an existence oracle over
``sf_work_items`` (WI 7632207d).

A far-side FILTER on the ids would have been the wrong fix and would have broken
the only legitimate caller: `SF_DEPLOY_BARRIER_API_KEY` holds no
``access_tuples``, so a filter drops every id and wedges the deploy barrier
permanently. Narrowing the auth costs the CI recorder nothing — the scope check
below already applied to it, so a key that works today necessarily carries the
scope, and nothing else calls this route (no frontend consumer, no MCP tool).

Set-based: bounded to 500 ids per call; CI batches one push's worth of WIs.
 * @summary Mark Work Items Deployed
 */
export const markWorkItemsDeployedApiV1SoftwareFactoryWorkItemsMarkDeployedPost =
  (markDeployedRequest: MarkDeployedRequest, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/work-items/mark-deployed`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: markDeployedRequest,
      signal
    });
  };

export const getMarkWorkItemsDeployedApiV1SoftwareFactoryWorkItemsMarkDeployedPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof markWorkItemsDeployedApiV1SoftwareFactoryWorkItemsMarkDeployedPost
        >
      >,
      TError,
      { data: MarkDeployedRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof markWorkItemsDeployedApiV1SoftwareFactoryWorkItemsMarkDeployedPost
      >
    >,
    TError,
    { data: MarkDeployedRequest },
    TContext
  > => {
    const mutationKey = [
      'markWorkItemsDeployedApiV1SoftwareFactoryWorkItemsMarkDeployedPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof markWorkItemsDeployedApiV1SoftwareFactoryWorkItemsMarkDeployedPost
        >
      >,
      { data: MarkDeployedRequest }
    > = (props) => {
      const { data } = props ?? {};

      return markWorkItemsDeployedApiV1SoftwareFactoryWorkItemsMarkDeployedPost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type MarkWorkItemsDeployedApiV1SoftwareFactoryWorkItemsMarkDeployedPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof markWorkItemsDeployedApiV1SoftwareFactoryWorkItemsMarkDeployedPost
      >
    >
  >;
export type MarkWorkItemsDeployedApiV1SoftwareFactoryWorkItemsMarkDeployedPostMutationBody =
  MarkDeployedRequest;
export type MarkWorkItemsDeployedApiV1SoftwareFactoryWorkItemsMarkDeployedPostMutationError =
  HTTPValidationError;

/**
 * @summary Mark Work Items Deployed
 */
export const useMarkWorkItemsDeployedApiV1SoftwareFactoryWorkItemsMarkDeployedPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof markWorkItemsDeployedApiV1SoftwareFactoryWorkItemsMarkDeployedPost
          >
        >,
        TError,
        { data: MarkDeployedRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof markWorkItemsDeployedApiV1SoftwareFactoryWorkItemsMarkDeployedPost
      >
    >,
    TError,
    { data: MarkDeployedRequest },
    TContext
  > => {
    const mutationOptions =
      getMarkWorkItemsDeployedApiV1SoftwareFactoryWorkItemsMarkDeployedPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List immediate children of a work item.
 * @summary List Work Item Children
 */
export const listWorkItemChildrenApiV1SoftwareFactoryWorkItemsItemIdChildrenGet =
  (
    itemId: string,
    params?: ListWorkItemChildrenApiV1SoftwareFactoryWorkItemsItemIdChildrenGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/work-items/${itemId}/children`,
      method: 'GET',
      params,
      signal
    });
  };

export const getListWorkItemChildrenApiV1SoftwareFactoryWorkItemsItemIdChildrenGetQueryKey =
  (
    itemId?: string,
    params?: ListWorkItemChildrenApiV1SoftwareFactoryWorkItemsItemIdChildrenGetParams
  ) => {
    return [
      `/api/v1/software-factory/work-items/${itemId}/children`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListWorkItemChildrenApiV1SoftwareFactoryWorkItemsItemIdChildrenGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listWorkItemChildrenApiV1SoftwareFactoryWorkItemsItemIdChildrenGet
      >
    >,
    TError = HTTPValidationError
  >(
    itemId: string,
    params?: ListWorkItemChildrenApiV1SoftwareFactoryWorkItemsItemIdChildrenGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listWorkItemChildrenApiV1SoftwareFactoryWorkItemsItemIdChildrenGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListWorkItemChildrenApiV1SoftwareFactoryWorkItemsItemIdChildrenGetQueryKey(
        itemId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listWorkItemChildrenApiV1SoftwareFactoryWorkItemsItemIdChildrenGet
        >
      >
    > = ({ signal }) =>
      listWorkItemChildrenApiV1SoftwareFactoryWorkItemsItemIdChildrenGet(
        itemId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!itemId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listWorkItemChildrenApiV1SoftwareFactoryWorkItemsItemIdChildrenGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListWorkItemChildrenApiV1SoftwareFactoryWorkItemsItemIdChildrenGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listWorkItemChildrenApiV1SoftwareFactoryWorkItemsItemIdChildrenGet
      >
    >
  >;
export type ListWorkItemChildrenApiV1SoftwareFactoryWorkItemsItemIdChildrenGetQueryError =
  HTTPValidationError;

export function useListWorkItemChildrenApiV1SoftwareFactoryWorkItemsItemIdChildrenGet<
  TData = Awaited<
    ReturnType<
      typeof listWorkItemChildrenApiV1SoftwareFactoryWorkItemsItemIdChildrenGet
    >
  >,
  TError = HTTPValidationError
>(
  itemId: string,
  params:
    | undefined
    | ListWorkItemChildrenApiV1SoftwareFactoryWorkItemsItemIdChildrenGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listWorkItemChildrenApiV1SoftwareFactoryWorkItemsItemIdChildrenGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listWorkItemChildrenApiV1SoftwareFactoryWorkItemsItemIdChildrenGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listWorkItemChildrenApiV1SoftwareFactoryWorkItemsItemIdChildrenGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListWorkItemChildrenApiV1SoftwareFactoryWorkItemsItemIdChildrenGet<
  TData = Awaited<
    ReturnType<
      typeof listWorkItemChildrenApiV1SoftwareFactoryWorkItemsItemIdChildrenGet
    >
  >,
  TError = HTTPValidationError
>(
  itemId: string,
  params?: ListWorkItemChildrenApiV1SoftwareFactoryWorkItemsItemIdChildrenGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listWorkItemChildrenApiV1SoftwareFactoryWorkItemsItemIdChildrenGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listWorkItemChildrenApiV1SoftwareFactoryWorkItemsItemIdChildrenGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listWorkItemChildrenApiV1SoftwareFactoryWorkItemsItemIdChildrenGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListWorkItemChildrenApiV1SoftwareFactoryWorkItemsItemIdChildrenGet<
  TData = Awaited<
    ReturnType<
      typeof listWorkItemChildrenApiV1SoftwareFactoryWorkItemsItemIdChildrenGet
    >
  >,
  TError = HTTPValidationError
>(
  itemId: string,
  params?: ListWorkItemChildrenApiV1SoftwareFactoryWorkItemsItemIdChildrenGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listWorkItemChildrenApiV1SoftwareFactoryWorkItemsItemIdChildrenGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Work Item Children
 */

export function useListWorkItemChildrenApiV1SoftwareFactoryWorkItemsItemIdChildrenGet<
  TData = Awaited<
    ReturnType<
      typeof listWorkItemChildrenApiV1SoftwareFactoryWorkItemsItemIdChildrenGet
    >
  >,
  TError = HTTPValidationError
>(
  itemId: string,
  params?: ListWorkItemChildrenApiV1SoftwareFactoryWorkItemsItemIdChildrenGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listWorkItemChildrenApiV1SoftwareFactoryWorkItemsItemIdChildrenGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListWorkItemChildrenApiV1SoftwareFactoryWorkItemsItemIdChildrenGetQueryOptions(
      itemId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get all commits linked to a work item.
 * @summary Get Work Item Commits
 */
export const getWorkItemCommitsApiV1SoftwareFactoryWorkItemsItemIdCommitsGet = (
  itemId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/software-factory/work-items/${itemId}/commits`,
    method: 'GET',
    signal
  });
};

export const getGetWorkItemCommitsApiV1SoftwareFactoryWorkItemsItemIdCommitsGetQueryKey =
  (itemId?: string) => {
    return [`/api/v1/software-factory/work-items/${itemId}/commits`] as const;
  };

export const getGetWorkItemCommitsApiV1SoftwareFactoryWorkItemsItemIdCommitsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getWorkItemCommitsApiV1SoftwareFactoryWorkItemsItemIdCommitsGet
      >
    >,
    TError = HTTPValidationError
  >(
    itemId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getWorkItemCommitsApiV1SoftwareFactoryWorkItemsItemIdCommitsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetWorkItemCommitsApiV1SoftwareFactoryWorkItemsItemIdCommitsGetQueryKey(
        itemId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getWorkItemCommitsApiV1SoftwareFactoryWorkItemsItemIdCommitsGet
        >
      >
    > = ({ signal }) =>
      getWorkItemCommitsApiV1SoftwareFactoryWorkItemsItemIdCommitsGet(
        itemId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!itemId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getWorkItemCommitsApiV1SoftwareFactoryWorkItemsItemIdCommitsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetWorkItemCommitsApiV1SoftwareFactoryWorkItemsItemIdCommitsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getWorkItemCommitsApiV1SoftwareFactoryWorkItemsItemIdCommitsGet
      >
    >
  >;
export type GetWorkItemCommitsApiV1SoftwareFactoryWorkItemsItemIdCommitsGetQueryError =
  HTTPValidationError;

export function useGetWorkItemCommitsApiV1SoftwareFactoryWorkItemsItemIdCommitsGet<
  TData = Awaited<
    ReturnType<
      typeof getWorkItemCommitsApiV1SoftwareFactoryWorkItemsItemIdCommitsGet
    >
  >,
  TError = HTTPValidationError
>(
  itemId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getWorkItemCommitsApiV1SoftwareFactoryWorkItemsItemIdCommitsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getWorkItemCommitsApiV1SoftwareFactoryWorkItemsItemIdCommitsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getWorkItemCommitsApiV1SoftwareFactoryWorkItemsItemIdCommitsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetWorkItemCommitsApiV1SoftwareFactoryWorkItemsItemIdCommitsGet<
  TData = Awaited<
    ReturnType<
      typeof getWorkItemCommitsApiV1SoftwareFactoryWorkItemsItemIdCommitsGet
    >
  >,
  TError = HTTPValidationError
>(
  itemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getWorkItemCommitsApiV1SoftwareFactoryWorkItemsItemIdCommitsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getWorkItemCommitsApiV1SoftwareFactoryWorkItemsItemIdCommitsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getWorkItemCommitsApiV1SoftwareFactoryWorkItemsItemIdCommitsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetWorkItemCommitsApiV1SoftwareFactoryWorkItemsItemIdCommitsGet<
  TData = Awaited<
    ReturnType<
      typeof getWorkItemCommitsApiV1SoftwareFactoryWorkItemsItemIdCommitsGet
    >
  >,
  TError = HTTPValidationError
>(
  itemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getWorkItemCommitsApiV1SoftwareFactoryWorkItemsItemIdCommitsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Work Item Commits
 */

export function useGetWorkItemCommitsApiV1SoftwareFactoryWorkItemsItemIdCommitsGet<
  TData = Awaited<
    ReturnType<
      typeof getWorkItemCommitsApiV1SoftwareFactoryWorkItemsItemIdCommitsGet
    >
  >,
  TError = HTTPValidationError
>(
  itemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getWorkItemCommitsApiV1SoftwareFactoryWorkItemsItemIdCommitsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetWorkItemCommitsApiV1SoftwareFactoryWorkItemsItemIdCommitsGetQueryOptions(
      itemId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Link one or more git commit SHAs to a work item.

Can be called at any time — during shipping, after shipping, or while in progress.
Duplicate SHAs are silently ignored.
 * @summary Link Commits To Work Item
 */
export const linkCommitsToWorkItemApiV1SoftwareFactoryWorkItemsItemIdCommitsPost =
  (
    itemId: string,
    linkCommitsRequest: LinkCommitsRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/work-items/${itemId}/commits`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: linkCommitsRequest,
      signal
    });
  };

export const getLinkCommitsToWorkItemApiV1SoftwareFactoryWorkItemsItemIdCommitsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof linkCommitsToWorkItemApiV1SoftwareFactoryWorkItemsItemIdCommitsPost
        >
      >,
      TError,
      { itemId: string; data: LinkCommitsRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof linkCommitsToWorkItemApiV1SoftwareFactoryWorkItemsItemIdCommitsPost
      >
    >,
    TError,
    { itemId: string; data: LinkCommitsRequest },
    TContext
  > => {
    const mutationKey = [
      'linkCommitsToWorkItemApiV1SoftwareFactoryWorkItemsItemIdCommitsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof linkCommitsToWorkItemApiV1SoftwareFactoryWorkItemsItemIdCommitsPost
        >
      >,
      { itemId: string; data: LinkCommitsRequest }
    > = (props) => {
      const { itemId, data } = props ?? {};

      return linkCommitsToWorkItemApiV1SoftwareFactoryWorkItemsItemIdCommitsPost(
        itemId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type LinkCommitsToWorkItemApiV1SoftwareFactoryWorkItemsItemIdCommitsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof linkCommitsToWorkItemApiV1SoftwareFactoryWorkItemsItemIdCommitsPost
      >
    >
  >;
export type LinkCommitsToWorkItemApiV1SoftwareFactoryWorkItemsItemIdCommitsPostMutationBody =
  LinkCommitsRequest;
export type LinkCommitsToWorkItemApiV1SoftwareFactoryWorkItemsItemIdCommitsPostMutationError =
  HTTPValidationError;

/**
 * @summary Link Commits To Work Item
 */
export const useLinkCommitsToWorkItemApiV1SoftwareFactoryWorkItemsItemIdCommitsPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof linkCommitsToWorkItemApiV1SoftwareFactoryWorkItemsItemIdCommitsPost
          >
        >,
        TError,
        { itemId: string; data: LinkCommitsRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof linkCommitsToWorkItemApiV1SoftwareFactoryWorkItemsItemIdCommitsPost
      >
    >,
    TError,
    { itemId: string; data: LinkCommitsRequest },
    TContext
  > => {
    const mutationOptions =
      getLinkCommitsToWorkItemApiV1SoftwareFactoryWorkItemsItemIdCommitsPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Remove the link between a commit SHA and a work item.
 * @summary Unlink Commit From Work Item
 */
export const unlinkCommitFromWorkItemApiV1SoftwareFactoryWorkItemsItemIdCommitsShaDelete =
  (itemId: string, sha: string) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/work-items/${itemId}/commits/${sha}`,
      method: 'DELETE'
    });
  };

export const getUnlinkCommitFromWorkItemApiV1SoftwareFactoryWorkItemsItemIdCommitsShaDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof unlinkCommitFromWorkItemApiV1SoftwareFactoryWorkItemsItemIdCommitsShaDelete
        >
      >,
      TError,
      { itemId: string; sha: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof unlinkCommitFromWorkItemApiV1SoftwareFactoryWorkItemsItemIdCommitsShaDelete
      >
    >,
    TError,
    { itemId: string; sha: string },
    TContext
  > => {
    const mutationKey = [
      'unlinkCommitFromWorkItemApiV1SoftwareFactoryWorkItemsItemIdCommitsShaDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof unlinkCommitFromWorkItemApiV1SoftwareFactoryWorkItemsItemIdCommitsShaDelete
        >
      >,
      { itemId: string; sha: string }
    > = (props) => {
      const { itemId, sha } = props ?? {};

      return unlinkCommitFromWorkItemApiV1SoftwareFactoryWorkItemsItemIdCommitsShaDelete(
        itemId,
        sha
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UnlinkCommitFromWorkItemApiV1SoftwareFactoryWorkItemsItemIdCommitsShaDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof unlinkCommitFromWorkItemApiV1SoftwareFactoryWorkItemsItemIdCommitsShaDelete
      >
    >
  >;

export type UnlinkCommitFromWorkItemApiV1SoftwareFactoryWorkItemsItemIdCommitsShaDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Unlink Commit From Work Item
 */
export const useUnlinkCommitFromWorkItemApiV1SoftwareFactoryWorkItemsItemIdCommitsShaDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof unlinkCommitFromWorkItemApiV1SoftwareFactoryWorkItemsItemIdCommitsShaDelete
          >
        >,
        TError,
        { itemId: string; sha: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof unlinkCommitFromWorkItemApiV1SoftwareFactoryWorkItemsItemIdCommitsShaDelete
      >
    >,
    TError,
    { itemId: string; sha: string },
    TContext
  > => {
    const mutationOptions =
      getUnlinkCommitFromWorkItemApiV1SoftwareFactoryWorkItemsItemIdCommitsShaDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List customer (company/contact) associations on a work item.
 * @summary List Work Item Customers
 */
export const listWorkItemCustomersApiV1SoftwareFactoryWorkItemsItemIdCustomersGet =
  (itemId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/work-items/${itemId}/customers`,
      method: 'GET',
      signal
    });
  };

export const getListWorkItemCustomersApiV1SoftwareFactoryWorkItemsItemIdCustomersGetQueryKey =
  (itemId?: string) => {
    return [`/api/v1/software-factory/work-items/${itemId}/customers`] as const;
  };

export const getListWorkItemCustomersApiV1SoftwareFactoryWorkItemsItemIdCustomersGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listWorkItemCustomersApiV1SoftwareFactoryWorkItemsItemIdCustomersGet
      >
    >,
    TError = HTTPValidationError
  >(
    itemId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listWorkItemCustomersApiV1SoftwareFactoryWorkItemsItemIdCustomersGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListWorkItemCustomersApiV1SoftwareFactoryWorkItemsItemIdCustomersGetQueryKey(
        itemId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listWorkItemCustomersApiV1SoftwareFactoryWorkItemsItemIdCustomersGet
        >
      >
    > = ({ signal }) =>
      listWorkItemCustomersApiV1SoftwareFactoryWorkItemsItemIdCustomersGet(
        itemId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!itemId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listWorkItemCustomersApiV1SoftwareFactoryWorkItemsItemIdCustomersGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListWorkItemCustomersApiV1SoftwareFactoryWorkItemsItemIdCustomersGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listWorkItemCustomersApiV1SoftwareFactoryWorkItemsItemIdCustomersGet
      >
    >
  >;
export type ListWorkItemCustomersApiV1SoftwareFactoryWorkItemsItemIdCustomersGetQueryError =
  HTTPValidationError;

export function useListWorkItemCustomersApiV1SoftwareFactoryWorkItemsItemIdCustomersGet<
  TData = Awaited<
    ReturnType<
      typeof listWorkItemCustomersApiV1SoftwareFactoryWorkItemsItemIdCustomersGet
    >
  >,
  TError = HTTPValidationError
>(
  itemId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listWorkItemCustomersApiV1SoftwareFactoryWorkItemsItemIdCustomersGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listWorkItemCustomersApiV1SoftwareFactoryWorkItemsItemIdCustomersGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listWorkItemCustomersApiV1SoftwareFactoryWorkItemsItemIdCustomersGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListWorkItemCustomersApiV1SoftwareFactoryWorkItemsItemIdCustomersGet<
  TData = Awaited<
    ReturnType<
      typeof listWorkItemCustomersApiV1SoftwareFactoryWorkItemsItemIdCustomersGet
    >
  >,
  TError = HTTPValidationError
>(
  itemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listWorkItemCustomersApiV1SoftwareFactoryWorkItemsItemIdCustomersGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listWorkItemCustomersApiV1SoftwareFactoryWorkItemsItemIdCustomersGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listWorkItemCustomersApiV1SoftwareFactoryWorkItemsItemIdCustomersGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListWorkItemCustomersApiV1SoftwareFactoryWorkItemsItemIdCustomersGet<
  TData = Awaited<
    ReturnType<
      typeof listWorkItemCustomersApiV1SoftwareFactoryWorkItemsItemIdCustomersGet
    >
  >,
  TError = HTTPValidationError
>(
  itemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listWorkItemCustomersApiV1SoftwareFactoryWorkItemsItemIdCustomersGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Work Item Customers
 */

export function useListWorkItemCustomersApiV1SoftwareFactoryWorkItemsItemIdCustomersGet<
  TData = Awaited<
    ReturnType<
      typeof listWorkItemCustomersApiV1SoftwareFactoryWorkItemsItemIdCustomersGet
    >
  >,
  TError = HTTPValidationError
>(
  itemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listWorkItemCustomersApiV1SoftwareFactoryWorkItemsItemIdCustomersGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListWorkItemCustomersApiV1SoftwareFactoryWorkItemsItemIdCustomersGetQueryOptions(
      itemId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Manually add a customer (company/contact) or sales deal to a work item.
 * @summary Add Work Item Customer
 */
export const addWorkItemCustomerApiV1SoftwareFactoryWorkItemsItemIdCustomersPost =
  (
    itemId: string,
    addWorkItemCustomerRequest: AddWorkItemCustomerRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/work-items/${itemId}/customers`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: addWorkItemCustomerRequest,
      signal
    });
  };

export const getAddWorkItemCustomerApiV1SoftwareFactoryWorkItemsItemIdCustomersPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof addWorkItemCustomerApiV1SoftwareFactoryWorkItemsItemIdCustomersPost
        >
      >,
      TError,
      { itemId: string; data: AddWorkItemCustomerRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof addWorkItemCustomerApiV1SoftwareFactoryWorkItemsItemIdCustomersPost
      >
    >,
    TError,
    { itemId: string; data: AddWorkItemCustomerRequest },
    TContext
  > => {
    const mutationKey = [
      'addWorkItemCustomerApiV1SoftwareFactoryWorkItemsItemIdCustomersPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof addWorkItemCustomerApiV1SoftwareFactoryWorkItemsItemIdCustomersPost
        >
      >,
      { itemId: string; data: AddWorkItemCustomerRequest }
    > = (props) => {
      const { itemId, data } = props ?? {};

      return addWorkItemCustomerApiV1SoftwareFactoryWorkItemsItemIdCustomersPost(
        itemId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AddWorkItemCustomerApiV1SoftwareFactoryWorkItemsItemIdCustomersPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof addWorkItemCustomerApiV1SoftwareFactoryWorkItemsItemIdCustomersPost
      >
    >
  >;
export type AddWorkItemCustomerApiV1SoftwareFactoryWorkItemsItemIdCustomersPostMutationBody =
  AddWorkItemCustomerRequest;
export type AddWorkItemCustomerApiV1SoftwareFactoryWorkItemsItemIdCustomersPostMutationError =
  HTTPValidationError;

/**
 * @summary Add Work Item Customer
 */
export const useAddWorkItemCustomerApiV1SoftwareFactoryWorkItemsItemIdCustomersPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof addWorkItemCustomerApiV1SoftwareFactoryWorkItemsItemIdCustomersPost
          >
        >,
        TError,
        { itemId: string; data: AddWorkItemCustomerRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof addWorkItemCustomerApiV1SoftwareFactoryWorkItemsItemIdCustomersPost
      >
    >,
    TError,
    { itemId: string; data: AddWorkItemCustomerRequest },
    TContext
  > => {
    const mutationOptions =
      getAddWorkItemCustomerApiV1SoftwareFactoryWorkItemsItemIdCustomersPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Remove a customer association from a work item.
 * @summary Remove Work Item Customer
 */
export const removeWorkItemCustomerApiV1SoftwareFactoryWorkItemsItemIdCustomersCustomerIdDelete =
  (itemId: string, customerId: string) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/work-items/${itemId}/customers/${customerId}`,
      method: 'DELETE'
    });
  };

export const getRemoveWorkItemCustomerApiV1SoftwareFactoryWorkItemsItemIdCustomersCustomerIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof removeWorkItemCustomerApiV1SoftwareFactoryWorkItemsItemIdCustomersCustomerIdDelete
        >
      >,
      TError,
      { itemId: string; customerId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof removeWorkItemCustomerApiV1SoftwareFactoryWorkItemsItemIdCustomersCustomerIdDelete
      >
    >,
    TError,
    { itemId: string; customerId: string },
    TContext
  > => {
    const mutationKey = [
      'removeWorkItemCustomerApiV1SoftwareFactoryWorkItemsItemIdCustomersCustomerIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof removeWorkItemCustomerApiV1SoftwareFactoryWorkItemsItemIdCustomersCustomerIdDelete
        >
      >,
      { itemId: string; customerId: string }
    > = (props) => {
      const { itemId, customerId } = props ?? {};

      return removeWorkItemCustomerApiV1SoftwareFactoryWorkItemsItemIdCustomersCustomerIdDelete(
        itemId,
        customerId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RemoveWorkItemCustomerApiV1SoftwareFactoryWorkItemsItemIdCustomersCustomerIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof removeWorkItemCustomerApiV1SoftwareFactoryWorkItemsItemIdCustomersCustomerIdDelete
      >
    >
  >;

export type RemoveWorkItemCustomerApiV1SoftwareFactoryWorkItemsItemIdCustomersCustomerIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Remove Work Item Customer
 */
export const useRemoveWorkItemCustomerApiV1SoftwareFactoryWorkItemsItemIdCustomersCustomerIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof removeWorkItemCustomerApiV1SoftwareFactoryWorkItemsItemIdCustomersCustomerIdDelete
          >
        >,
        TError,
        { itemId: string; customerId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof removeWorkItemCustomerApiV1SoftwareFactoryWorkItemsItemIdCustomersCustomerIdDelete
      >
    >,
    TError,
    { itemId: string; customerId: string },
    TContext
  > => {
    const mutationOptions =
      getRemoveWorkItemCustomerApiV1SoftwareFactoryWorkItemsItemIdCustomersCustomerIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Get the support ticket linked to this work item, if any.
 * @summary Get Linked Ticket
 */
export const getLinkedTicketApiV1SoftwareFactoryWorkItemsItemIdLinkedTicketGet =
  (itemId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/work-items/${itemId}/linked-ticket`,
      method: 'GET',
      signal
    });
  };

export const getGetLinkedTicketApiV1SoftwareFactoryWorkItemsItemIdLinkedTicketGetQueryKey =
  (itemId?: string) => {
    return [
      `/api/v1/software-factory/work-items/${itemId}/linked-ticket`
    ] as const;
  };

export const getGetLinkedTicketApiV1SoftwareFactoryWorkItemsItemIdLinkedTicketGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getLinkedTicketApiV1SoftwareFactoryWorkItemsItemIdLinkedTicketGet
      >
    >,
    TError = HTTPValidationError
  >(
    itemId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getLinkedTicketApiV1SoftwareFactoryWorkItemsItemIdLinkedTicketGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetLinkedTicketApiV1SoftwareFactoryWorkItemsItemIdLinkedTicketGetQueryKey(
        itemId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getLinkedTicketApiV1SoftwareFactoryWorkItemsItemIdLinkedTicketGet
        >
      >
    > = ({ signal }) =>
      getLinkedTicketApiV1SoftwareFactoryWorkItemsItemIdLinkedTicketGet(
        itemId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!itemId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getLinkedTicketApiV1SoftwareFactoryWorkItemsItemIdLinkedTicketGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetLinkedTicketApiV1SoftwareFactoryWorkItemsItemIdLinkedTicketGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getLinkedTicketApiV1SoftwareFactoryWorkItemsItemIdLinkedTicketGet
      >
    >
  >;
export type GetLinkedTicketApiV1SoftwareFactoryWorkItemsItemIdLinkedTicketGetQueryError =
  HTTPValidationError;

export function useGetLinkedTicketApiV1SoftwareFactoryWorkItemsItemIdLinkedTicketGet<
  TData = Awaited<
    ReturnType<
      typeof getLinkedTicketApiV1SoftwareFactoryWorkItemsItemIdLinkedTicketGet
    >
  >,
  TError = HTTPValidationError
>(
  itemId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLinkedTicketApiV1SoftwareFactoryWorkItemsItemIdLinkedTicketGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getLinkedTicketApiV1SoftwareFactoryWorkItemsItemIdLinkedTicketGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getLinkedTicketApiV1SoftwareFactoryWorkItemsItemIdLinkedTicketGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetLinkedTicketApiV1SoftwareFactoryWorkItemsItemIdLinkedTicketGet<
  TData = Awaited<
    ReturnType<
      typeof getLinkedTicketApiV1SoftwareFactoryWorkItemsItemIdLinkedTicketGet
    >
  >,
  TError = HTTPValidationError
>(
  itemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLinkedTicketApiV1SoftwareFactoryWorkItemsItemIdLinkedTicketGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getLinkedTicketApiV1SoftwareFactoryWorkItemsItemIdLinkedTicketGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getLinkedTicketApiV1SoftwareFactoryWorkItemsItemIdLinkedTicketGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetLinkedTicketApiV1SoftwareFactoryWorkItemsItemIdLinkedTicketGet<
  TData = Awaited<
    ReturnType<
      typeof getLinkedTicketApiV1SoftwareFactoryWorkItemsItemIdLinkedTicketGet
    >
  >,
  TError = HTTPValidationError
>(
  itemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLinkedTicketApiV1SoftwareFactoryWorkItemsItemIdLinkedTicketGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Linked Ticket
 */

export function useGetLinkedTicketApiV1SoftwareFactoryWorkItemsItemIdLinkedTicketGet<
  TData = Awaited<
    ReturnType<
      typeof getLinkedTicketApiV1SoftwareFactoryWorkItemsItemIdLinkedTicketGet
    >
  >,
  TError = HTTPValidationError
>(
  itemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getLinkedTicketApiV1SoftwareFactoryWorkItemsItemIdLinkedTicketGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetLinkedTicketApiV1SoftwareFactoryWorkItemsItemIdLinkedTicketGetQueryOptions(
      itemId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List Tasks-sprint tasks linked to this work item (the sprint bridge).
 * @summary List Work Item Linked Tasks
 */
export const listWorkItemLinkedTasksApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksGet =
  (itemId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/work-items/${itemId}/linked-tasks`,
      method: 'GET',
      signal
    });
  };

export const getListWorkItemLinkedTasksApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksGetQueryKey =
  (itemId?: string) => {
    return [
      `/api/v1/software-factory/work-items/${itemId}/linked-tasks`
    ] as const;
  };

export const getListWorkItemLinkedTasksApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listWorkItemLinkedTasksApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksGet
      >
    >,
    TError = HTTPValidationError
  >(
    itemId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listWorkItemLinkedTasksApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListWorkItemLinkedTasksApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksGetQueryKey(
        itemId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listWorkItemLinkedTasksApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksGet
        >
      >
    > = ({ signal }) =>
      listWorkItemLinkedTasksApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksGet(
        itemId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!itemId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listWorkItemLinkedTasksApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListWorkItemLinkedTasksApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listWorkItemLinkedTasksApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksGet
      >
    >
  >;
export type ListWorkItemLinkedTasksApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksGetQueryError =
  HTTPValidationError;

export function useListWorkItemLinkedTasksApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksGet<
  TData = Awaited<
    ReturnType<
      typeof listWorkItemLinkedTasksApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksGet
    >
  >,
  TError = HTTPValidationError
>(
  itemId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listWorkItemLinkedTasksApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listWorkItemLinkedTasksApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listWorkItemLinkedTasksApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListWorkItemLinkedTasksApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksGet<
  TData = Awaited<
    ReturnType<
      typeof listWorkItemLinkedTasksApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksGet
    >
  >,
  TError = HTTPValidationError
>(
  itemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listWorkItemLinkedTasksApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listWorkItemLinkedTasksApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listWorkItemLinkedTasksApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListWorkItemLinkedTasksApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksGet<
  TData = Awaited<
    ReturnType<
      typeof listWorkItemLinkedTasksApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksGet
    >
  >,
  TError = HTTPValidationError
>(
  itemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listWorkItemLinkedTasksApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Work Item Linked Tasks
 */

export function useListWorkItemLinkedTasksApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksGet<
  TData = Awaited<
    ReturnType<
      typeof listWorkItemLinkedTasksApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksGet
    >
  >,
  TError = HTTPValidationError
>(
  itemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listWorkItemLinkedTasksApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListWorkItemLinkedTasksApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksGetQueryOptions(
      itemId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Schedule a work item into a sprint: create a linked Task on a sprint board.
 * @summary Schedule Work Item Into Sprint
 */
export const scheduleWorkItemIntoSprintApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksPost =
  (
    itemId: string,
    scheduleIntoSprintRequest: ScheduleIntoSprintRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/work-items/${itemId}/linked-tasks`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: scheduleIntoSprintRequest,
      signal
    });
  };

export const getScheduleWorkItemIntoSprintApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof scheduleWorkItemIntoSprintApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksPost
        >
      >,
      TError,
      { itemId: string; data: ScheduleIntoSprintRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof scheduleWorkItemIntoSprintApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksPost
      >
    >,
    TError,
    { itemId: string; data: ScheduleIntoSprintRequest },
    TContext
  > => {
    const mutationKey = [
      'scheduleWorkItemIntoSprintApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof scheduleWorkItemIntoSprintApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksPost
        >
      >,
      { itemId: string; data: ScheduleIntoSprintRequest }
    > = (props) => {
      const { itemId, data } = props ?? {};

      return scheduleWorkItemIntoSprintApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksPost(
        itemId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ScheduleWorkItemIntoSprintApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof scheduleWorkItemIntoSprintApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksPost
      >
    >
  >;
export type ScheduleWorkItemIntoSprintApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksPostMutationBody =
  ScheduleIntoSprintRequest;
export type ScheduleWorkItemIntoSprintApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksPostMutationError =
  HTTPValidationError;

/**
 * @summary Schedule Work Item Into Sprint
 */
export const useScheduleWorkItemIntoSprintApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof scheduleWorkItemIntoSprintApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksPost
          >
        >,
        TError,
        { itemId: string; data: ScheduleIntoSprintRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof scheduleWorkItemIntoSprintApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksPost
      >
    >,
    TError,
    { itemId: string; data: ScheduleIntoSprintRequest },
    TContext
  > => {
    const mutationOptions =
      getScheduleWorkItemIntoSprintApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List the work items this sprint task was scheduled from — the link's OTHER end.

The reverse of ``GET /work-items/{item_id}/linked-tasks``. It exists because the
bridge acts at a distance: `sprint_bridge_handlers` moves the work item to
shipped when this task is completed, and until this route a human closing the
task had no way to know that (WI 1b99410f).

Near side is the TASK, whose visibility is the Tasks module's own answer
(``enforce_task_visible`` — 404 when the caller is not on its board, so absent
and invisible are indistinguishable). Far side is the work items, filtered by
the caller's own work-item sharing scope in the service, so a widely-shared
board never becomes a way to enumerate work items that are not.

It lives on the SOFTWARE FACTORY router because software_factory owns
``sf_work_item_tasks``; the task end reads that junction, it does not own it.
 * @summary List Task Linked Work Items
 */
export const listTaskLinkedWorkItemsApiV1SoftwareFactoryTasksTaskIdWorkItemsGet =
  (taskId: string, signal?: AbortSignal) => {
    return customInstance<TaskLinkedWorkItemListResponse>({
      url: `/api/v1/software-factory/tasks/${taskId}/work-items`,
      method: 'GET',
      signal
    });
  };

export const getListTaskLinkedWorkItemsApiV1SoftwareFactoryTasksTaskIdWorkItemsGetQueryKey =
  (taskId?: string) => {
    return [`/api/v1/software-factory/tasks/${taskId}/work-items`] as const;
  };

export const getListTaskLinkedWorkItemsApiV1SoftwareFactoryTasksTaskIdWorkItemsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listTaskLinkedWorkItemsApiV1SoftwareFactoryTasksTaskIdWorkItemsGet
      >
    >,
    TError = HTTPValidationError
  >(
    taskId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listTaskLinkedWorkItemsApiV1SoftwareFactoryTasksTaskIdWorkItemsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListTaskLinkedWorkItemsApiV1SoftwareFactoryTasksTaskIdWorkItemsGetQueryKey(
        taskId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listTaskLinkedWorkItemsApiV1SoftwareFactoryTasksTaskIdWorkItemsGet
        >
      >
    > = ({ signal }) =>
      listTaskLinkedWorkItemsApiV1SoftwareFactoryTasksTaskIdWorkItemsGet(
        taskId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!taskId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listTaskLinkedWorkItemsApiV1SoftwareFactoryTasksTaskIdWorkItemsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListTaskLinkedWorkItemsApiV1SoftwareFactoryTasksTaskIdWorkItemsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listTaskLinkedWorkItemsApiV1SoftwareFactoryTasksTaskIdWorkItemsGet
      >
    >
  >;
export type ListTaskLinkedWorkItemsApiV1SoftwareFactoryTasksTaskIdWorkItemsGetQueryError =
  HTTPValidationError;

export function useListTaskLinkedWorkItemsApiV1SoftwareFactoryTasksTaskIdWorkItemsGet<
  TData = Awaited<
    ReturnType<
      typeof listTaskLinkedWorkItemsApiV1SoftwareFactoryTasksTaskIdWorkItemsGet
    >
  >,
  TError = HTTPValidationError
>(
  taskId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listTaskLinkedWorkItemsApiV1SoftwareFactoryTasksTaskIdWorkItemsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listTaskLinkedWorkItemsApiV1SoftwareFactoryTasksTaskIdWorkItemsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listTaskLinkedWorkItemsApiV1SoftwareFactoryTasksTaskIdWorkItemsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListTaskLinkedWorkItemsApiV1SoftwareFactoryTasksTaskIdWorkItemsGet<
  TData = Awaited<
    ReturnType<
      typeof listTaskLinkedWorkItemsApiV1SoftwareFactoryTasksTaskIdWorkItemsGet
    >
  >,
  TError = HTTPValidationError
>(
  taskId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listTaskLinkedWorkItemsApiV1SoftwareFactoryTasksTaskIdWorkItemsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listTaskLinkedWorkItemsApiV1SoftwareFactoryTasksTaskIdWorkItemsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listTaskLinkedWorkItemsApiV1SoftwareFactoryTasksTaskIdWorkItemsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListTaskLinkedWorkItemsApiV1SoftwareFactoryTasksTaskIdWorkItemsGet<
  TData = Awaited<
    ReturnType<
      typeof listTaskLinkedWorkItemsApiV1SoftwareFactoryTasksTaskIdWorkItemsGet
    >
  >,
  TError = HTTPValidationError
>(
  taskId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listTaskLinkedWorkItemsApiV1SoftwareFactoryTasksTaskIdWorkItemsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Task Linked Work Items
 */

export function useListTaskLinkedWorkItemsApiV1SoftwareFactoryTasksTaskIdWorkItemsGet<
  TData = Awaited<
    ReturnType<
      typeof listTaskLinkedWorkItemsApiV1SoftwareFactoryTasksTaskIdWorkItemsGet
    >
  >,
  TError = HTTPValidationError
>(
  taskId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listTaskLinkedWorkItemsApiV1SoftwareFactoryTasksTaskIdWorkItemsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListTaskLinkedWorkItemsApiV1SoftwareFactoryTasksTaskIdWorkItemsGetQueryOptions(
      taskId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Remove the link between a work item and a sprint task (the task is kept).
 * @summary Unlink Work Item Task
 */
export const unlinkWorkItemTaskApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksTaskIdDelete =
  (itemId: string, taskId: string) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/work-items/${itemId}/linked-tasks/${taskId}`,
      method: 'DELETE'
    });
  };

export const getUnlinkWorkItemTaskApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksTaskIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof unlinkWorkItemTaskApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksTaskIdDelete
        >
      >,
      TError,
      { itemId: string; taskId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof unlinkWorkItemTaskApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksTaskIdDelete
      >
    >,
    TError,
    { itemId: string; taskId: string },
    TContext
  > => {
    const mutationKey = [
      'unlinkWorkItemTaskApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksTaskIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof unlinkWorkItemTaskApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksTaskIdDelete
        >
      >,
      { itemId: string; taskId: string }
    > = (props) => {
      const { itemId, taskId } = props ?? {};

      return unlinkWorkItemTaskApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksTaskIdDelete(
        itemId,
        taskId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UnlinkWorkItemTaskApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksTaskIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof unlinkWorkItemTaskApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksTaskIdDelete
      >
    >
  >;

export type UnlinkWorkItemTaskApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksTaskIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Unlink Work Item Task
 */
export const useUnlinkWorkItemTaskApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksTaskIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof unlinkWorkItemTaskApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksTaskIdDelete
          >
        >,
        TError,
        { itemId: string; taskId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof unlinkWorkItemTaskApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksTaskIdDelete
      >
    >,
    TError,
    { itemId: string; taskId: string },
    TContext
  > => {
    const mutationOptions =
      getUnlinkWorkItemTaskApiV1SoftwareFactoryWorkItemsItemIdLinkedTasksTaskIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List initiatives (strategic groupings of work items).

Carries BOTH access patterns on one endpoint (ui-list-pages.md § 11): the
server-paged list page passes an explicit `limit`/`offset`, while the roadmap
/ picker consumers omit `limit` and get the full set via `resolve_limit`.
 * @summary List Initiatives
 */
export const listInitiativesApiV1SoftwareFactoryInitiativesGet = (
  params?: ListInitiativesApiV1SoftwareFactoryInitiativesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/software-factory/initiatives`,
    method: 'GET',
    params,
    signal
  });
};

export const getListInitiativesApiV1SoftwareFactoryInitiativesGetQueryKey = (
  params?: ListInitiativesApiV1SoftwareFactoryInitiativesGetParams
) => {
  return [
    `/api/v1/software-factory/initiatives`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListInitiativesApiV1SoftwareFactoryInitiativesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listInitiativesApiV1SoftwareFactoryInitiativesGet>
    >,
    TError = HTTPValidationError
  >(
    params?: ListInitiativesApiV1SoftwareFactoryInitiativesGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<typeof listInitiativesApiV1SoftwareFactoryInitiativesGet>
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListInitiativesApiV1SoftwareFactoryInitiativesGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listInitiativesApiV1SoftwareFactoryInitiativesGet>
      >
    > = ({ signal }) =>
      listInitiativesApiV1SoftwareFactoryInitiativesGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listInitiativesApiV1SoftwareFactoryInitiativesGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListInitiativesApiV1SoftwareFactoryInitiativesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listInitiativesApiV1SoftwareFactoryInitiativesGet>
    >
  >;
export type ListInitiativesApiV1SoftwareFactoryInitiativesGetQueryError =
  HTTPValidationError;

export function useListInitiativesApiV1SoftwareFactoryInitiativesGet<
  TData = Awaited<
    ReturnType<typeof listInitiativesApiV1SoftwareFactoryInitiativesGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListInitiativesApiV1SoftwareFactoryInitiativesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listInitiativesApiV1SoftwareFactoryInitiativesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listInitiativesApiV1SoftwareFactoryInitiativesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listInitiativesApiV1SoftwareFactoryInitiativesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListInitiativesApiV1SoftwareFactoryInitiativesGet<
  TData = Awaited<
    ReturnType<typeof listInitiativesApiV1SoftwareFactoryInitiativesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListInitiativesApiV1SoftwareFactoryInitiativesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listInitiativesApiV1SoftwareFactoryInitiativesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listInitiativesApiV1SoftwareFactoryInitiativesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listInitiativesApiV1SoftwareFactoryInitiativesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListInitiativesApiV1SoftwareFactoryInitiativesGet<
  TData = Awaited<
    ReturnType<typeof listInitiativesApiV1SoftwareFactoryInitiativesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListInitiativesApiV1SoftwareFactoryInitiativesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listInitiativesApiV1SoftwareFactoryInitiativesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Initiatives
 */

export function useListInitiativesApiV1SoftwareFactoryInitiativesGet<
  TData = Awaited<
    ReturnType<typeof listInitiativesApiV1SoftwareFactoryInitiativesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListInitiativesApiV1SoftwareFactoryInitiativesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listInitiativesApiV1SoftwareFactoryInitiativesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListInitiativesApiV1SoftwareFactoryInitiativesGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new initiative to group related work items.
 * @summary Create Initiative
 */
export const createInitiativeApiV1SoftwareFactoryInitiativesPost = (
  createInitiativeApiV1SoftwareFactoryInitiativesPostBody: CreateInitiativeApiV1SoftwareFactoryInitiativesPostBody,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/software-factory/initiatives`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createInitiativeApiV1SoftwareFactoryInitiativesPostBody,
    signal
  });
};

export const getCreateInitiativeApiV1SoftwareFactoryInitiativesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createInitiativeApiV1SoftwareFactoryInitiativesPost>
      >,
      TError,
      { data: CreateInitiativeApiV1SoftwareFactoryInitiativesPostBody },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof createInitiativeApiV1SoftwareFactoryInitiativesPost>
    >,
    TError,
    { data: CreateInitiativeApiV1SoftwareFactoryInitiativesPostBody },
    TContext
  > => {
    const mutationKey = ['createInitiativeApiV1SoftwareFactoryInitiativesPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createInitiativeApiV1SoftwareFactoryInitiativesPost>
      >,
      { data: CreateInitiativeApiV1SoftwareFactoryInitiativesPostBody }
    > = (props) => {
      const { data } = props ?? {};

      return createInitiativeApiV1SoftwareFactoryInitiativesPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateInitiativeApiV1SoftwareFactoryInitiativesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof createInitiativeApiV1SoftwareFactoryInitiativesPost>
    >
  >;
export type CreateInitiativeApiV1SoftwareFactoryInitiativesPostMutationBody =
  CreateInitiativeApiV1SoftwareFactoryInitiativesPostBody;
export type CreateInitiativeApiV1SoftwareFactoryInitiativesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Initiative
 */
export const useCreateInitiativeApiV1SoftwareFactoryInitiativesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createInitiativeApiV1SoftwareFactoryInitiativesPost>
      >,
      TError,
      { data: CreateInitiativeApiV1SoftwareFactoryInitiativesPostBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof createInitiativeApiV1SoftwareFactoryInitiativesPost>
  >,
  TError,
  { data: CreateInitiativeApiV1SoftwareFactoryInitiativesPostBody },
  TContext
> => {
  const mutationOptions =
    getCreateInitiativeApiV1SoftwareFactoryInitiativesPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * List this tenant's Tasks OKR objectives (depth-0 tasks on OKR boards) for
the initiative goal picker. Registered before /initiatives/{initiative_id} so
the literal path isn't swallowed by the UUID route param.
 * @summary List Okr Objectives
 */
export const listOkrObjectivesApiV1SoftwareFactoryInitiativesOkrObjectivesGet =
  (signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/initiatives/okr-objectives`,
      method: 'GET',
      signal
    });
  };

export const getListOkrObjectivesApiV1SoftwareFactoryInitiativesOkrObjectivesGetQueryKey =
  () => {
    return [`/api/v1/software-factory/initiatives/okr-objectives`] as const;
  };

export const getListOkrObjectivesApiV1SoftwareFactoryInitiativesOkrObjectivesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listOkrObjectivesApiV1SoftwareFactoryInitiativesOkrObjectivesGet
      >
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listOkrObjectivesApiV1SoftwareFactoryInitiativesOkrObjectivesGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListOkrObjectivesApiV1SoftwareFactoryInitiativesOkrObjectivesGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listOkrObjectivesApiV1SoftwareFactoryInitiativesOkrObjectivesGet
        >
      >
    > = ({ signal }) =>
      listOkrObjectivesApiV1SoftwareFactoryInitiativesOkrObjectivesGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listOkrObjectivesApiV1SoftwareFactoryInitiativesOkrObjectivesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListOkrObjectivesApiV1SoftwareFactoryInitiativesOkrObjectivesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listOkrObjectivesApiV1SoftwareFactoryInitiativesOkrObjectivesGet
      >
    >
  >;
export type ListOkrObjectivesApiV1SoftwareFactoryInitiativesOkrObjectivesGetQueryError =
  unknown;

export function useListOkrObjectivesApiV1SoftwareFactoryInitiativesOkrObjectivesGet<
  TData = Awaited<
    ReturnType<
      typeof listOkrObjectivesApiV1SoftwareFactoryInitiativesOkrObjectivesGet
    >
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listOkrObjectivesApiV1SoftwareFactoryInitiativesOkrObjectivesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listOkrObjectivesApiV1SoftwareFactoryInitiativesOkrObjectivesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listOkrObjectivesApiV1SoftwareFactoryInitiativesOkrObjectivesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListOkrObjectivesApiV1SoftwareFactoryInitiativesOkrObjectivesGet<
  TData = Awaited<
    ReturnType<
      typeof listOkrObjectivesApiV1SoftwareFactoryInitiativesOkrObjectivesGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listOkrObjectivesApiV1SoftwareFactoryInitiativesOkrObjectivesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listOkrObjectivesApiV1SoftwareFactoryInitiativesOkrObjectivesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listOkrObjectivesApiV1SoftwareFactoryInitiativesOkrObjectivesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListOkrObjectivesApiV1SoftwareFactoryInitiativesOkrObjectivesGet<
  TData = Awaited<
    ReturnType<
      typeof listOkrObjectivesApiV1SoftwareFactoryInitiativesOkrObjectivesGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listOkrObjectivesApiV1SoftwareFactoryInitiativesOkrObjectivesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Okr Objectives
 */

export function useListOkrObjectivesApiV1SoftwareFactoryInitiativesOkrObjectivesGet<
  TData = Awaited<
    ReturnType<
      typeof listOkrObjectivesApiV1SoftwareFactoryInitiativesOkrObjectivesGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listOkrObjectivesApiV1SoftwareFactoryInitiativesOkrObjectivesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListOkrObjectivesApiV1SoftwareFactoryInitiativesOkrObjectivesGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get a single initiative by ID.
 * @summary Get Initiative
 */
export const getInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdGet = (
  initiativeId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/software-factory/initiatives/${initiativeId}`,
    method: 'GET',
    signal
  });
};

export const getGetInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdGetQueryKey =
  (initiativeId?: string) => {
    return [`/api/v1/software-factory/initiatives/${initiativeId}`] as const;
  };

export const getGetInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdGet
      >
    >,
    TError = HTTPValidationError
  >(
    initiativeId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdGetQueryKey(
        initiativeId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdGet
        >
      >
    > = ({ signal }) =>
      getInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdGet(
        initiativeId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!initiativeId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdGet
      >
    >
  >;
export type GetInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdGetQueryError =
  HTTPValidationError;

export function useGetInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdGet<
  TData = Awaited<
    ReturnType<
      typeof getInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdGet
    >
  >,
  TError = HTTPValidationError
>(
  initiativeId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdGet<
  TData = Awaited<
    ReturnType<
      typeof getInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdGet
    >
  >,
  TError = HTTPValidationError
>(
  initiativeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdGet<
  TData = Awaited<
    ReturnType<
      typeof getInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdGet
    >
  >,
  TError = HTTPValidationError
>(
  initiativeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Initiative
 */

export function useGetInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdGet<
  TData = Awaited<
    ReturnType<
      typeof getInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdGet
    >
  >,
  TError = HTTPValidationError
>(
  initiativeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdGetQueryOptions(
      initiativeId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update an initiative's properties. Owner or SF module admin only.
 * @summary Update Initiative
 */
export const updateInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdPut = (
  initiativeId: string,
  updateInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdPutBody: UpdateInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdPutBody
) => {
  return customInstance<unknown>({
    url: `/api/v1/software-factory/initiatives/${initiativeId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdPutBody
  });
};

export const getUpdateInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdPut
        >
      >,
      TError,
      {
        initiativeId: string;
        data: UpdateInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdPutBody;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdPut
      >
    >,
    TError,
    {
      initiativeId: string;
      data: UpdateInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdPutBody;
    },
    TContext
  > => {
    const mutationKey = [
      'updateInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdPut
        >
      >,
      {
        initiativeId: string;
        data: UpdateInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdPutBody;
      }
    > = (props) => {
      const { initiativeId, data } = props ?? {};

      return updateInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdPut(
        initiativeId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdPut
      >
    >
  >;
export type UpdateInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdPutMutationBody =
  UpdateInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdPutBody;
export type UpdateInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Initiative
 */
export const useUpdateInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdPut
          >
        >,
        TError,
        {
          initiativeId: string;
          data: UpdateInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdPutBody;
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdPut
      >
    >,
    TError,
    {
      initiativeId: string;
      data: UpdateInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdPutBody;
    },
    TContext
  > => {
    const mutationOptions =
      getUpdateInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Delete an initiative. Children become top-level. Owner or SF module admin only.
 * @summary Delete Initiative
 */
export const deleteInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdDelete =
  (initiativeId: string) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/initiatives/${initiativeId}`,
      method: 'DELETE'
    });
  };

export const getDeleteInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdDelete
        >
      >,
      TError,
      { initiativeId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdDelete
      >
    >,
    TError,
    { initiativeId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdDelete
        >
      >,
      { initiativeId: string }
    > = (props) => {
      const { initiativeId } = props ?? {};

      return deleteInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdDelete(
        initiativeId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdDelete
      >
    >
  >;

export type DeleteInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Initiative
 */
export const useDeleteInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdDelete
          >
        >,
        TError,
        { initiativeId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdDelete
      >
    >,
    TError,
    { initiativeId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Reset the schedule baseline to the initiative's current dates.

The baseline is normally captured automatically on first commitment; this is
the deliberate "re-baseline" action that overwrites it. Requires a target_date.
Owner or SF module admin only — it overwrites a delivery commitment.
 * @summary Rebaseline Initiative
 */
export const rebaselineInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdRebaselinePost =
  (initiativeId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/initiatives/${initiativeId}/rebaseline`,
      method: 'POST',
      signal
    });
  };

export const getRebaselineInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdRebaselinePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof rebaselineInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdRebaselinePost
        >
      >,
      TError,
      { initiativeId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof rebaselineInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdRebaselinePost
      >
    >,
    TError,
    { initiativeId: string },
    TContext
  > => {
    const mutationKey = [
      'rebaselineInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdRebaselinePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof rebaselineInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdRebaselinePost
        >
      >,
      { initiativeId: string }
    > = (props) => {
      const { initiativeId } = props ?? {};

      return rebaselineInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdRebaselinePost(
        initiativeId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RebaselineInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdRebaselinePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof rebaselineInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdRebaselinePost
      >
    >
  >;

export type RebaselineInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdRebaselinePostMutationError =
  HTTPValidationError;

/**
 * @summary Rebaseline Initiative
 */
export const useRebaselineInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdRebaselinePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof rebaselineInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdRebaselinePost
          >
        >,
        TError,
        { initiativeId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof rebaselineInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdRebaselinePost
      >
    >,
    TError,
    { initiativeId: string },
    TContext
  > => {
    const mutationOptions =
      getRebaselineInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdRebaselinePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List immediate children of an initiative.
 * @summary List Initiative Children
 */
export const listInitiativeChildrenApiV1SoftwareFactoryInitiativesInitiativeIdChildrenGet =
  (
    initiativeId: string,
    params?: ListInitiativeChildrenApiV1SoftwareFactoryInitiativesInitiativeIdChildrenGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/initiatives/${initiativeId}/children`,
      method: 'GET',
      params,
      signal
    });
  };

export const getListInitiativeChildrenApiV1SoftwareFactoryInitiativesInitiativeIdChildrenGetQueryKey =
  (
    initiativeId?: string,
    params?: ListInitiativeChildrenApiV1SoftwareFactoryInitiativesInitiativeIdChildrenGetParams
  ) => {
    return [
      `/api/v1/software-factory/initiatives/${initiativeId}/children`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListInitiativeChildrenApiV1SoftwareFactoryInitiativesInitiativeIdChildrenGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listInitiativeChildrenApiV1SoftwareFactoryInitiativesInitiativeIdChildrenGet
      >
    >,
    TError = HTTPValidationError
  >(
    initiativeId: string,
    params?: ListInitiativeChildrenApiV1SoftwareFactoryInitiativesInitiativeIdChildrenGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listInitiativeChildrenApiV1SoftwareFactoryInitiativesInitiativeIdChildrenGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListInitiativeChildrenApiV1SoftwareFactoryInitiativesInitiativeIdChildrenGetQueryKey(
        initiativeId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listInitiativeChildrenApiV1SoftwareFactoryInitiativesInitiativeIdChildrenGet
        >
      >
    > = ({ signal }) =>
      listInitiativeChildrenApiV1SoftwareFactoryInitiativesInitiativeIdChildrenGet(
        initiativeId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!initiativeId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listInitiativeChildrenApiV1SoftwareFactoryInitiativesInitiativeIdChildrenGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListInitiativeChildrenApiV1SoftwareFactoryInitiativesInitiativeIdChildrenGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listInitiativeChildrenApiV1SoftwareFactoryInitiativesInitiativeIdChildrenGet
      >
    >
  >;
export type ListInitiativeChildrenApiV1SoftwareFactoryInitiativesInitiativeIdChildrenGetQueryError =
  HTTPValidationError;

export function useListInitiativeChildrenApiV1SoftwareFactoryInitiativesInitiativeIdChildrenGet<
  TData = Awaited<
    ReturnType<
      typeof listInitiativeChildrenApiV1SoftwareFactoryInitiativesInitiativeIdChildrenGet
    >
  >,
  TError = HTTPValidationError
>(
  initiativeId: string,
  params:
    | undefined
    | ListInitiativeChildrenApiV1SoftwareFactoryInitiativesInitiativeIdChildrenGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listInitiativeChildrenApiV1SoftwareFactoryInitiativesInitiativeIdChildrenGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listInitiativeChildrenApiV1SoftwareFactoryInitiativesInitiativeIdChildrenGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listInitiativeChildrenApiV1SoftwareFactoryInitiativesInitiativeIdChildrenGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListInitiativeChildrenApiV1SoftwareFactoryInitiativesInitiativeIdChildrenGet<
  TData = Awaited<
    ReturnType<
      typeof listInitiativeChildrenApiV1SoftwareFactoryInitiativesInitiativeIdChildrenGet
    >
  >,
  TError = HTTPValidationError
>(
  initiativeId: string,
  params?: ListInitiativeChildrenApiV1SoftwareFactoryInitiativesInitiativeIdChildrenGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listInitiativeChildrenApiV1SoftwareFactoryInitiativesInitiativeIdChildrenGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listInitiativeChildrenApiV1SoftwareFactoryInitiativesInitiativeIdChildrenGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listInitiativeChildrenApiV1SoftwareFactoryInitiativesInitiativeIdChildrenGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListInitiativeChildrenApiV1SoftwareFactoryInitiativesInitiativeIdChildrenGet<
  TData = Awaited<
    ReturnType<
      typeof listInitiativeChildrenApiV1SoftwareFactoryInitiativesInitiativeIdChildrenGet
    >
  >,
  TError = HTTPValidationError
>(
  initiativeId: string,
  params?: ListInitiativeChildrenApiV1SoftwareFactoryInitiativesInitiativeIdChildrenGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listInitiativeChildrenApiV1SoftwareFactoryInitiativesInitiativeIdChildrenGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Initiative Children
 */

export function useListInitiativeChildrenApiV1SoftwareFactoryInitiativesInitiativeIdChildrenGet<
  TData = Awaited<
    ReturnType<
      typeof listInitiativeChildrenApiV1SoftwareFactoryInitiativesInitiativeIdChildrenGet
    >
  >,
  TError = HTTPValidationError
>(
  initiativeId: string,
  params?: ListInitiativeChildrenApiV1SoftwareFactoryInitiativesInitiativeIdChildrenGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listInitiativeChildrenApiV1SoftwareFactoryInitiativesInitiativeIdChildrenGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListInitiativeChildrenApiV1SoftwareFactoryInitiativesInitiativeIdChildrenGetQueryOptions(
      initiativeId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List customer/deal associations on an initiative.
 * @summary List Initiative Customers
 */
export const listInitiativeCustomersApiV1SoftwareFactoryInitiativesInitiativeIdCustomersGet =
  (initiativeId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/initiatives/${initiativeId}/customers`,
      method: 'GET',
      signal
    });
  };

export const getListInitiativeCustomersApiV1SoftwareFactoryInitiativesInitiativeIdCustomersGetQueryKey =
  (initiativeId?: string) => {
    return [
      `/api/v1/software-factory/initiatives/${initiativeId}/customers`
    ] as const;
  };

export const getListInitiativeCustomersApiV1SoftwareFactoryInitiativesInitiativeIdCustomersGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listInitiativeCustomersApiV1SoftwareFactoryInitiativesInitiativeIdCustomersGet
      >
    >,
    TError = HTTPValidationError
  >(
    initiativeId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listInitiativeCustomersApiV1SoftwareFactoryInitiativesInitiativeIdCustomersGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListInitiativeCustomersApiV1SoftwareFactoryInitiativesInitiativeIdCustomersGetQueryKey(
        initiativeId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listInitiativeCustomersApiV1SoftwareFactoryInitiativesInitiativeIdCustomersGet
        >
      >
    > = ({ signal }) =>
      listInitiativeCustomersApiV1SoftwareFactoryInitiativesInitiativeIdCustomersGet(
        initiativeId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!initiativeId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listInitiativeCustomersApiV1SoftwareFactoryInitiativesInitiativeIdCustomersGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListInitiativeCustomersApiV1SoftwareFactoryInitiativesInitiativeIdCustomersGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listInitiativeCustomersApiV1SoftwareFactoryInitiativesInitiativeIdCustomersGet
      >
    >
  >;
export type ListInitiativeCustomersApiV1SoftwareFactoryInitiativesInitiativeIdCustomersGetQueryError =
  HTTPValidationError;

export function useListInitiativeCustomersApiV1SoftwareFactoryInitiativesInitiativeIdCustomersGet<
  TData = Awaited<
    ReturnType<
      typeof listInitiativeCustomersApiV1SoftwareFactoryInitiativesInitiativeIdCustomersGet
    >
  >,
  TError = HTTPValidationError
>(
  initiativeId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listInitiativeCustomersApiV1SoftwareFactoryInitiativesInitiativeIdCustomersGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listInitiativeCustomersApiV1SoftwareFactoryInitiativesInitiativeIdCustomersGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listInitiativeCustomersApiV1SoftwareFactoryInitiativesInitiativeIdCustomersGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListInitiativeCustomersApiV1SoftwareFactoryInitiativesInitiativeIdCustomersGet<
  TData = Awaited<
    ReturnType<
      typeof listInitiativeCustomersApiV1SoftwareFactoryInitiativesInitiativeIdCustomersGet
    >
  >,
  TError = HTTPValidationError
>(
  initiativeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listInitiativeCustomersApiV1SoftwareFactoryInitiativesInitiativeIdCustomersGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listInitiativeCustomersApiV1SoftwareFactoryInitiativesInitiativeIdCustomersGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listInitiativeCustomersApiV1SoftwareFactoryInitiativesInitiativeIdCustomersGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListInitiativeCustomersApiV1SoftwareFactoryInitiativesInitiativeIdCustomersGet<
  TData = Awaited<
    ReturnType<
      typeof listInitiativeCustomersApiV1SoftwareFactoryInitiativesInitiativeIdCustomersGet
    >
  >,
  TError = HTTPValidationError
>(
  initiativeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listInitiativeCustomersApiV1SoftwareFactoryInitiativesInitiativeIdCustomersGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Initiative Customers
 */

export function useListInitiativeCustomersApiV1SoftwareFactoryInitiativesInitiativeIdCustomersGet<
  TData = Awaited<
    ReturnType<
      typeof listInitiativeCustomersApiV1SoftwareFactoryInitiativesInitiativeIdCustomersGet
    >
  >,
  TError = HTTPValidationError
>(
  initiativeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listInitiativeCustomersApiV1SoftwareFactoryInitiativesInitiativeIdCustomersGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListInitiativeCustomersApiV1SoftwareFactoryInitiativesInitiativeIdCustomersGetQueryOptions(
      initiativeId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Manually link a customer (company/contact) or sales deal to an initiative.

Owner or SF module admin only on the near side (the initiative); the body's
``deal_id`` keeps its own far-side gate.
 * @summary Add Initiative Customer
 */
export const addInitiativeCustomerApiV1SoftwareFactoryInitiativesInitiativeIdCustomersPost =
  (
    initiativeId: string,
    addInitiativeCustomerRequest: AddInitiativeCustomerRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/initiatives/${initiativeId}/customers`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: addInitiativeCustomerRequest,
      signal
    });
  };

export const getAddInitiativeCustomerApiV1SoftwareFactoryInitiativesInitiativeIdCustomersPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof addInitiativeCustomerApiV1SoftwareFactoryInitiativesInitiativeIdCustomersPost
        >
      >,
      TError,
      { initiativeId: string; data: AddInitiativeCustomerRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof addInitiativeCustomerApiV1SoftwareFactoryInitiativesInitiativeIdCustomersPost
      >
    >,
    TError,
    { initiativeId: string; data: AddInitiativeCustomerRequest },
    TContext
  > => {
    const mutationKey = [
      'addInitiativeCustomerApiV1SoftwareFactoryInitiativesInitiativeIdCustomersPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof addInitiativeCustomerApiV1SoftwareFactoryInitiativesInitiativeIdCustomersPost
        >
      >,
      { initiativeId: string; data: AddInitiativeCustomerRequest }
    > = (props) => {
      const { initiativeId, data } = props ?? {};

      return addInitiativeCustomerApiV1SoftwareFactoryInitiativesInitiativeIdCustomersPost(
        initiativeId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AddInitiativeCustomerApiV1SoftwareFactoryInitiativesInitiativeIdCustomersPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof addInitiativeCustomerApiV1SoftwareFactoryInitiativesInitiativeIdCustomersPost
      >
    >
  >;
export type AddInitiativeCustomerApiV1SoftwareFactoryInitiativesInitiativeIdCustomersPostMutationBody =
  AddInitiativeCustomerRequest;
export type AddInitiativeCustomerApiV1SoftwareFactoryInitiativesInitiativeIdCustomersPostMutationError =
  HTTPValidationError;

/**
 * @summary Add Initiative Customer
 */
export const useAddInitiativeCustomerApiV1SoftwareFactoryInitiativesInitiativeIdCustomersPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof addInitiativeCustomerApiV1SoftwareFactoryInitiativesInitiativeIdCustomersPost
          >
        >,
        TError,
        { initiativeId: string; data: AddInitiativeCustomerRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof addInitiativeCustomerApiV1SoftwareFactoryInitiativesInitiativeIdCustomersPost
      >
    >,
    TError,
    { initiativeId: string; data: AddInitiativeCustomerRequest },
    TContext
  > => {
    const mutationOptions =
      getAddInitiativeCustomerApiV1SoftwareFactoryInitiativesInitiativeIdCustomersPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Remove a customer/deal association from an initiative. Owner or SF module
admin only.
 * @summary Remove Initiative Customer
 */
export const removeInitiativeCustomerApiV1SoftwareFactoryInitiativesInitiativeIdCustomersCustomerIdDelete =
  (initiativeId: string, customerId: string) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/initiatives/${initiativeId}/customers/${customerId}`,
      method: 'DELETE'
    });
  };

export const getRemoveInitiativeCustomerApiV1SoftwareFactoryInitiativesInitiativeIdCustomersCustomerIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof removeInitiativeCustomerApiV1SoftwareFactoryInitiativesInitiativeIdCustomersCustomerIdDelete
        >
      >,
      TError,
      { initiativeId: string; customerId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof removeInitiativeCustomerApiV1SoftwareFactoryInitiativesInitiativeIdCustomersCustomerIdDelete
      >
    >,
    TError,
    { initiativeId: string; customerId: string },
    TContext
  > => {
    const mutationKey = [
      'removeInitiativeCustomerApiV1SoftwareFactoryInitiativesInitiativeIdCustomersCustomerIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof removeInitiativeCustomerApiV1SoftwareFactoryInitiativesInitiativeIdCustomersCustomerIdDelete
        >
      >,
      { initiativeId: string; customerId: string }
    > = (props) => {
      const { initiativeId, customerId } = props ?? {};

      return removeInitiativeCustomerApiV1SoftwareFactoryInitiativesInitiativeIdCustomersCustomerIdDelete(
        initiativeId,
        customerId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RemoveInitiativeCustomerApiV1SoftwareFactoryInitiativesInitiativeIdCustomersCustomerIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof removeInitiativeCustomerApiV1SoftwareFactoryInitiativesInitiativeIdCustomersCustomerIdDelete
      >
    >
  >;

export type RemoveInitiativeCustomerApiV1SoftwareFactoryInitiativesInitiativeIdCustomersCustomerIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Remove Initiative Customer
 */
export const useRemoveInitiativeCustomerApiV1SoftwareFactoryInitiativesInitiativeIdCustomersCustomerIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof removeInitiativeCustomerApiV1SoftwareFactoryInitiativesInitiativeIdCustomersCustomerIdDelete
          >
        >,
        TError,
        { initiativeId: string; customerId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof removeInitiativeCustomerApiV1SoftwareFactoryInitiativesInitiativeIdCustomersCustomerIdDelete
      >
    >,
    TError,
    { initiativeId: string; customerId: string },
    TContext
  > => {
    const mutationOptions =
      getRemoveInitiativeCustomerApiV1SoftwareFactoryInitiativesInitiativeIdCustomersCustomerIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Use AI to suggest work items that would fulfill an initiative.
 * @summary Suggest Work Items For Initiative
 */
export const suggestWorkItemsForInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdAiSuggestWorkItemsPost =
  (
    initiativeId: string,
    suggestWorkItemsForInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdAiSuggestWorkItemsPostBody: SuggestWorkItemsForInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdAiSuggestWorkItemsPostBody,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/initiatives/${initiativeId}/ai/suggest-work-items`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: suggestWorkItemsForInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdAiSuggestWorkItemsPostBody,
      signal
    });
  };

export const getSuggestWorkItemsForInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdAiSuggestWorkItemsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof suggestWorkItemsForInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdAiSuggestWorkItemsPost
        >
      >,
      TError,
      {
        initiativeId: string;
        data: SuggestWorkItemsForInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdAiSuggestWorkItemsPostBody;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof suggestWorkItemsForInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdAiSuggestWorkItemsPost
      >
    >,
    TError,
    {
      initiativeId: string;
      data: SuggestWorkItemsForInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdAiSuggestWorkItemsPostBody;
    },
    TContext
  > => {
    const mutationKey = [
      'suggestWorkItemsForInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdAiSuggestWorkItemsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof suggestWorkItemsForInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdAiSuggestWorkItemsPost
        >
      >,
      {
        initiativeId: string;
        data: SuggestWorkItemsForInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdAiSuggestWorkItemsPostBody;
      }
    > = (props) => {
      const { initiativeId, data } = props ?? {};

      return suggestWorkItemsForInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdAiSuggestWorkItemsPost(
        initiativeId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type SuggestWorkItemsForInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdAiSuggestWorkItemsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof suggestWorkItemsForInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdAiSuggestWorkItemsPost
      >
    >
  >;
export type SuggestWorkItemsForInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdAiSuggestWorkItemsPostMutationBody =
  SuggestWorkItemsForInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdAiSuggestWorkItemsPostBody;
export type SuggestWorkItemsForInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdAiSuggestWorkItemsPostMutationError =
  HTTPValidationError;

/**
 * @summary Suggest Work Items For Initiative
 */
export const useSuggestWorkItemsForInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdAiSuggestWorkItemsPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof suggestWorkItemsForInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdAiSuggestWorkItemsPost
          >
        >,
        TError,
        {
          initiativeId: string;
          data: SuggestWorkItemsForInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdAiSuggestWorkItemsPostBody;
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof suggestWorkItemsForInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdAiSuggestWorkItemsPost
      >
    >,
    TError,
    {
      initiativeId: string;
      data: SuggestWorkItemsForInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdAiSuggestWorkItemsPostBody;
    },
    TContext
  > => {
    const mutationOptions =
      getSuggestWorkItemsForInitiativeApiV1SoftwareFactoryInitiativesInitiativeIdAiSuggestWorkItemsPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List milestones (dated roadmap commitments) with computed at-risk rollups.

Keeps the ``resolve_limit`` (Shape B) signature because the roadmap timeline
view consumes the full set from this same endpoint; the paged list page always
sends an explicit ``limit``/``offset`` (ui-list-pages.md § 11).
 * @summary List Milestones
 */
export const listMilestonesApiV1SoftwareFactoryMilestonesGet = (
  params?: ListMilestonesApiV1SoftwareFactoryMilestonesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/software-factory/milestones`,
    method: 'GET',
    params,
    signal
  });
};

export const getListMilestonesApiV1SoftwareFactoryMilestonesGetQueryKey = (
  params?: ListMilestonesApiV1SoftwareFactoryMilestonesGetParams
) => {
  return [
    `/api/v1/software-factory/milestones`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListMilestonesApiV1SoftwareFactoryMilestonesGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listMilestonesApiV1SoftwareFactoryMilestonesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListMilestonesApiV1SoftwareFactoryMilestonesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listMilestonesApiV1SoftwareFactoryMilestonesGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListMilestonesApiV1SoftwareFactoryMilestonesGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listMilestonesApiV1SoftwareFactoryMilestonesGet>>
  > = ({ signal }) =>
    listMilestonesApiV1SoftwareFactoryMilestonesGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMilestonesApiV1SoftwareFactoryMilestonesGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListMilestonesApiV1SoftwareFactoryMilestonesGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listMilestonesApiV1SoftwareFactoryMilestonesGet>>
  >;
export type ListMilestonesApiV1SoftwareFactoryMilestonesGetQueryError =
  HTTPValidationError;

export function useListMilestonesApiV1SoftwareFactoryMilestonesGet<
  TData = Awaited<
    ReturnType<typeof listMilestonesApiV1SoftwareFactoryMilestonesGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListMilestonesApiV1SoftwareFactoryMilestonesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listMilestonesApiV1SoftwareFactoryMilestonesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listMilestonesApiV1SoftwareFactoryMilestonesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listMilestonesApiV1SoftwareFactoryMilestonesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListMilestonesApiV1SoftwareFactoryMilestonesGet<
  TData = Awaited<
    ReturnType<typeof listMilestonesApiV1SoftwareFactoryMilestonesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListMilestonesApiV1SoftwareFactoryMilestonesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listMilestonesApiV1SoftwareFactoryMilestonesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listMilestonesApiV1SoftwareFactoryMilestonesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listMilestonesApiV1SoftwareFactoryMilestonesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListMilestonesApiV1SoftwareFactoryMilestonesGet<
  TData = Awaited<
    ReturnType<typeof listMilestonesApiV1SoftwareFactoryMilestonesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListMilestonesApiV1SoftwareFactoryMilestonesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listMilestonesApiV1SoftwareFactoryMilestonesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Milestones
 */

export function useListMilestonesApiV1SoftwareFactoryMilestonesGet<
  TData = Awaited<
    ReturnType<typeof listMilestonesApiV1SoftwareFactoryMilestonesGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListMilestonesApiV1SoftwareFactoryMilestonesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listMilestonesApiV1SoftwareFactoryMilestonesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListMilestonesApiV1SoftwareFactoryMilestonesGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new milestone.
 * @summary Create Milestone
 */
export const createMilestoneApiV1SoftwareFactoryMilestonesPost = (
  createMilestoneApiV1SoftwareFactoryMilestonesPostBody: CreateMilestoneApiV1SoftwareFactoryMilestonesPostBody,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/software-factory/milestones`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createMilestoneApiV1SoftwareFactoryMilestonesPostBody,
    signal
  });
};

export const getCreateMilestoneApiV1SoftwareFactoryMilestonesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createMilestoneApiV1SoftwareFactoryMilestonesPost>
      >,
      TError,
      { data: CreateMilestoneApiV1SoftwareFactoryMilestonesPostBody },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof createMilestoneApiV1SoftwareFactoryMilestonesPost>
    >,
    TError,
    { data: CreateMilestoneApiV1SoftwareFactoryMilestonesPostBody },
    TContext
  > => {
    const mutationKey = ['createMilestoneApiV1SoftwareFactoryMilestonesPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createMilestoneApiV1SoftwareFactoryMilestonesPost>
      >,
      { data: CreateMilestoneApiV1SoftwareFactoryMilestonesPostBody }
    > = (props) => {
      const { data } = props ?? {};

      return createMilestoneApiV1SoftwareFactoryMilestonesPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateMilestoneApiV1SoftwareFactoryMilestonesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof createMilestoneApiV1SoftwareFactoryMilestonesPost>
    >
  >;
export type CreateMilestoneApiV1SoftwareFactoryMilestonesPostMutationBody =
  CreateMilestoneApiV1SoftwareFactoryMilestonesPostBody;
export type CreateMilestoneApiV1SoftwareFactoryMilestonesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Milestone
 */
export const useCreateMilestoneApiV1SoftwareFactoryMilestonesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createMilestoneApiV1SoftwareFactoryMilestonesPost>
      >,
      TError,
      { data: CreateMilestoneApiV1SoftwareFactoryMilestonesPostBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createMilestoneApiV1SoftwareFactoryMilestonesPost>>,
  TError,
  { data: CreateMilestoneApiV1SoftwareFactoryMilestonesPostBody },
  TContext
> => {
  const mutationOptions =
    getCreateMilestoneApiV1SoftwareFactoryMilestonesPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get a single milestone by ID with its at-risk rollup.
 * @summary Get Milestone
 */
export const getMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdGet = (
  milestoneId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/software-factory/milestones/${milestoneId}`,
    method: 'GET',
    signal
  });
};

export const getGetMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdGetQueryKey =
  (milestoneId?: string) => {
    return [`/api/v1/software-factory/milestones/${milestoneId}`] as const;
  };

export const getGetMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdGet
      >
    >,
    TError = HTTPValidationError
  >(
    milestoneId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdGetQueryKey(
        milestoneId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdGet
        >
      >
    > = ({ signal }) =>
      getMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdGet(
        milestoneId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!milestoneId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdGet
      >
    >
  >;
export type GetMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdGetQueryError =
  HTTPValidationError;

export function useGetMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdGet<
  TData = Awaited<
    ReturnType<typeof getMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdGet>
  >,
  TError = HTTPValidationError
>(
  milestoneId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdGet<
  TData = Awaited<
    ReturnType<typeof getMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdGet>
  >,
  TError = HTTPValidationError
>(
  milestoneId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdGet<
  TData = Awaited<
    ReturnType<typeof getMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdGet>
  >,
  TError = HTTPValidationError
>(
  milestoneId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Milestone
 */

export function useGetMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdGet<
  TData = Awaited<
    ReturnType<typeof getMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdGet>
  >,
  TError = HTTPValidationError
>(
  milestoneId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdGetQueryOptions(
      milestoneId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update a milestone's properties.
 * @summary Update Milestone
 */
export const updateMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdPut = (
  milestoneId: string,
  updateMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdPutBody: UpdateMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdPutBody
) => {
  return customInstance<unknown>({
    url: `/api/v1/software-factory/milestones/${milestoneId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdPutBody
  });
};

export const getUpdateMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdPut
        >
      >,
      TError,
      {
        milestoneId: string;
        data: UpdateMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdPutBody;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdPut
      >
    >,
    TError,
    {
      milestoneId: string;
      data: UpdateMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdPutBody;
    },
    TContext
  > => {
    const mutationKey = [
      'updateMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdPut
        >
      >,
      {
        milestoneId: string;
        data: UpdateMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdPutBody;
      }
    > = (props) => {
      const { milestoneId, data } = props ?? {};

      return updateMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdPut(
        milestoneId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdPut
      >
    >
  >;
export type UpdateMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdPutMutationBody =
  UpdateMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdPutBody;
export type UpdateMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Milestone
 */
export const useUpdateMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdPut
        >
      >,
      TError,
      {
        milestoneId: string;
        data: UpdateMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdPutBody;
      },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof updateMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdPut
    >
  >,
  TError,
  {
    milestoneId: string;
    data: UpdateMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdPutBody;
  },
  TContext
> => {
  const mutationOptions =
    getUpdateMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Soft-delete a milestone.
 * @summary Delete Milestone
 */
export const deleteMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdDelete = (
  milestoneId: string
) => {
  return customInstance<unknown>({
    url: `/api/v1/software-factory/milestones/${milestoneId}`,
    method: 'DELETE'
  });
};

export const getDeleteMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdDelete
        >
      >,
      TError,
      { milestoneId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdDelete
      >
    >,
    TError,
    { milestoneId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdDelete
        >
      >,
      { milestoneId: string }
    > = (props) => {
      const { milestoneId } = props ?? {};

      return deleteMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdDelete(
        milestoneId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdDelete
      >
    >
  >;

export type DeleteMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Milestone
 */
export const useDeleteMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdDelete
          >
        >,
        TError,
        { milestoneId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdDelete
      >
    >,
    TError,
    { milestoneId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteMilestoneApiV1SoftwareFactoryMilestonesMilestoneIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List the work items bundled into a milestone.
 * @summary List Milestone Work Items
 */
export const listMilestoneWorkItemsApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsGet =
  (milestoneId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/milestones/${milestoneId}/work-items`,
      method: 'GET',
      signal
    });
  };

export const getListMilestoneWorkItemsApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsGetQueryKey =
  (milestoneId?: string) => {
    return [
      `/api/v1/software-factory/milestones/${milestoneId}/work-items`
    ] as const;
  };

export const getListMilestoneWorkItemsApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listMilestoneWorkItemsApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsGet
      >
    >,
    TError = HTTPValidationError
  >(
    milestoneId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listMilestoneWorkItemsApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListMilestoneWorkItemsApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsGetQueryKey(
        milestoneId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listMilestoneWorkItemsApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsGet
        >
      >
    > = ({ signal }) =>
      listMilestoneWorkItemsApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsGet(
        milestoneId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!milestoneId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listMilestoneWorkItemsApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListMilestoneWorkItemsApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listMilestoneWorkItemsApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsGet
      >
    >
  >;
export type ListMilestoneWorkItemsApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsGetQueryError =
  HTTPValidationError;

export function useListMilestoneWorkItemsApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsGet<
  TData = Awaited<
    ReturnType<
      typeof listMilestoneWorkItemsApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsGet
    >
  >,
  TError = HTTPValidationError
>(
  milestoneId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listMilestoneWorkItemsApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listMilestoneWorkItemsApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listMilestoneWorkItemsApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListMilestoneWorkItemsApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsGet<
  TData = Awaited<
    ReturnType<
      typeof listMilestoneWorkItemsApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsGet
    >
  >,
  TError = HTTPValidationError
>(
  milestoneId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listMilestoneWorkItemsApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listMilestoneWorkItemsApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listMilestoneWorkItemsApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListMilestoneWorkItemsApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsGet<
  TData = Awaited<
    ReturnType<
      typeof listMilestoneWorkItemsApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsGet
    >
  >,
  TError = HTTPValidationError
>(
  milestoneId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listMilestoneWorkItemsApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Milestone Work Items
 */

export function useListMilestoneWorkItemsApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsGet<
  TData = Awaited<
    ReturnType<
      typeof listMilestoneWorkItemsApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsGet
    >
  >,
  TError = HTTPValidationError
>(
  milestoneId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listMilestoneWorkItemsApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListMilestoneWorkItemsApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsGetQueryOptions(
      milestoneId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Link an existing work item to a milestone.

Typed body for the same reason as `dispatch_work_item`: the handler refuses
without `work_item_id`, and an untyped `data: dict` published no properties, so
the MCP tool for this route carried the milestone id and nothing else — a call
that could never succeed. Typing it also brought the route INTO
`tools/check_link_route_far_side.py`, which is blind to a `dict` body — see the
marker above.
 * @summary Link Milestone Work Item
 */
export const linkMilestoneWorkItemApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsPost =
  (
    milestoneId: string,
    sfMilestoneWorkItemLink: SfMilestoneWorkItemLink,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/milestones/${milestoneId}/work-items`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: sfMilestoneWorkItemLink,
      signal
    });
  };

export const getLinkMilestoneWorkItemApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof linkMilestoneWorkItemApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsPost
        >
      >,
      TError,
      { milestoneId: string; data: SfMilestoneWorkItemLink },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof linkMilestoneWorkItemApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsPost
      >
    >,
    TError,
    { milestoneId: string; data: SfMilestoneWorkItemLink },
    TContext
  > => {
    const mutationKey = [
      'linkMilestoneWorkItemApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof linkMilestoneWorkItemApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsPost
        >
      >,
      { milestoneId: string; data: SfMilestoneWorkItemLink }
    > = (props) => {
      const { milestoneId, data } = props ?? {};

      return linkMilestoneWorkItemApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsPost(
        milestoneId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type LinkMilestoneWorkItemApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof linkMilestoneWorkItemApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsPost
      >
    >
  >;
export type LinkMilestoneWorkItemApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsPostMutationBody =
  SfMilestoneWorkItemLink;
export type LinkMilestoneWorkItemApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsPostMutationError =
  HTTPValidationError;

/**
 * @summary Link Milestone Work Item
 */
export const useLinkMilestoneWorkItemApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof linkMilestoneWorkItemApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsPost
          >
        >,
        TError,
        { milestoneId: string; data: SfMilestoneWorkItemLink },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof linkMilestoneWorkItemApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsPost
      >
    >,
    TError,
    { milestoneId: string; data: SfMilestoneWorkItemLink },
    TContext
  > => {
    const mutationOptions =
      getLinkMilestoneWorkItemApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Unlink a work item from a milestone.
 * @summary Unlink Milestone Work Item
 */
export const unlinkMilestoneWorkItemApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsWorkItemIdDelete =
  (milestoneId: string, workItemId: string) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/milestones/${milestoneId}/work-items/${workItemId}`,
      method: 'DELETE'
    });
  };

export const getUnlinkMilestoneWorkItemApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsWorkItemIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof unlinkMilestoneWorkItemApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsWorkItemIdDelete
        >
      >,
      TError,
      { milestoneId: string; workItemId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof unlinkMilestoneWorkItemApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsWorkItemIdDelete
      >
    >,
    TError,
    { milestoneId: string; workItemId: string },
    TContext
  > => {
    const mutationKey = [
      'unlinkMilestoneWorkItemApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsWorkItemIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof unlinkMilestoneWorkItemApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsWorkItemIdDelete
        >
      >,
      { milestoneId: string; workItemId: string }
    > = (props) => {
      const { milestoneId, workItemId } = props ?? {};

      return unlinkMilestoneWorkItemApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsWorkItemIdDelete(
        milestoneId,
        workItemId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UnlinkMilestoneWorkItemApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsWorkItemIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof unlinkMilestoneWorkItemApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsWorkItemIdDelete
      >
    >
  >;

export type UnlinkMilestoneWorkItemApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsWorkItemIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Unlink Milestone Work Item
 */
export const useUnlinkMilestoneWorkItemApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsWorkItemIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof unlinkMilestoneWorkItemApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsWorkItemIdDelete
          >
        >,
        TError,
        { milestoneId: string; workItemId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof unlinkMilestoneWorkItemApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsWorkItemIdDelete
      >
    >,
    TError,
    { milestoneId: string; workItemId: string },
    TContext
  > => {
    const mutationOptions =
      getUnlinkMilestoneWorkItemApiV1SoftwareFactoryMilestonesMilestoneIdWorkItemsWorkItemIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List native sprints with their work-item counts.

Keeps the ``resolve_limit`` (Shape B) signature because the roadmap timeline
and the sprint picker consume the full set from this same endpoint; the paged
list page always sends an explicit ``limit``/``offset`` (ui-list-pages.md § 11).
 * @summary List Sprints
 */
export const listSprintsApiV1SoftwareFactorySprintsGet = (
  params?: ListSprintsApiV1SoftwareFactorySprintsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/software-factory/sprints`,
    method: 'GET',
    params,
    signal
  });
};

export const getListSprintsApiV1SoftwareFactorySprintsGetQueryKey = (
  params?: ListSprintsApiV1SoftwareFactorySprintsGetParams
) => {
  return [
    `/api/v1/software-factory/sprints`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListSprintsApiV1SoftwareFactorySprintsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listSprintsApiV1SoftwareFactorySprintsGet>>,
  TError = HTTPValidationError
>(
  params?: ListSprintsApiV1SoftwareFactorySprintsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSprintsApiV1SoftwareFactorySprintsGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListSprintsApiV1SoftwareFactorySprintsGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listSprintsApiV1SoftwareFactorySprintsGet>>
  > = ({ signal }) => listSprintsApiV1SoftwareFactorySprintsGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSprintsApiV1SoftwareFactorySprintsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListSprintsApiV1SoftwareFactorySprintsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSprintsApiV1SoftwareFactorySprintsGet>>
>;
export type ListSprintsApiV1SoftwareFactorySprintsGetQueryError =
  HTTPValidationError;

export function useListSprintsApiV1SoftwareFactorySprintsGet<
  TData = Awaited<ReturnType<typeof listSprintsApiV1SoftwareFactorySprintsGet>>,
  TError = HTTPValidationError
>(
  params: undefined | ListSprintsApiV1SoftwareFactorySprintsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSprintsApiV1SoftwareFactorySprintsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSprintsApiV1SoftwareFactorySprintsGet>>,
          TError,
          Awaited<ReturnType<typeof listSprintsApiV1SoftwareFactorySprintsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListSprintsApiV1SoftwareFactorySprintsGet<
  TData = Awaited<ReturnType<typeof listSprintsApiV1SoftwareFactorySprintsGet>>,
  TError = HTTPValidationError
>(
  params?: ListSprintsApiV1SoftwareFactorySprintsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSprintsApiV1SoftwareFactorySprintsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSprintsApiV1SoftwareFactorySprintsGet>>,
          TError,
          Awaited<ReturnType<typeof listSprintsApiV1SoftwareFactorySprintsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListSprintsApiV1SoftwareFactorySprintsGet<
  TData = Awaited<ReturnType<typeof listSprintsApiV1SoftwareFactorySprintsGet>>,
  TError = HTTPValidationError
>(
  params?: ListSprintsApiV1SoftwareFactorySprintsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSprintsApiV1SoftwareFactorySprintsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Sprints
 */

export function useListSprintsApiV1SoftwareFactorySprintsGet<
  TData = Awaited<ReturnType<typeof listSprintsApiV1SoftwareFactorySprintsGet>>,
  TError = HTTPValidationError
>(
  params?: ListSprintsApiV1SoftwareFactorySprintsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSprintsApiV1SoftwareFactorySprintsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListSprintsApiV1SoftwareFactorySprintsGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new native sprint. Rejects a second active sprint per tenant.
 * @summary Create Sprint
 */
export const createSprintApiV1SoftwareFactorySprintsPost = (
  sfSprintCreate: SfSprintCreate,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/software-factory/sprints`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: sfSprintCreate,
    signal
  });
};

export const getCreateSprintApiV1SoftwareFactorySprintsPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSprintApiV1SoftwareFactorySprintsPost>>,
    TError,
    { data: SfSprintCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSprintApiV1SoftwareFactorySprintsPost>>,
  TError,
  { data: SfSprintCreate },
  TContext
> => {
  const mutationKey = ['createSprintApiV1SoftwareFactorySprintsPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSprintApiV1SoftwareFactorySprintsPost>>,
    { data: SfSprintCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createSprintApiV1SoftwareFactorySprintsPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateSprintApiV1SoftwareFactorySprintsPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createSprintApiV1SoftwareFactorySprintsPost>>
  >;
export type CreateSprintApiV1SoftwareFactorySprintsPostMutationBody =
  SfSprintCreate;
export type CreateSprintApiV1SoftwareFactorySprintsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Sprint
 */
export const useCreateSprintApiV1SoftwareFactorySprintsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createSprintApiV1SoftwareFactorySprintsPost>>,
      TError,
      { data: SfSprintCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createSprintApiV1SoftwareFactorySprintsPost>>,
  TError,
  { data: SfSprintCreate },
  TContext
> => {
  const mutationOptions =
    getCreateSprintApiV1SoftwareFactorySprintsPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Create the first sprint when sprint auto-create is turned on (design §1b).

Idempotent. Returns ``{status, sprint, options}``: ``exists`` (a sprint already
covers today), ``needs_choice`` (a >1-week cadence offers several start dates —
``options`` lists them, nothing created), or ``created`` (the first sprint was
created). Declared before ``/sprints/{sprint_id}`` so "initialize" is never
parsed as an id.
 * @summary Initialize First Sprint
 */
export const initializeFirstSprintApiV1SoftwareFactorySprintsInitializePost = (
  initializeFirstSprintRequest: InitializeFirstSprintRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/software-factory/sprints/initialize`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: initializeFirstSprintRequest,
    signal
  });
};

export const getInitializeFirstSprintApiV1SoftwareFactorySprintsInitializePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof initializeFirstSprintApiV1SoftwareFactorySprintsInitializePost
        >
      >,
      TError,
      { data: InitializeFirstSprintRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof initializeFirstSprintApiV1SoftwareFactorySprintsInitializePost
      >
    >,
    TError,
    { data: InitializeFirstSprintRequest },
    TContext
  > => {
    const mutationKey = [
      'initializeFirstSprintApiV1SoftwareFactorySprintsInitializePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof initializeFirstSprintApiV1SoftwareFactorySprintsInitializePost
        >
      >,
      { data: InitializeFirstSprintRequest }
    > = (props) => {
      const { data } = props ?? {};

      return initializeFirstSprintApiV1SoftwareFactorySprintsInitializePost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type InitializeFirstSprintApiV1SoftwareFactorySprintsInitializePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof initializeFirstSprintApiV1SoftwareFactorySprintsInitializePost
      >
    >
  >;
export type InitializeFirstSprintApiV1SoftwareFactorySprintsInitializePostMutationBody =
  InitializeFirstSprintRequest;
export type InitializeFirstSprintApiV1SoftwareFactorySprintsInitializePostMutationError =
  HTTPValidationError;

/**
 * @summary Initialize First Sprint
 */
export const useInitializeFirstSprintApiV1SoftwareFactorySprintsInitializePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof initializeFirstSprintApiV1SoftwareFactorySprintsInitializePost
          >
        >,
        TError,
        { data: InitializeFirstSprintRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof initializeFirstSprintApiV1SoftwareFactorySprintsInitializePost
      >
    >,
    TError,
    { data: InitializeFirstSprintRequest },
    TContext
  > => {
    const mutationOptions =
      getInitializeFirstSprintApiV1SoftwareFactorySprintsInitializePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Get the tenant's single active sprint (null when none is active).

Declared before /sprints/{sprint_id} so "active" is never parsed as an ID.
 * @summary Get Active Sprint
 */
export const getActiveSprintApiV1SoftwareFactorySprintsActiveGet = (
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/software-factory/sprints/active`,
    method: 'GET',
    signal
  });
};

export const getGetActiveSprintApiV1SoftwareFactorySprintsActiveGetQueryKey =
  () => {
    return [`/api/v1/software-factory/sprints/active`] as const;
  };

export const getGetActiveSprintApiV1SoftwareFactorySprintsActiveGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getActiveSprintApiV1SoftwareFactorySprintsActiveGet>
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getActiveSprintApiV1SoftwareFactorySprintsActiveGet>
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetActiveSprintApiV1SoftwareFactorySprintsActiveGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getActiveSprintApiV1SoftwareFactorySprintsActiveGet>
      >
    > = ({ signal }) =>
      getActiveSprintApiV1SoftwareFactorySprintsActiveGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getActiveSprintApiV1SoftwareFactorySprintsActiveGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetActiveSprintApiV1SoftwareFactorySprintsActiveGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getActiveSprintApiV1SoftwareFactorySprintsActiveGet>
    >
  >;
export type GetActiveSprintApiV1SoftwareFactorySprintsActiveGetQueryError =
  unknown;

export function useGetActiveSprintApiV1SoftwareFactorySprintsActiveGet<
  TData = Awaited<
    ReturnType<typeof getActiveSprintApiV1SoftwareFactorySprintsActiveGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getActiveSprintApiV1SoftwareFactorySprintsActiveGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getActiveSprintApiV1SoftwareFactorySprintsActiveGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getActiveSprintApiV1SoftwareFactorySprintsActiveGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetActiveSprintApiV1SoftwareFactorySprintsActiveGet<
  TData = Awaited<
    ReturnType<typeof getActiveSprintApiV1SoftwareFactorySprintsActiveGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getActiveSprintApiV1SoftwareFactorySprintsActiveGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getActiveSprintApiV1SoftwareFactorySprintsActiveGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getActiveSprintApiV1SoftwareFactorySprintsActiveGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetActiveSprintApiV1SoftwareFactorySprintsActiveGet<
  TData = Awaited<
    ReturnType<typeof getActiveSprintApiV1SoftwareFactorySprintsActiveGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getActiveSprintApiV1SoftwareFactorySprintsActiveGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Active Sprint
 */

export function useGetActiveSprintApiV1SoftwareFactorySprintsActiveGet<
  TData = Awaited<
    ReturnType<typeof getActiveSprintApiV1SoftwareFactorySprintsActiveGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getActiveSprintApiV1SoftwareFactorySprintsActiveGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetActiveSprintApiV1SoftwareFactorySprintsActiveGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get a single sprint by ID with its work-item count.
 * @summary Get Sprint
 */
export const getSprintApiV1SoftwareFactorySprintsSprintIdGet = (
  sprintId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/software-factory/sprints/${sprintId}`,
    method: 'GET',
    signal
  });
};

export const getGetSprintApiV1SoftwareFactorySprintsSprintIdGetQueryKey = (
  sprintId?: string
) => {
  return [`/api/v1/software-factory/sprints/${sprintId}`] as const;
};

export const getGetSprintApiV1SoftwareFactorySprintsSprintIdGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getSprintApiV1SoftwareFactorySprintsSprintIdGet>
  >,
  TError = HTTPValidationError
>(
  sprintId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getSprintApiV1SoftwareFactorySprintsSprintIdGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetSprintApiV1SoftwareFactorySprintsSprintIdGetQueryKey(sprintId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSprintApiV1SoftwareFactorySprintsSprintIdGet>>
  > = ({ signal }) =>
    getSprintApiV1SoftwareFactorySprintsSprintIdGet(sprintId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!sprintId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSprintApiV1SoftwareFactorySprintsSprintIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetSprintApiV1SoftwareFactorySprintsSprintIdGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getSprintApiV1SoftwareFactorySprintsSprintIdGet>>
  >;
export type GetSprintApiV1SoftwareFactorySprintsSprintIdGetQueryError =
  HTTPValidationError;

export function useGetSprintApiV1SoftwareFactorySprintsSprintIdGet<
  TData = Awaited<
    ReturnType<typeof getSprintApiV1SoftwareFactorySprintsSprintIdGet>
  >,
  TError = HTTPValidationError
>(
  sprintId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getSprintApiV1SoftwareFactorySprintsSprintIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getSprintApiV1SoftwareFactorySprintsSprintIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getSprintApiV1SoftwareFactorySprintsSprintIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetSprintApiV1SoftwareFactorySprintsSprintIdGet<
  TData = Awaited<
    ReturnType<typeof getSprintApiV1SoftwareFactorySprintsSprintIdGet>
  >,
  TError = HTTPValidationError
>(
  sprintId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getSprintApiV1SoftwareFactorySprintsSprintIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getSprintApiV1SoftwareFactorySprintsSprintIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getSprintApiV1SoftwareFactorySprintsSprintIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSprintApiV1SoftwareFactorySprintsSprintIdGet<
  TData = Awaited<
    ReturnType<typeof getSprintApiV1SoftwareFactorySprintsSprintIdGet>
  >,
  TError = HTTPValidationError
>(
  sprintId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getSprintApiV1SoftwareFactorySprintsSprintIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Sprint
 */

export function useGetSprintApiV1SoftwareFactorySprintsSprintIdGet<
  TData = Awaited<
    ReturnType<typeof getSprintApiV1SoftwareFactorySprintsSprintIdGet>
  >,
  TError = HTTPValidationError
>(
  sprintId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getSprintApiV1SoftwareFactorySprintsSprintIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetSprintApiV1SoftwareFactorySprintsSprintIdGetQueryOptions(
      sprintId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update a sprint's properties. Activating rejects if another is active.
 * @summary Update Sprint
 */
export const updateSprintApiV1SoftwareFactorySprintsSprintIdPut = (
  sprintId: string,
  sfSprintUpdate: SfSprintUpdate
) => {
  return customInstance<unknown>({
    url: `/api/v1/software-factory/sprints/${sprintId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: sfSprintUpdate
  });
};

export const getUpdateSprintApiV1SoftwareFactorySprintsSprintIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateSprintApiV1SoftwareFactorySprintsSprintIdPut>
      >,
      TError,
      { sprintId: string; data: SfSprintUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updateSprintApiV1SoftwareFactorySprintsSprintIdPut>
    >,
    TError,
    { sprintId: string; data: SfSprintUpdate },
    TContext
  > => {
    const mutationKey = ['updateSprintApiV1SoftwareFactorySprintsSprintIdPut'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updateSprintApiV1SoftwareFactorySprintsSprintIdPut>
      >,
      { sprintId: string; data: SfSprintUpdate }
    > = (props) => {
      const { sprintId, data } = props ?? {};

      return updateSprintApiV1SoftwareFactorySprintsSprintIdPut(sprintId, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateSprintApiV1SoftwareFactorySprintsSprintIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof updateSprintApiV1SoftwareFactorySprintsSprintIdPut>
    >
  >;
export type UpdateSprintApiV1SoftwareFactorySprintsSprintIdPutMutationBody =
  SfSprintUpdate;
export type UpdateSprintApiV1SoftwareFactorySprintsSprintIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Sprint
 */
export const useUpdateSprintApiV1SoftwareFactorySprintsSprintIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateSprintApiV1SoftwareFactorySprintsSprintIdPut>
      >,
      TError,
      { sprintId: string; data: SfSprintUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateSprintApiV1SoftwareFactorySprintsSprintIdPut>
  >,
  TError,
  { sprintId: string; data: SfSprintUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateSprintApiV1SoftwareFactorySprintsSprintIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Soft-delete a sprint; its work items are returned to the backlog (sprint_id cleared).
 * @summary Delete Sprint
 */
export const deleteSprintApiV1SoftwareFactorySprintsSprintIdDelete = (
  sprintId: string
) => {
  return customInstance<unknown>({
    url: `/api/v1/software-factory/sprints/${sprintId}`,
    method: 'DELETE'
  });
};

export const getDeleteSprintApiV1SoftwareFactorySprintsSprintIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteSprintApiV1SoftwareFactorySprintsSprintIdDelete>
      >,
      TError,
      { sprintId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof deleteSprintApiV1SoftwareFactorySprintsSprintIdDelete>
    >,
    TError,
    { sprintId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteSprintApiV1SoftwareFactorySprintsSprintIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof deleteSprintApiV1SoftwareFactorySprintsSprintIdDelete>
      >,
      { sprintId: string }
    > = (props) => {
      const { sprintId } = props ?? {};

      return deleteSprintApiV1SoftwareFactorySprintsSprintIdDelete(sprintId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteSprintApiV1SoftwareFactorySprintsSprintIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof deleteSprintApiV1SoftwareFactorySprintsSprintIdDelete>
    >
  >;

export type DeleteSprintApiV1SoftwareFactorySprintsSprintIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Sprint
 */
export const useDeleteSprintApiV1SoftwareFactorySprintsSprintIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteSprintApiV1SoftwareFactorySprintsSprintIdDelete>
      >,
      TError,
      { sprintId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof deleteSprintApiV1SoftwareFactorySprintsSprintIdDelete>
  >,
  TError,
  { sprintId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteSprintApiV1SoftwareFactorySprintsSprintIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Mark a sprint completed and carry over its non-terminal items (design §1b).

Non-terminal items (anything but shipped/wont_do) move to the next sprint — a
freshly-created one when the tenant has sprint auto-create on, otherwise back to
the backlog. Terminal items stay put. Idempotent: completing an already-completed
sprint is a no-op. Returns ``{sprint, next_sprint_id, carried_over_count}``.
 * @summary Complete Sprint
 */
export const completeSprintApiV1SoftwareFactorySprintsSprintIdCompletePost = (
  sprintId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/software-factory/sprints/${sprintId}/complete`,
    method: 'POST',
    signal
  });
};

export const getCompleteSprintApiV1SoftwareFactorySprintsSprintIdCompletePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof completeSprintApiV1SoftwareFactorySprintsSprintIdCompletePost
        >
      >,
      TError,
      { sprintId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof completeSprintApiV1SoftwareFactorySprintsSprintIdCompletePost
      >
    >,
    TError,
    { sprintId: string },
    TContext
  > => {
    const mutationKey = [
      'completeSprintApiV1SoftwareFactorySprintsSprintIdCompletePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof completeSprintApiV1SoftwareFactorySprintsSprintIdCompletePost
        >
      >,
      { sprintId: string }
    > = (props) => {
      const { sprintId } = props ?? {};

      return completeSprintApiV1SoftwareFactorySprintsSprintIdCompletePost(
        sprintId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CompleteSprintApiV1SoftwareFactorySprintsSprintIdCompletePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof completeSprintApiV1SoftwareFactorySprintsSprintIdCompletePost
      >
    >
  >;

export type CompleteSprintApiV1SoftwareFactorySprintsSprintIdCompletePostMutationError =
  HTTPValidationError;

/**
 * @summary Complete Sprint
 */
export const useCompleteSprintApiV1SoftwareFactorySprintsSprintIdCompletePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof completeSprintApiV1SoftwareFactorySprintsSprintIdCompletePost
          >
        >,
        TError,
        { sprintId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof completeSprintApiV1SoftwareFactorySprintsSprintIdCompletePost
      >
    >,
    TError,
    { sprintId: string },
    TContext
  > => {
    const mutationOptions =
      getCompleteSprintApiV1SoftwareFactorySprintsSprintIdCompletePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * The sprint's work items grouped by status for the kanban.

Each card carries the computed ``blocked`` / ``predecessors`` /
``autonomy_level`` (§2.1) so the UI can show why an item isn't dispatching.
Columns follow the tenant's ``default_item_statuses`` ordering; the response
also includes per-status counts and a total. Read-only — sprint membership is
a grouping overlay and never affects dispatch eligibility.
 * @summary Get Sprint Board
 */
export const getSprintBoardApiV1SoftwareFactorySprintsSprintIdBoardGet = (
  sprintId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/software-factory/sprints/${sprintId}/board`,
    method: 'GET',
    signal
  });
};

export const getGetSprintBoardApiV1SoftwareFactorySprintsSprintIdBoardGetQueryKey =
  (sprintId?: string) => {
    return [`/api/v1/software-factory/sprints/${sprintId}/board`] as const;
  };

export const getGetSprintBoardApiV1SoftwareFactorySprintsSprintIdBoardGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getSprintBoardApiV1SoftwareFactorySprintsSprintIdBoardGet
      >
    >,
    TError = HTTPValidationError
  >(
    sprintId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getSprintBoardApiV1SoftwareFactorySprintsSprintIdBoardGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetSprintBoardApiV1SoftwareFactorySprintsSprintIdBoardGetQueryKey(
        sprintId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getSprintBoardApiV1SoftwareFactorySprintsSprintIdBoardGet
        >
      >
    > = ({ signal }) =>
      getSprintBoardApiV1SoftwareFactorySprintsSprintIdBoardGet(
        sprintId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!sprintId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getSprintBoardApiV1SoftwareFactorySprintsSprintIdBoardGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetSprintBoardApiV1SoftwareFactorySprintsSprintIdBoardGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getSprintBoardApiV1SoftwareFactorySprintsSprintIdBoardGet
      >
    >
  >;
export type GetSprintBoardApiV1SoftwareFactorySprintsSprintIdBoardGetQueryError =
  HTTPValidationError;

export function useGetSprintBoardApiV1SoftwareFactorySprintsSprintIdBoardGet<
  TData = Awaited<
    ReturnType<typeof getSprintBoardApiV1SoftwareFactorySprintsSprintIdBoardGet>
  >,
  TError = HTTPValidationError
>(
  sprintId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getSprintBoardApiV1SoftwareFactorySprintsSprintIdBoardGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getSprintBoardApiV1SoftwareFactorySprintsSprintIdBoardGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getSprintBoardApiV1SoftwareFactorySprintsSprintIdBoardGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetSprintBoardApiV1SoftwareFactorySprintsSprintIdBoardGet<
  TData = Awaited<
    ReturnType<typeof getSprintBoardApiV1SoftwareFactorySprintsSprintIdBoardGet>
  >,
  TError = HTTPValidationError
>(
  sprintId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getSprintBoardApiV1SoftwareFactorySprintsSprintIdBoardGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getSprintBoardApiV1SoftwareFactorySprintsSprintIdBoardGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getSprintBoardApiV1SoftwareFactorySprintsSprintIdBoardGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSprintBoardApiV1SoftwareFactorySprintsSprintIdBoardGet<
  TData = Awaited<
    ReturnType<typeof getSprintBoardApiV1SoftwareFactorySprintsSprintIdBoardGet>
  >,
  TError = HTTPValidationError
>(
  sprintId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getSprintBoardApiV1SoftwareFactorySprintsSprintIdBoardGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Sprint Board
 */

export function useGetSprintBoardApiV1SoftwareFactorySprintsSprintIdBoardGet<
  TData = Awaited<
    ReturnType<typeof getSprintBoardApiV1SoftwareFactorySprintsSprintIdBoardGet>
  >,
  TError = HTTPValidationError
>(
  sprintId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getSprintBoardApiV1SoftwareFactorySprintsSprintIdBoardGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetSprintBoardApiV1SoftwareFactorySprintsSprintIdBoardGetQueryOptions(
      sprintId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Assign a work item to this sprint (sets sprint_id; re-parents from another sprint).
 * @summary Assign Work Item To Sprint
 */
export const assignWorkItemToSprintApiV1SoftwareFactorySprintsSprintIdWorkItemsPost =
  (
    sprintId: string,
    assignWorkItemToSprintRequest: AssignWorkItemToSprintRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/sprints/${sprintId}/work-items`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: assignWorkItemToSprintRequest,
      signal
    });
  };

export const getAssignWorkItemToSprintApiV1SoftwareFactorySprintsSprintIdWorkItemsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof assignWorkItemToSprintApiV1SoftwareFactorySprintsSprintIdWorkItemsPost
        >
      >,
      TError,
      { sprintId: string; data: AssignWorkItemToSprintRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof assignWorkItemToSprintApiV1SoftwareFactorySprintsSprintIdWorkItemsPost
      >
    >,
    TError,
    { sprintId: string; data: AssignWorkItemToSprintRequest },
    TContext
  > => {
    const mutationKey = [
      'assignWorkItemToSprintApiV1SoftwareFactorySprintsSprintIdWorkItemsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof assignWorkItemToSprintApiV1SoftwareFactorySprintsSprintIdWorkItemsPost
        >
      >,
      { sprintId: string; data: AssignWorkItemToSprintRequest }
    > = (props) => {
      const { sprintId, data } = props ?? {};

      return assignWorkItemToSprintApiV1SoftwareFactorySprintsSprintIdWorkItemsPost(
        sprintId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AssignWorkItemToSprintApiV1SoftwareFactorySprintsSprintIdWorkItemsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof assignWorkItemToSprintApiV1SoftwareFactorySprintsSprintIdWorkItemsPost
      >
    >
  >;
export type AssignWorkItemToSprintApiV1SoftwareFactorySprintsSprintIdWorkItemsPostMutationBody =
  AssignWorkItemToSprintRequest;
export type AssignWorkItemToSprintApiV1SoftwareFactorySprintsSprintIdWorkItemsPostMutationError =
  HTTPValidationError;

/**
 * @summary Assign Work Item To Sprint
 */
export const useAssignWorkItemToSprintApiV1SoftwareFactorySprintsSprintIdWorkItemsPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof assignWorkItemToSprintApiV1SoftwareFactorySprintsSprintIdWorkItemsPost
          >
        >,
        TError,
        { sprintId: string; data: AssignWorkItemToSprintRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof assignWorkItemToSprintApiV1SoftwareFactorySprintsSprintIdWorkItemsPost
      >
    >,
    TError,
    { sprintId: string; data: AssignWorkItemToSprintRequest },
    TContext
  > => {
    const mutationOptions =
      getAssignWorkItemToSprintApiV1SoftwareFactorySprintsSprintIdWorkItemsPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Unassign a work item from this sprint back to the backlog (sprint_id=NULL).
 * @summary Unassign Work Item From Sprint
 */
export const unassignWorkItemFromSprintApiV1SoftwareFactorySprintsSprintIdWorkItemsWorkItemIdDelete =
  (sprintId: string, workItemId: string) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/sprints/${sprintId}/work-items/${workItemId}`,
      method: 'DELETE'
    });
  };

export const getUnassignWorkItemFromSprintApiV1SoftwareFactorySprintsSprintIdWorkItemsWorkItemIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof unassignWorkItemFromSprintApiV1SoftwareFactorySprintsSprintIdWorkItemsWorkItemIdDelete
        >
      >,
      TError,
      { sprintId: string; workItemId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof unassignWorkItemFromSprintApiV1SoftwareFactorySprintsSprintIdWorkItemsWorkItemIdDelete
      >
    >,
    TError,
    { sprintId: string; workItemId: string },
    TContext
  > => {
    const mutationKey = [
      'unassignWorkItemFromSprintApiV1SoftwareFactorySprintsSprintIdWorkItemsWorkItemIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof unassignWorkItemFromSprintApiV1SoftwareFactorySprintsSprintIdWorkItemsWorkItemIdDelete
        >
      >,
      { sprintId: string; workItemId: string }
    > = (props) => {
      const { sprintId, workItemId } = props ?? {};

      return unassignWorkItemFromSprintApiV1SoftwareFactorySprintsSprintIdWorkItemsWorkItemIdDelete(
        sprintId,
        workItemId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UnassignWorkItemFromSprintApiV1SoftwareFactorySprintsSprintIdWorkItemsWorkItemIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof unassignWorkItemFromSprintApiV1SoftwareFactorySprintsSprintIdWorkItemsWorkItemIdDelete
      >
    >
  >;

export type UnassignWorkItemFromSprintApiV1SoftwareFactorySprintsSprintIdWorkItemsWorkItemIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Unassign Work Item From Sprint
 */
export const useUnassignWorkItemFromSprintApiV1SoftwareFactorySprintsSprintIdWorkItemsWorkItemIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof unassignWorkItemFromSprintApiV1SoftwareFactorySprintsSprintIdWorkItemsWorkItemIdDelete
          >
        >,
        TError,
        { sprintId: string; workItemId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof unassignWorkItemFromSprintApiV1SoftwareFactorySprintsSprintIdWorkItemsWorkItemIdDelete
      >
    >,
    TError,
    { sprintId: string; workItemId: string },
    TContext
  > => {
    const mutationOptions =
      getUnassignWorkItemFromSprintApiV1SoftwareFactorySprintsSprintIdWorkItemsWorkItemIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List changelog entries with optional filters.
 * @summary List Changelog Entries
 */
export const listChangelogEntriesApiV1SoftwareFactoryChangelogGet = (
  params?: ListChangelogEntriesApiV1SoftwareFactoryChangelogGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/software-factory/changelog`,
    method: 'GET',
    params,
    signal
  });
};

export const getListChangelogEntriesApiV1SoftwareFactoryChangelogGetQueryKey = (
  params?: ListChangelogEntriesApiV1SoftwareFactoryChangelogGetParams
) => {
  return [
    `/api/v1/software-factory/changelog`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListChangelogEntriesApiV1SoftwareFactoryChangelogGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listChangelogEntriesApiV1SoftwareFactoryChangelogGet>
    >,
    TError = HTTPValidationError
  >(
    params?: ListChangelogEntriesApiV1SoftwareFactoryChangelogGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listChangelogEntriesApiV1SoftwareFactoryChangelogGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListChangelogEntriesApiV1SoftwareFactoryChangelogGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listChangelogEntriesApiV1SoftwareFactoryChangelogGet>
      >
    > = ({ signal }) =>
      listChangelogEntriesApiV1SoftwareFactoryChangelogGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listChangelogEntriesApiV1SoftwareFactoryChangelogGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListChangelogEntriesApiV1SoftwareFactoryChangelogGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listChangelogEntriesApiV1SoftwareFactoryChangelogGet>
    >
  >;
export type ListChangelogEntriesApiV1SoftwareFactoryChangelogGetQueryError =
  HTTPValidationError;

export function useListChangelogEntriesApiV1SoftwareFactoryChangelogGet<
  TData = Awaited<
    ReturnType<typeof listChangelogEntriesApiV1SoftwareFactoryChangelogGet>
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | ListChangelogEntriesApiV1SoftwareFactoryChangelogGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listChangelogEntriesApiV1SoftwareFactoryChangelogGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listChangelogEntriesApiV1SoftwareFactoryChangelogGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listChangelogEntriesApiV1SoftwareFactoryChangelogGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListChangelogEntriesApiV1SoftwareFactoryChangelogGet<
  TData = Awaited<
    ReturnType<typeof listChangelogEntriesApiV1SoftwareFactoryChangelogGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListChangelogEntriesApiV1SoftwareFactoryChangelogGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listChangelogEntriesApiV1SoftwareFactoryChangelogGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listChangelogEntriesApiV1SoftwareFactoryChangelogGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listChangelogEntriesApiV1SoftwareFactoryChangelogGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListChangelogEntriesApiV1SoftwareFactoryChangelogGet<
  TData = Awaited<
    ReturnType<typeof listChangelogEntriesApiV1SoftwareFactoryChangelogGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListChangelogEntriesApiV1SoftwareFactoryChangelogGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listChangelogEntriesApiV1SoftwareFactoryChangelogGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Changelog Entries
 */

export function useListChangelogEntriesApiV1SoftwareFactoryChangelogGet<
  TData = Awaited<
    ReturnType<typeof listChangelogEntriesApiV1SoftwareFactoryChangelogGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListChangelogEntriesApiV1SoftwareFactoryChangelogGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listChangelogEntriesApiV1SoftwareFactoryChangelogGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListChangelogEntriesApiV1SoftwareFactoryChangelogGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new changelog entry (draft). Publish separately via the publish endpoint.
 * @summary Create Changelog Entry
 */
export const createChangelogEntryApiV1SoftwareFactoryChangelogPost = (
  createChangelogEntryApiV1SoftwareFactoryChangelogPostBody: CreateChangelogEntryApiV1SoftwareFactoryChangelogPostBody,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/software-factory/changelog`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createChangelogEntryApiV1SoftwareFactoryChangelogPostBody,
    signal
  });
};

export const getCreateChangelogEntryApiV1SoftwareFactoryChangelogPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createChangelogEntryApiV1SoftwareFactoryChangelogPost>
      >,
      TError,
      { data: CreateChangelogEntryApiV1SoftwareFactoryChangelogPostBody },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof createChangelogEntryApiV1SoftwareFactoryChangelogPost>
    >,
    TError,
    { data: CreateChangelogEntryApiV1SoftwareFactoryChangelogPostBody },
    TContext
  > => {
    const mutationKey = [
      'createChangelogEntryApiV1SoftwareFactoryChangelogPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createChangelogEntryApiV1SoftwareFactoryChangelogPost>
      >,
      { data: CreateChangelogEntryApiV1SoftwareFactoryChangelogPostBody }
    > = (props) => {
      const { data } = props ?? {};

      return createChangelogEntryApiV1SoftwareFactoryChangelogPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateChangelogEntryApiV1SoftwareFactoryChangelogPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof createChangelogEntryApiV1SoftwareFactoryChangelogPost>
    >
  >;
export type CreateChangelogEntryApiV1SoftwareFactoryChangelogPostMutationBody =
  CreateChangelogEntryApiV1SoftwareFactoryChangelogPostBody;
export type CreateChangelogEntryApiV1SoftwareFactoryChangelogPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Changelog Entry
 */
export const useCreateChangelogEntryApiV1SoftwareFactoryChangelogPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createChangelogEntryApiV1SoftwareFactoryChangelogPost>
      >,
      TError,
      { data: CreateChangelogEntryApiV1SoftwareFactoryChangelogPostBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof createChangelogEntryApiV1SoftwareFactoryChangelogPost>
  >,
  TError,
  { data: CreateChangelogEntryApiV1SoftwareFactoryChangelogPostBody },
  TContext
> => {
  const mutationOptions =
    getCreateChangelogEntryApiV1SoftwareFactoryChangelogPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * List unread changelog entries for the current user.
 * @summary List Unread Changelog
 */
export const listUnreadChangelogApiV1SoftwareFactoryChangelogUnreadGet = (
  params?: ListUnreadChangelogApiV1SoftwareFactoryChangelogUnreadGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/software-factory/changelog/unread`,
    method: 'GET',
    params,
    signal
  });
};

export const getListUnreadChangelogApiV1SoftwareFactoryChangelogUnreadGetQueryKey =
  (
    params?: ListUnreadChangelogApiV1SoftwareFactoryChangelogUnreadGetParams
  ) => {
    return [
      `/api/v1/software-factory/changelog/unread`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListUnreadChangelogApiV1SoftwareFactoryChangelogUnreadGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listUnreadChangelogApiV1SoftwareFactoryChangelogUnreadGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: ListUnreadChangelogApiV1SoftwareFactoryChangelogUnreadGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listUnreadChangelogApiV1SoftwareFactoryChangelogUnreadGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListUnreadChangelogApiV1SoftwareFactoryChangelogUnreadGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listUnreadChangelogApiV1SoftwareFactoryChangelogUnreadGet
        >
      >
    > = ({ signal }) =>
      listUnreadChangelogApiV1SoftwareFactoryChangelogUnreadGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listUnreadChangelogApiV1SoftwareFactoryChangelogUnreadGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListUnreadChangelogApiV1SoftwareFactoryChangelogUnreadGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listUnreadChangelogApiV1SoftwareFactoryChangelogUnreadGet
      >
    >
  >;
export type ListUnreadChangelogApiV1SoftwareFactoryChangelogUnreadGetQueryError =
  HTTPValidationError;

export function useListUnreadChangelogApiV1SoftwareFactoryChangelogUnreadGet<
  TData = Awaited<
    ReturnType<typeof listUnreadChangelogApiV1SoftwareFactoryChangelogUnreadGet>
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | ListUnreadChangelogApiV1SoftwareFactoryChangelogUnreadGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listUnreadChangelogApiV1SoftwareFactoryChangelogUnreadGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listUnreadChangelogApiV1SoftwareFactoryChangelogUnreadGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listUnreadChangelogApiV1SoftwareFactoryChangelogUnreadGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListUnreadChangelogApiV1SoftwareFactoryChangelogUnreadGet<
  TData = Awaited<
    ReturnType<typeof listUnreadChangelogApiV1SoftwareFactoryChangelogUnreadGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListUnreadChangelogApiV1SoftwareFactoryChangelogUnreadGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listUnreadChangelogApiV1SoftwareFactoryChangelogUnreadGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listUnreadChangelogApiV1SoftwareFactoryChangelogUnreadGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listUnreadChangelogApiV1SoftwareFactoryChangelogUnreadGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListUnreadChangelogApiV1SoftwareFactoryChangelogUnreadGet<
  TData = Awaited<
    ReturnType<typeof listUnreadChangelogApiV1SoftwareFactoryChangelogUnreadGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListUnreadChangelogApiV1SoftwareFactoryChangelogUnreadGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listUnreadChangelogApiV1SoftwareFactoryChangelogUnreadGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Unread Changelog
 */

export function useListUnreadChangelogApiV1SoftwareFactoryChangelogUnreadGet<
  TData = Awaited<
    ReturnType<typeof listUnreadChangelogApiV1SoftwareFactoryChangelogUnreadGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListUnreadChangelogApiV1SoftwareFactoryChangelogUnreadGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listUnreadChangelogApiV1SoftwareFactoryChangelogUnreadGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListUnreadChangelogApiV1SoftwareFactoryChangelogUnreadGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get a single changelog entry by ID.
 * @summary Get Changelog Entry
 */
export const getChangelogEntryApiV1SoftwareFactoryChangelogEntryIdGet = (
  entryId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/software-factory/changelog/${entryId}`,
    method: 'GET',
    signal
  });
};

export const getGetChangelogEntryApiV1SoftwareFactoryChangelogEntryIdGetQueryKey =
  (entryId?: string) => {
    return [`/api/v1/software-factory/changelog/${entryId}`] as const;
  };

export const getGetChangelogEntryApiV1SoftwareFactoryChangelogEntryIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getChangelogEntryApiV1SoftwareFactoryChangelogEntryIdGet
      >
    >,
    TError = HTTPValidationError
  >(
    entryId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getChangelogEntryApiV1SoftwareFactoryChangelogEntryIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetChangelogEntryApiV1SoftwareFactoryChangelogEntryIdGetQueryKey(
        entryId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getChangelogEntryApiV1SoftwareFactoryChangelogEntryIdGet
        >
      >
    > = ({ signal }) =>
      getChangelogEntryApiV1SoftwareFactoryChangelogEntryIdGet(entryId, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!entryId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getChangelogEntryApiV1SoftwareFactoryChangelogEntryIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetChangelogEntryApiV1SoftwareFactoryChangelogEntryIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getChangelogEntryApiV1SoftwareFactoryChangelogEntryIdGet
      >
    >
  >;
export type GetChangelogEntryApiV1SoftwareFactoryChangelogEntryIdGetQueryError =
  HTTPValidationError;

export function useGetChangelogEntryApiV1SoftwareFactoryChangelogEntryIdGet<
  TData = Awaited<
    ReturnType<typeof getChangelogEntryApiV1SoftwareFactoryChangelogEntryIdGet>
  >,
  TError = HTTPValidationError
>(
  entryId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getChangelogEntryApiV1SoftwareFactoryChangelogEntryIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getChangelogEntryApiV1SoftwareFactoryChangelogEntryIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getChangelogEntryApiV1SoftwareFactoryChangelogEntryIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetChangelogEntryApiV1SoftwareFactoryChangelogEntryIdGet<
  TData = Awaited<
    ReturnType<typeof getChangelogEntryApiV1SoftwareFactoryChangelogEntryIdGet>
  >,
  TError = HTTPValidationError
>(
  entryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getChangelogEntryApiV1SoftwareFactoryChangelogEntryIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getChangelogEntryApiV1SoftwareFactoryChangelogEntryIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getChangelogEntryApiV1SoftwareFactoryChangelogEntryIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetChangelogEntryApiV1SoftwareFactoryChangelogEntryIdGet<
  TData = Awaited<
    ReturnType<typeof getChangelogEntryApiV1SoftwareFactoryChangelogEntryIdGet>
  >,
  TError = HTTPValidationError
>(
  entryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getChangelogEntryApiV1SoftwareFactoryChangelogEntryIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Changelog Entry
 */

export function useGetChangelogEntryApiV1SoftwareFactoryChangelogEntryIdGet<
  TData = Awaited<
    ReturnType<typeof getChangelogEntryApiV1SoftwareFactoryChangelogEntryIdGet>
  >,
  TError = HTTPValidationError
>(
  entryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getChangelogEntryApiV1SoftwareFactoryChangelogEntryIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetChangelogEntryApiV1SoftwareFactoryChangelogEntryIdGetQueryOptions(
      entryId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update Changelog Entry
 */
export const updateChangelogEntryApiV1SoftwareFactoryChangelogEntryIdPut = (
  entryId: string,
  updateChangelogEntryApiV1SoftwareFactoryChangelogEntryIdPutBody: UpdateChangelogEntryApiV1SoftwareFactoryChangelogEntryIdPutBody
) => {
  return customInstance<unknown>({
    url: `/api/v1/software-factory/changelog/${entryId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateChangelogEntryApiV1SoftwareFactoryChangelogEntryIdPutBody
  });
};

export const getUpdateChangelogEntryApiV1SoftwareFactoryChangelogEntryIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateChangelogEntryApiV1SoftwareFactoryChangelogEntryIdPut
        >
      >,
      TError,
      {
        entryId: string;
        data: UpdateChangelogEntryApiV1SoftwareFactoryChangelogEntryIdPutBody;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateChangelogEntryApiV1SoftwareFactoryChangelogEntryIdPut
      >
    >,
    TError,
    {
      entryId: string;
      data: UpdateChangelogEntryApiV1SoftwareFactoryChangelogEntryIdPutBody;
    },
    TContext
  > => {
    const mutationKey = [
      'updateChangelogEntryApiV1SoftwareFactoryChangelogEntryIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateChangelogEntryApiV1SoftwareFactoryChangelogEntryIdPut
        >
      >,
      {
        entryId: string;
        data: UpdateChangelogEntryApiV1SoftwareFactoryChangelogEntryIdPutBody;
      }
    > = (props) => {
      const { entryId, data } = props ?? {};

      return updateChangelogEntryApiV1SoftwareFactoryChangelogEntryIdPut(
        entryId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateChangelogEntryApiV1SoftwareFactoryChangelogEntryIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateChangelogEntryApiV1SoftwareFactoryChangelogEntryIdPut
      >
    >
  >;
export type UpdateChangelogEntryApiV1SoftwareFactoryChangelogEntryIdPutMutationBody =
  UpdateChangelogEntryApiV1SoftwareFactoryChangelogEntryIdPutBody;
export type UpdateChangelogEntryApiV1SoftwareFactoryChangelogEntryIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Changelog Entry
 */
export const useUpdateChangelogEntryApiV1SoftwareFactoryChangelogEntryIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateChangelogEntryApiV1SoftwareFactoryChangelogEntryIdPut
        >
      >,
      TError,
      {
        entryId: string;
        data: UpdateChangelogEntryApiV1SoftwareFactoryChangelogEntryIdPutBody;
      },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof updateChangelogEntryApiV1SoftwareFactoryChangelogEntryIdPut
    >
  >,
  TError,
  {
    entryId: string;
    data: UpdateChangelogEntryApiV1SoftwareFactoryChangelogEntryIdPutBody;
  },
  TContext
> => {
  const mutationOptions =
    getUpdateChangelogEntryApiV1SoftwareFactoryChangelogEntryIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Delete Changelog Entry
 */
export const deleteChangelogEntryApiV1SoftwareFactoryChangelogEntryIdDelete = (
  entryId: string
) => {
  return customInstance<unknown>({
    url: `/api/v1/software-factory/changelog/${entryId}`,
    method: 'DELETE'
  });
};

export const getDeleteChangelogEntryApiV1SoftwareFactoryChangelogEntryIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteChangelogEntryApiV1SoftwareFactoryChangelogEntryIdDelete
        >
      >,
      TError,
      { entryId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteChangelogEntryApiV1SoftwareFactoryChangelogEntryIdDelete
      >
    >,
    TError,
    { entryId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteChangelogEntryApiV1SoftwareFactoryChangelogEntryIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteChangelogEntryApiV1SoftwareFactoryChangelogEntryIdDelete
        >
      >,
      { entryId: string }
    > = (props) => {
      const { entryId } = props ?? {};

      return deleteChangelogEntryApiV1SoftwareFactoryChangelogEntryIdDelete(
        entryId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteChangelogEntryApiV1SoftwareFactoryChangelogEntryIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteChangelogEntryApiV1SoftwareFactoryChangelogEntryIdDelete
      >
    >
  >;

export type DeleteChangelogEntryApiV1SoftwareFactoryChangelogEntryIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Changelog Entry
 */
export const useDeleteChangelogEntryApiV1SoftwareFactoryChangelogEntryIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteChangelogEntryApiV1SoftwareFactoryChangelogEntryIdDelete
          >
        >,
        TError,
        { entryId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteChangelogEntryApiV1SoftwareFactoryChangelogEntryIdDelete
      >
    >,
    TError,
    { entryId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteChangelogEntryApiV1SoftwareFactoryChangelogEntryIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * @summary Publish Changelog Entry
 */
export const publishChangelogEntryApiV1SoftwareFactoryChangelogEntryIdPublishPost =
  (entryId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/changelog/${entryId}/publish`,
      method: 'POST',
      signal
    });
  };

export const getPublishChangelogEntryApiV1SoftwareFactoryChangelogEntryIdPublishPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof publishChangelogEntryApiV1SoftwareFactoryChangelogEntryIdPublishPost
        >
      >,
      TError,
      { entryId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof publishChangelogEntryApiV1SoftwareFactoryChangelogEntryIdPublishPost
      >
    >,
    TError,
    { entryId: string },
    TContext
  > => {
    const mutationKey = [
      'publishChangelogEntryApiV1SoftwareFactoryChangelogEntryIdPublishPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof publishChangelogEntryApiV1SoftwareFactoryChangelogEntryIdPublishPost
        >
      >,
      { entryId: string }
    > = (props) => {
      const { entryId } = props ?? {};

      return publishChangelogEntryApiV1SoftwareFactoryChangelogEntryIdPublishPost(
        entryId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PublishChangelogEntryApiV1SoftwareFactoryChangelogEntryIdPublishPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof publishChangelogEntryApiV1SoftwareFactoryChangelogEntryIdPublishPost
      >
    >
  >;

export type PublishChangelogEntryApiV1SoftwareFactoryChangelogEntryIdPublishPostMutationError =
  HTTPValidationError;

/**
 * @summary Publish Changelog Entry
 */
export const usePublishChangelogEntryApiV1SoftwareFactoryChangelogEntryIdPublishPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof publishChangelogEntryApiV1SoftwareFactoryChangelogEntryIdPublishPost
          >
        >,
        TError,
        { entryId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof publishChangelogEntryApiV1SoftwareFactoryChangelogEntryIdPublishPost
      >
    >,
    TError,
    { entryId: string },
    TContext
  > => {
    const mutationOptions =
      getPublishChangelogEntryApiV1SoftwareFactoryChangelogEntryIdPublishPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * @summary Mark Changelog Read
 */
export const markChangelogReadApiV1SoftwareFactoryChangelogEntryIdReadPost = (
  entryId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/software-factory/changelog/${entryId}/read`,
    method: 'POST',
    signal
  });
};

export const getMarkChangelogReadApiV1SoftwareFactoryChangelogEntryIdReadPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof markChangelogReadApiV1SoftwareFactoryChangelogEntryIdReadPost
        >
      >,
      TError,
      { entryId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof markChangelogReadApiV1SoftwareFactoryChangelogEntryIdReadPost
      >
    >,
    TError,
    { entryId: string },
    TContext
  > => {
    const mutationKey = [
      'markChangelogReadApiV1SoftwareFactoryChangelogEntryIdReadPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof markChangelogReadApiV1SoftwareFactoryChangelogEntryIdReadPost
        >
      >,
      { entryId: string }
    > = (props) => {
      const { entryId } = props ?? {};

      return markChangelogReadApiV1SoftwareFactoryChangelogEntryIdReadPost(
        entryId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type MarkChangelogReadApiV1SoftwareFactoryChangelogEntryIdReadPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof markChangelogReadApiV1SoftwareFactoryChangelogEntryIdReadPost
      >
    >
  >;

export type MarkChangelogReadApiV1SoftwareFactoryChangelogEntryIdReadPostMutationError =
  HTTPValidationError;

/**
 * @summary Mark Changelog Read
 */
export const useMarkChangelogReadApiV1SoftwareFactoryChangelogEntryIdReadPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof markChangelogReadApiV1SoftwareFactoryChangelogEntryIdReadPost
          >
        >,
        TError,
        { entryId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof markChangelogReadApiV1SoftwareFactoryChangelogEntryIdReadPost
      >
    >,
    TError,
    { entryId: string },
    TContext
  > => {
    const mutationOptions =
      getMarkChangelogReadApiV1SoftwareFactoryChangelogEntryIdReadPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * @summary Get Changelog Translations
 */
export const getChangelogTranslationsApiV1SoftwareFactoryChangelogEntryIdTranslationsGet =
  (entryId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/changelog/${entryId}/translations`,
      method: 'GET',
      signal
    });
  };

export const getGetChangelogTranslationsApiV1SoftwareFactoryChangelogEntryIdTranslationsGetQueryKey =
  (entryId?: string) => {
    return [
      `/api/v1/software-factory/changelog/${entryId}/translations`
    ] as const;
  };

export const getGetChangelogTranslationsApiV1SoftwareFactoryChangelogEntryIdTranslationsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getChangelogTranslationsApiV1SoftwareFactoryChangelogEntryIdTranslationsGet
      >
    >,
    TError = HTTPValidationError
  >(
    entryId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getChangelogTranslationsApiV1SoftwareFactoryChangelogEntryIdTranslationsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetChangelogTranslationsApiV1SoftwareFactoryChangelogEntryIdTranslationsGetQueryKey(
        entryId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getChangelogTranslationsApiV1SoftwareFactoryChangelogEntryIdTranslationsGet
        >
      >
    > = ({ signal }) =>
      getChangelogTranslationsApiV1SoftwareFactoryChangelogEntryIdTranslationsGet(
        entryId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!entryId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getChangelogTranslationsApiV1SoftwareFactoryChangelogEntryIdTranslationsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetChangelogTranslationsApiV1SoftwareFactoryChangelogEntryIdTranslationsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getChangelogTranslationsApiV1SoftwareFactoryChangelogEntryIdTranslationsGet
      >
    >
  >;
export type GetChangelogTranslationsApiV1SoftwareFactoryChangelogEntryIdTranslationsGetQueryError =
  HTTPValidationError;

export function useGetChangelogTranslationsApiV1SoftwareFactoryChangelogEntryIdTranslationsGet<
  TData = Awaited<
    ReturnType<
      typeof getChangelogTranslationsApiV1SoftwareFactoryChangelogEntryIdTranslationsGet
    >
  >,
  TError = HTTPValidationError
>(
  entryId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getChangelogTranslationsApiV1SoftwareFactoryChangelogEntryIdTranslationsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getChangelogTranslationsApiV1SoftwareFactoryChangelogEntryIdTranslationsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getChangelogTranslationsApiV1SoftwareFactoryChangelogEntryIdTranslationsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetChangelogTranslationsApiV1SoftwareFactoryChangelogEntryIdTranslationsGet<
  TData = Awaited<
    ReturnType<
      typeof getChangelogTranslationsApiV1SoftwareFactoryChangelogEntryIdTranslationsGet
    >
  >,
  TError = HTTPValidationError
>(
  entryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getChangelogTranslationsApiV1SoftwareFactoryChangelogEntryIdTranslationsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getChangelogTranslationsApiV1SoftwareFactoryChangelogEntryIdTranslationsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getChangelogTranslationsApiV1SoftwareFactoryChangelogEntryIdTranslationsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetChangelogTranslationsApiV1SoftwareFactoryChangelogEntryIdTranslationsGet<
  TData = Awaited<
    ReturnType<
      typeof getChangelogTranslationsApiV1SoftwareFactoryChangelogEntryIdTranslationsGet
    >
  >,
  TError = HTTPValidationError
>(
  entryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getChangelogTranslationsApiV1SoftwareFactoryChangelogEntryIdTranslationsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Changelog Translations
 */

export function useGetChangelogTranslationsApiV1SoftwareFactoryChangelogEntryIdTranslationsGet<
  TData = Awaited<
    ReturnType<
      typeof getChangelogTranslationsApiV1SoftwareFactoryChangelogEntryIdTranslationsGet
    >
  >,
  TError = HTTPValidationError
>(
  entryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getChangelogTranslationsApiV1SoftwareFactoryChangelogEntryIdTranslationsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetChangelogTranslationsApiV1SoftwareFactoryChangelogEntryIdTranslationsGetQueryOptions(
      entryId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create or replace the translated copy of a changelog entry for one language.

Typed body for the same reason as `dispatch_work_item`: an untyped `data: dict`
published no properties, so the MCP tool for this route could send only the
entry id and the language — and that call cannot write a translation at all
(both columns are NOT NULL on insert) while the update arm degenerated into a
no-op that still answered 200.
 * @summary Upsert Changelog Translation
 */
export const upsertChangelogTranslationApiV1SoftwareFactoryChangelogEntryIdTranslationsLanguagePut =
  (
    entryId: string,
    language: string,
    sfChangelogTranslationUpsert: SfChangelogTranslationUpsert
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/changelog/${entryId}/translations/${language}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: sfChangelogTranslationUpsert
    });
  };

export const getUpsertChangelogTranslationApiV1SoftwareFactoryChangelogEntryIdTranslationsLanguagePutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof upsertChangelogTranslationApiV1SoftwareFactoryChangelogEntryIdTranslationsLanguagePut
        >
      >,
      TError,
      { entryId: string; language: string; data: SfChangelogTranslationUpsert },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof upsertChangelogTranslationApiV1SoftwareFactoryChangelogEntryIdTranslationsLanguagePut
      >
    >,
    TError,
    { entryId: string; language: string; data: SfChangelogTranslationUpsert },
    TContext
  > => {
    const mutationKey = [
      'upsertChangelogTranslationApiV1SoftwareFactoryChangelogEntryIdTranslationsLanguagePut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof upsertChangelogTranslationApiV1SoftwareFactoryChangelogEntryIdTranslationsLanguagePut
        >
      >,
      { entryId: string; language: string; data: SfChangelogTranslationUpsert }
    > = (props) => {
      const { entryId, language, data } = props ?? {};

      return upsertChangelogTranslationApiV1SoftwareFactoryChangelogEntryIdTranslationsLanguagePut(
        entryId,
        language,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpsertChangelogTranslationApiV1SoftwareFactoryChangelogEntryIdTranslationsLanguagePutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof upsertChangelogTranslationApiV1SoftwareFactoryChangelogEntryIdTranslationsLanguagePut
      >
    >
  >;
export type UpsertChangelogTranslationApiV1SoftwareFactoryChangelogEntryIdTranslationsLanguagePutMutationBody =
  SfChangelogTranslationUpsert;
export type UpsertChangelogTranslationApiV1SoftwareFactoryChangelogEntryIdTranslationsLanguagePutMutationError =
  HTTPValidationError;

/**
 * @summary Upsert Changelog Translation
 */
export const useUpsertChangelogTranslationApiV1SoftwareFactoryChangelogEntryIdTranslationsLanguagePut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof upsertChangelogTranslationApiV1SoftwareFactoryChangelogEntryIdTranslationsLanguagePut
          >
        >,
        TError,
        {
          entryId: string;
          language: string;
          data: SfChangelogTranslationUpsert;
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof upsertChangelogTranslationApiV1SoftwareFactoryChangelogEntryIdTranslationsLanguagePut
      >
    >,
    TError,
    { entryId: string; language: string; data: SfChangelogTranslationUpsert },
    TContext
  > => {
    const mutationOptions =
      getUpsertChangelogTranslationApiV1SoftwareFactoryChangelogEntryIdTranslationsLanguagePutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * @summary Delete Changelog Translation
 */
export const deleteChangelogTranslationApiV1SoftwareFactoryChangelogEntryIdTranslationsLanguageDelete =
  (entryId: string, language: string) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/changelog/${entryId}/translations/${language}`,
      method: 'DELETE'
    });
  };

export const getDeleteChangelogTranslationApiV1SoftwareFactoryChangelogEntryIdTranslationsLanguageDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteChangelogTranslationApiV1SoftwareFactoryChangelogEntryIdTranslationsLanguageDelete
        >
      >,
      TError,
      { entryId: string; language: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteChangelogTranslationApiV1SoftwareFactoryChangelogEntryIdTranslationsLanguageDelete
      >
    >,
    TError,
    { entryId: string; language: string },
    TContext
  > => {
    const mutationKey = [
      'deleteChangelogTranslationApiV1SoftwareFactoryChangelogEntryIdTranslationsLanguageDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteChangelogTranslationApiV1SoftwareFactoryChangelogEntryIdTranslationsLanguageDelete
        >
      >,
      { entryId: string; language: string }
    > = (props) => {
      const { entryId, language } = props ?? {};

      return deleteChangelogTranslationApiV1SoftwareFactoryChangelogEntryIdTranslationsLanguageDelete(
        entryId,
        language
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteChangelogTranslationApiV1SoftwareFactoryChangelogEntryIdTranslationsLanguageDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteChangelogTranslationApiV1SoftwareFactoryChangelogEntryIdTranslationsLanguageDelete
      >
    >
  >;

export type DeleteChangelogTranslationApiV1SoftwareFactoryChangelogEntryIdTranslationsLanguageDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Changelog Translation
 */
export const useDeleteChangelogTranslationApiV1SoftwareFactoryChangelogEntryIdTranslationsLanguageDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteChangelogTranslationApiV1SoftwareFactoryChangelogEntryIdTranslationsLanguageDelete
          >
        >,
        TError,
        { entryId: string; language: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteChangelogTranslationApiV1SoftwareFactoryChangelogEntryIdTranslationsLanguageDelete
      >
    >,
    TError,
    { entryId: string; language: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteChangelogTranslationApiV1SoftwareFactoryChangelogEntryIdTranslationsLanguageDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List the work items this changelog entry announces.

Near side is the changelog entry, whose visibility scope is the tenant — so the
gate that matters is on the FAR side, and `list_linked_work_items` applies it
(`.claude/rules/rules-entity-link-far-side.md`).
 * @summary List Changelog Work Items
 */
export const listChangelogWorkItemsApiV1SoftwareFactoryChangelogEntryIdWorkItemsGet =
  (entryId: string, signal?: AbortSignal) => {
    return customInstance<ChangelogLinkedWorkItemListResponse>({
      url: `/api/v1/software-factory/changelog/${entryId}/work-items`,
      method: 'GET',
      signal
    });
  };

export const getListChangelogWorkItemsApiV1SoftwareFactoryChangelogEntryIdWorkItemsGetQueryKey =
  (entryId?: string) => {
    return [
      `/api/v1/software-factory/changelog/${entryId}/work-items`
    ] as const;
  };

export const getListChangelogWorkItemsApiV1SoftwareFactoryChangelogEntryIdWorkItemsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listChangelogWorkItemsApiV1SoftwareFactoryChangelogEntryIdWorkItemsGet
      >
    >,
    TError = HTTPValidationError
  >(
    entryId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listChangelogWorkItemsApiV1SoftwareFactoryChangelogEntryIdWorkItemsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListChangelogWorkItemsApiV1SoftwareFactoryChangelogEntryIdWorkItemsGetQueryKey(
        entryId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listChangelogWorkItemsApiV1SoftwareFactoryChangelogEntryIdWorkItemsGet
        >
      >
    > = ({ signal }) =>
      listChangelogWorkItemsApiV1SoftwareFactoryChangelogEntryIdWorkItemsGet(
        entryId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!entryId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listChangelogWorkItemsApiV1SoftwareFactoryChangelogEntryIdWorkItemsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListChangelogWorkItemsApiV1SoftwareFactoryChangelogEntryIdWorkItemsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listChangelogWorkItemsApiV1SoftwareFactoryChangelogEntryIdWorkItemsGet
      >
    >
  >;
export type ListChangelogWorkItemsApiV1SoftwareFactoryChangelogEntryIdWorkItemsGetQueryError =
  HTTPValidationError;

export function useListChangelogWorkItemsApiV1SoftwareFactoryChangelogEntryIdWorkItemsGet<
  TData = Awaited<
    ReturnType<
      typeof listChangelogWorkItemsApiV1SoftwareFactoryChangelogEntryIdWorkItemsGet
    >
  >,
  TError = HTTPValidationError
>(
  entryId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listChangelogWorkItemsApiV1SoftwareFactoryChangelogEntryIdWorkItemsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listChangelogWorkItemsApiV1SoftwareFactoryChangelogEntryIdWorkItemsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listChangelogWorkItemsApiV1SoftwareFactoryChangelogEntryIdWorkItemsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListChangelogWorkItemsApiV1SoftwareFactoryChangelogEntryIdWorkItemsGet<
  TData = Awaited<
    ReturnType<
      typeof listChangelogWorkItemsApiV1SoftwareFactoryChangelogEntryIdWorkItemsGet
    >
  >,
  TError = HTTPValidationError
>(
  entryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listChangelogWorkItemsApiV1SoftwareFactoryChangelogEntryIdWorkItemsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listChangelogWorkItemsApiV1SoftwareFactoryChangelogEntryIdWorkItemsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listChangelogWorkItemsApiV1SoftwareFactoryChangelogEntryIdWorkItemsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListChangelogWorkItemsApiV1SoftwareFactoryChangelogEntryIdWorkItemsGet<
  TData = Awaited<
    ReturnType<
      typeof listChangelogWorkItemsApiV1SoftwareFactoryChangelogEntryIdWorkItemsGet
    >
  >,
  TError = HTTPValidationError
>(
  entryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listChangelogWorkItemsApiV1SoftwareFactoryChangelogEntryIdWorkItemsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Changelog Work Items
 */

export function useListChangelogWorkItemsApiV1SoftwareFactoryChangelogEntryIdWorkItemsGet<
  TData = Awaited<
    ReturnType<
      typeof listChangelogWorkItemsApiV1SoftwareFactoryChangelogEntryIdWorkItemsGet
    >
  >,
  TError = HTTPValidationError
>(
  entryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listChangelogWorkItemsApiV1SoftwareFactoryChangelogEntryIdWorkItemsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListChangelogWorkItemsApiV1SoftwareFactoryChangelogEntryIdWorkItemsGetQueryOptions(
      entryId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Link work items to a changelog entry (incremental — never a whole-list rebind).

The body names a `software_factory.work_item`, an ENFORCED object type, so each
id takes that item's own write gate before the link is written — a link is a
claim about the item, and the path's changelog entry is tenant-visible and
bounds nothing.
 * @summary Link Changelog Work Items
 */
export const linkChangelogWorkItemsApiV1SoftwareFactoryChangelogEntryIdWorkItemsPost =
  (
    entryId: string,
    changelogWorkItemLinkCreate: ChangelogWorkItemLinkCreate,
    signal?: AbortSignal
  ) => {
    return customInstance<ChangelogLinkedWorkItemListResponse>({
      url: `/api/v1/software-factory/changelog/${entryId}/work-items`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: changelogWorkItemLinkCreate,
      signal
    });
  };

export const getLinkChangelogWorkItemsApiV1SoftwareFactoryChangelogEntryIdWorkItemsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof linkChangelogWorkItemsApiV1SoftwareFactoryChangelogEntryIdWorkItemsPost
        >
      >,
      TError,
      { entryId: string; data: ChangelogWorkItemLinkCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof linkChangelogWorkItemsApiV1SoftwareFactoryChangelogEntryIdWorkItemsPost
      >
    >,
    TError,
    { entryId: string; data: ChangelogWorkItemLinkCreate },
    TContext
  > => {
    const mutationKey = [
      'linkChangelogWorkItemsApiV1SoftwareFactoryChangelogEntryIdWorkItemsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof linkChangelogWorkItemsApiV1SoftwareFactoryChangelogEntryIdWorkItemsPost
        >
      >,
      { entryId: string; data: ChangelogWorkItemLinkCreate }
    > = (props) => {
      const { entryId, data } = props ?? {};

      return linkChangelogWorkItemsApiV1SoftwareFactoryChangelogEntryIdWorkItemsPost(
        entryId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type LinkChangelogWorkItemsApiV1SoftwareFactoryChangelogEntryIdWorkItemsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof linkChangelogWorkItemsApiV1SoftwareFactoryChangelogEntryIdWorkItemsPost
      >
    >
  >;
export type LinkChangelogWorkItemsApiV1SoftwareFactoryChangelogEntryIdWorkItemsPostMutationBody =
  ChangelogWorkItemLinkCreate;
export type LinkChangelogWorkItemsApiV1SoftwareFactoryChangelogEntryIdWorkItemsPostMutationError =
  HTTPValidationError;

/**
 * @summary Link Changelog Work Items
 */
export const useLinkChangelogWorkItemsApiV1SoftwareFactoryChangelogEntryIdWorkItemsPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof linkChangelogWorkItemsApiV1SoftwareFactoryChangelogEntryIdWorkItemsPost
          >
        >,
        TError,
        { entryId: string; data: ChangelogWorkItemLinkCreate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof linkChangelogWorkItemsApiV1SoftwareFactoryChangelogEntryIdWorkItemsPost
      >
    >,
    TError,
    { entryId: string; data: ChangelogWorkItemLinkCreate },
    TContext
  > => {
    const mutationOptions =
      getLinkChangelogWorkItemsApiV1SoftwareFactoryChangelogEntryIdWorkItemsPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Unlink one work item from a changelog entry. Same far-side write gate as the
link route: removing the announcement of an item you cannot edit is the same
claim in reverse.
 * @summary Unlink Changelog Work Item
 */
export const unlinkChangelogWorkItemApiV1SoftwareFactoryChangelogEntryIdWorkItemsWorkItemIdDelete =
  (entryId: string, workItemId: string) => {
    return customInstance<ChangelogLinkedWorkItemListResponse>({
      url: `/api/v1/software-factory/changelog/${entryId}/work-items/${workItemId}`,
      method: 'DELETE'
    });
  };

export const getUnlinkChangelogWorkItemApiV1SoftwareFactoryChangelogEntryIdWorkItemsWorkItemIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof unlinkChangelogWorkItemApiV1SoftwareFactoryChangelogEntryIdWorkItemsWorkItemIdDelete
        >
      >,
      TError,
      { entryId: string; workItemId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof unlinkChangelogWorkItemApiV1SoftwareFactoryChangelogEntryIdWorkItemsWorkItemIdDelete
      >
    >,
    TError,
    { entryId: string; workItemId: string },
    TContext
  > => {
    const mutationKey = [
      'unlinkChangelogWorkItemApiV1SoftwareFactoryChangelogEntryIdWorkItemsWorkItemIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof unlinkChangelogWorkItemApiV1SoftwareFactoryChangelogEntryIdWorkItemsWorkItemIdDelete
        >
      >,
      { entryId: string; workItemId: string }
    > = (props) => {
      const { entryId, workItemId } = props ?? {};

      return unlinkChangelogWorkItemApiV1SoftwareFactoryChangelogEntryIdWorkItemsWorkItemIdDelete(
        entryId,
        workItemId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UnlinkChangelogWorkItemApiV1SoftwareFactoryChangelogEntryIdWorkItemsWorkItemIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof unlinkChangelogWorkItemApiV1SoftwareFactoryChangelogEntryIdWorkItemsWorkItemIdDelete
      >
    >
  >;

export type UnlinkChangelogWorkItemApiV1SoftwareFactoryChangelogEntryIdWorkItemsWorkItemIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Unlink Changelog Work Item
 */
export const useUnlinkChangelogWorkItemApiV1SoftwareFactoryChangelogEntryIdWorkItemsWorkItemIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof unlinkChangelogWorkItemApiV1SoftwareFactoryChangelogEntryIdWorkItemsWorkItemIdDelete
          >
        >,
        TError,
        { entryId: string; workItemId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof unlinkChangelogWorkItemApiV1SoftwareFactoryChangelogEntryIdWorkItemsWorkItemIdDelete
      >
    >,
    TError,
    { entryId: string; workItemId: string },
    TContext
  > => {
    const mutationOptions =
      getUnlinkChangelogWorkItemApiV1SoftwareFactoryChangelogEntryIdWorkItemsWorkItemIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List the changelog entries announcing this work item (the reverse direction).

Near side is the work item — gated here, since this handler calls a sibling
service rather than `WorkItemService`. The far side is the changelog entry,
which is tenant-scoped with no per-entity relation to narrow by.
 * @summary List Work Item Changelog Entries
 */
export const listWorkItemChangelogEntriesApiV1SoftwareFactoryWorkItemsItemIdChangelogEntriesGet =
  (itemId: string, signal?: AbortSignal) => {
    return customInstance<WorkItemChangelogEntryListResponse>({
      url: `/api/v1/software-factory/work-items/${itemId}/changelog-entries`,
      method: 'GET',
      signal
    });
  };

export const getListWorkItemChangelogEntriesApiV1SoftwareFactoryWorkItemsItemIdChangelogEntriesGetQueryKey =
  (itemId?: string) => {
    return [
      `/api/v1/software-factory/work-items/${itemId}/changelog-entries`
    ] as const;
  };

export const getListWorkItemChangelogEntriesApiV1SoftwareFactoryWorkItemsItemIdChangelogEntriesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listWorkItemChangelogEntriesApiV1SoftwareFactoryWorkItemsItemIdChangelogEntriesGet
      >
    >,
    TError = HTTPValidationError
  >(
    itemId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listWorkItemChangelogEntriesApiV1SoftwareFactoryWorkItemsItemIdChangelogEntriesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListWorkItemChangelogEntriesApiV1SoftwareFactoryWorkItemsItemIdChangelogEntriesGetQueryKey(
        itemId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listWorkItemChangelogEntriesApiV1SoftwareFactoryWorkItemsItemIdChangelogEntriesGet
        >
      >
    > = ({ signal }) =>
      listWorkItemChangelogEntriesApiV1SoftwareFactoryWorkItemsItemIdChangelogEntriesGet(
        itemId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!itemId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listWorkItemChangelogEntriesApiV1SoftwareFactoryWorkItemsItemIdChangelogEntriesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListWorkItemChangelogEntriesApiV1SoftwareFactoryWorkItemsItemIdChangelogEntriesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listWorkItemChangelogEntriesApiV1SoftwareFactoryWorkItemsItemIdChangelogEntriesGet
      >
    >
  >;
export type ListWorkItemChangelogEntriesApiV1SoftwareFactoryWorkItemsItemIdChangelogEntriesGetQueryError =
  HTTPValidationError;

export function useListWorkItemChangelogEntriesApiV1SoftwareFactoryWorkItemsItemIdChangelogEntriesGet<
  TData = Awaited<
    ReturnType<
      typeof listWorkItemChangelogEntriesApiV1SoftwareFactoryWorkItemsItemIdChangelogEntriesGet
    >
  >,
  TError = HTTPValidationError
>(
  itemId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listWorkItemChangelogEntriesApiV1SoftwareFactoryWorkItemsItemIdChangelogEntriesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listWorkItemChangelogEntriesApiV1SoftwareFactoryWorkItemsItemIdChangelogEntriesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listWorkItemChangelogEntriesApiV1SoftwareFactoryWorkItemsItemIdChangelogEntriesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListWorkItemChangelogEntriesApiV1SoftwareFactoryWorkItemsItemIdChangelogEntriesGet<
  TData = Awaited<
    ReturnType<
      typeof listWorkItemChangelogEntriesApiV1SoftwareFactoryWorkItemsItemIdChangelogEntriesGet
    >
  >,
  TError = HTTPValidationError
>(
  itemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listWorkItemChangelogEntriesApiV1SoftwareFactoryWorkItemsItemIdChangelogEntriesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listWorkItemChangelogEntriesApiV1SoftwareFactoryWorkItemsItemIdChangelogEntriesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listWorkItemChangelogEntriesApiV1SoftwareFactoryWorkItemsItemIdChangelogEntriesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListWorkItemChangelogEntriesApiV1SoftwareFactoryWorkItemsItemIdChangelogEntriesGet<
  TData = Awaited<
    ReturnType<
      typeof listWorkItemChangelogEntriesApiV1SoftwareFactoryWorkItemsItemIdChangelogEntriesGet
    >
  >,
  TError = HTTPValidationError
>(
  itemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listWorkItemChangelogEntriesApiV1SoftwareFactoryWorkItemsItemIdChangelogEntriesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Work Item Changelog Entries
 */

export function useListWorkItemChangelogEntriesApiV1SoftwareFactoryWorkItemsItemIdChangelogEntriesGet<
  TData = Awaited<
    ReturnType<
      typeof listWorkItemChangelogEntriesApiV1SoftwareFactoryWorkItemsItemIdChangelogEntriesGet
    >
  >,
  TError = HTTPValidationError
>(
  itemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listWorkItemChangelogEntriesApiV1SoftwareFactoryWorkItemsItemIdChangelogEntriesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListWorkItemChangelogEntriesApiV1SoftwareFactoryWorkItemsItemIdChangelogEntriesGetQueryOptions(
      itemId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List user announcements for the authoring UI.
 * @summary List Announcements
 */
export const listAnnouncementsApiV1SoftwareFactoryAnnouncementsGet = (
  params?: ListAnnouncementsApiV1SoftwareFactoryAnnouncementsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/software-factory/announcements`,
    method: 'GET',
    params,
    signal
  });
};

export const getListAnnouncementsApiV1SoftwareFactoryAnnouncementsGetQueryKey =
  (params?: ListAnnouncementsApiV1SoftwareFactoryAnnouncementsGetParams) => {
    return [
      `/api/v1/software-factory/announcements`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListAnnouncementsApiV1SoftwareFactoryAnnouncementsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listAnnouncementsApiV1SoftwareFactoryAnnouncementsGet>
    >,
    TError = HTTPValidationError
  >(
    params?: ListAnnouncementsApiV1SoftwareFactoryAnnouncementsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listAnnouncementsApiV1SoftwareFactoryAnnouncementsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListAnnouncementsApiV1SoftwareFactoryAnnouncementsGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listAnnouncementsApiV1SoftwareFactoryAnnouncementsGet>
      >
    > = ({ signal }) =>
      listAnnouncementsApiV1SoftwareFactoryAnnouncementsGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listAnnouncementsApiV1SoftwareFactoryAnnouncementsGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListAnnouncementsApiV1SoftwareFactoryAnnouncementsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listAnnouncementsApiV1SoftwareFactoryAnnouncementsGet>
    >
  >;
export type ListAnnouncementsApiV1SoftwareFactoryAnnouncementsGetQueryError =
  HTTPValidationError;

export function useListAnnouncementsApiV1SoftwareFactoryAnnouncementsGet<
  TData = Awaited<
    ReturnType<typeof listAnnouncementsApiV1SoftwareFactoryAnnouncementsGet>
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | ListAnnouncementsApiV1SoftwareFactoryAnnouncementsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listAnnouncementsApiV1SoftwareFactoryAnnouncementsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listAnnouncementsApiV1SoftwareFactoryAnnouncementsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listAnnouncementsApiV1SoftwareFactoryAnnouncementsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListAnnouncementsApiV1SoftwareFactoryAnnouncementsGet<
  TData = Awaited<
    ReturnType<typeof listAnnouncementsApiV1SoftwareFactoryAnnouncementsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListAnnouncementsApiV1SoftwareFactoryAnnouncementsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listAnnouncementsApiV1SoftwareFactoryAnnouncementsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listAnnouncementsApiV1SoftwareFactoryAnnouncementsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listAnnouncementsApiV1SoftwareFactoryAnnouncementsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListAnnouncementsApiV1SoftwareFactoryAnnouncementsGet<
  TData = Awaited<
    ReturnType<typeof listAnnouncementsApiV1SoftwareFactoryAnnouncementsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListAnnouncementsApiV1SoftwareFactoryAnnouncementsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listAnnouncementsApiV1SoftwareFactoryAnnouncementsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Announcements
 */

export function useListAnnouncementsApiV1SoftwareFactoryAnnouncementsGet<
  TData = Awaited<
    ReturnType<typeof listAnnouncementsApiV1SoftwareFactoryAnnouncementsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListAnnouncementsApiV1SoftwareFactoryAnnouncementsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listAnnouncementsApiV1SoftwareFactoryAnnouncementsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListAnnouncementsApiV1SoftwareFactoryAnnouncementsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new announcement (draft). Publish separately.
 * @summary Create Announcement
 */
export const createAnnouncementApiV1SoftwareFactoryAnnouncementsPost = (
  createAnnouncementApiV1SoftwareFactoryAnnouncementsPostBody: CreateAnnouncementApiV1SoftwareFactoryAnnouncementsPostBody,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/software-factory/announcements`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createAnnouncementApiV1SoftwareFactoryAnnouncementsPostBody,
    signal
  });
};

export const getCreateAnnouncementApiV1SoftwareFactoryAnnouncementsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createAnnouncementApiV1SoftwareFactoryAnnouncementsPost
        >
      >,
      TError,
      { data: CreateAnnouncementApiV1SoftwareFactoryAnnouncementsPostBody },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof createAnnouncementApiV1SoftwareFactoryAnnouncementsPost>
    >,
    TError,
    { data: CreateAnnouncementApiV1SoftwareFactoryAnnouncementsPostBody },
    TContext
  > => {
    const mutationKey = [
      'createAnnouncementApiV1SoftwareFactoryAnnouncementsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createAnnouncementApiV1SoftwareFactoryAnnouncementsPost
        >
      >,
      { data: CreateAnnouncementApiV1SoftwareFactoryAnnouncementsPostBody }
    > = (props) => {
      const { data } = props ?? {};

      return createAnnouncementApiV1SoftwareFactoryAnnouncementsPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateAnnouncementApiV1SoftwareFactoryAnnouncementsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof createAnnouncementApiV1SoftwareFactoryAnnouncementsPost>
    >
  >;
export type CreateAnnouncementApiV1SoftwareFactoryAnnouncementsPostMutationBody =
  CreateAnnouncementApiV1SoftwareFactoryAnnouncementsPostBody;
export type CreateAnnouncementApiV1SoftwareFactoryAnnouncementsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Announcement
 */
export const useCreateAnnouncementApiV1SoftwareFactoryAnnouncementsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createAnnouncementApiV1SoftwareFactoryAnnouncementsPost
        >
      >,
      TError,
      { data: CreateAnnouncementApiV1SoftwareFactoryAnnouncementsPostBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof createAnnouncementApiV1SoftwareFactoryAnnouncementsPost>
  >,
  TError,
  { data: CreateAnnouncementApiV1SoftwareFactoryAnnouncementsPostBody },
  TContext
> => {
  const mutationOptions =
    getCreateAnnouncementApiV1SoftwareFactoryAnnouncementsPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * List published, non-dismissed announcements eligible for the current user.
 * @summary List My Announcements
 */
export const listMyAnnouncementsApiV1SoftwareFactoryAnnouncementsMeGet = (
  params?: ListMyAnnouncementsApiV1SoftwareFactoryAnnouncementsMeGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/software-factory/announcements/me`,
    method: 'GET',
    params,
    signal
  });
};

export const getListMyAnnouncementsApiV1SoftwareFactoryAnnouncementsMeGetQueryKey =
  (
    params?: ListMyAnnouncementsApiV1SoftwareFactoryAnnouncementsMeGetParams
  ) => {
    return [
      `/api/v1/software-factory/announcements/me`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListMyAnnouncementsApiV1SoftwareFactoryAnnouncementsMeGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listMyAnnouncementsApiV1SoftwareFactoryAnnouncementsMeGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: ListMyAnnouncementsApiV1SoftwareFactoryAnnouncementsMeGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listMyAnnouncementsApiV1SoftwareFactoryAnnouncementsMeGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListMyAnnouncementsApiV1SoftwareFactoryAnnouncementsMeGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listMyAnnouncementsApiV1SoftwareFactoryAnnouncementsMeGet
        >
      >
    > = ({ signal }) =>
      listMyAnnouncementsApiV1SoftwareFactoryAnnouncementsMeGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listMyAnnouncementsApiV1SoftwareFactoryAnnouncementsMeGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListMyAnnouncementsApiV1SoftwareFactoryAnnouncementsMeGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listMyAnnouncementsApiV1SoftwareFactoryAnnouncementsMeGet
      >
    >
  >;
export type ListMyAnnouncementsApiV1SoftwareFactoryAnnouncementsMeGetQueryError =
  HTTPValidationError;

export function useListMyAnnouncementsApiV1SoftwareFactoryAnnouncementsMeGet<
  TData = Awaited<
    ReturnType<typeof listMyAnnouncementsApiV1SoftwareFactoryAnnouncementsMeGet>
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | ListMyAnnouncementsApiV1SoftwareFactoryAnnouncementsMeGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listMyAnnouncementsApiV1SoftwareFactoryAnnouncementsMeGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listMyAnnouncementsApiV1SoftwareFactoryAnnouncementsMeGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listMyAnnouncementsApiV1SoftwareFactoryAnnouncementsMeGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListMyAnnouncementsApiV1SoftwareFactoryAnnouncementsMeGet<
  TData = Awaited<
    ReturnType<typeof listMyAnnouncementsApiV1SoftwareFactoryAnnouncementsMeGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListMyAnnouncementsApiV1SoftwareFactoryAnnouncementsMeGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listMyAnnouncementsApiV1SoftwareFactoryAnnouncementsMeGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listMyAnnouncementsApiV1SoftwareFactoryAnnouncementsMeGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listMyAnnouncementsApiV1SoftwareFactoryAnnouncementsMeGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListMyAnnouncementsApiV1SoftwareFactoryAnnouncementsMeGet<
  TData = Awaited<
    ReturnType<typeof listMyAnnouncementsApiV1SoftwareFactoryAnnouncementsMeGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListMyAnnouncementsApiV1SoftwareFactoryAnnouncementsMeGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listMyAnnouncementsApiV1SoftwareFactoryAnnouncementsMeGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List My Announcements
 */

export function useListMyAnnouncementsApiV1SoftwareFactoryAnnouncementsMeGet<
  TData = Awaited<
    ReturnType<typeof listMyAnnouncementsApiV1SoftwareFactoryAnnouncementsMeGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListMyAnnouncementsApiV1SoftwareFactoryAnnouncementsMeGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listMyAnnouncementsApiV1SoftwareFactoryAnnouncementsMeGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListMyAnnouncementsApiV1SoftwareFactoryAnnouncementsMeGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get a single announcement with translations and links.
 * @summary Get Announcement
 */
export const getAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdGet =
  (announcementId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/announcements/${announcementId}`,
      method: 'GET',
      signal
    });
  };

export const getGetAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdGetQueryKey =
  (announcementId?: string) => {
    return [
      `/api/v1/software-factory/announcements/${announcementId}`
    ] as const;
  };

export const getGetAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdGet
      >
    >,
    TError = HTTPValidationError
  >(
    announcementId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdGetQueryKey(
        announcementId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdGet
        >
      >
    > = ({ signal }) =>
      getAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdGet(
        announcementId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!announcementId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdGet
      >
    >
  >;
export type GetAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdGetQueryError =
  HTTPValidationError;

export function useGetAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdGet<
  TData = Awaited<
    ReturnType<
      typeof getAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdGet
    >
  >,
  TError = HTTPValidationError
>(
  announcementId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdGet<
  TData = Awaited<
    ReturnType<
      typeof getAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdGet
    >
  >,
  TError = HTTPValidationError
>(
  announcementId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdGet<
  TData = Awaited<
    ReturnType<
      typeof getAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdGet
    >
  >,
  TError = HTTPValidationError
>(
  announcementId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Announcement
 */

export function useGetAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdGet<
  TData = Awaited<
    ReturnType<
      typeof getAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdGet
    >
  >,
  TError = HTTPValidationError
>(
  announcementId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdGetQueryOptions(
      announcementId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update an announcement's editable fields.
 * @summary Update Announcement
 */
export const updateAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdPut =
  (
    announcementId: string,
    updateAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdPutBody: UpdateAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdPutBody
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/announcements/${announcementId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdPutBody
    });
  };

export const getUpdateAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdPut
        >
      >,
      TError,
      {
        announcementId: string;
        data: UpdateAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdPutBody;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdPut
      >
    >,
    TError,
    {
      announcementId: string;
      data: UpdateAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdPutBody;
    },
    TContext
  > => {
    const mutationKey = [
      'updateAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdPut
        >
      >,
      {
        announcementId: string;
        data: UpdateAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdPutBody;
      }
    > = (props) => {
      const { announcementId, data } = props ?? {};

      return updateAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdPut(
        announcementId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdPut
      >
    >
  >;
export type UpdateAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdPutMutationBody =
  UpdateAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdPutBody;
export type UpdateAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Announcement
 */
export const useUpdateAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdPut
          >
        >,
        TError,
        {
          announcementId: string;
          data: UpdateAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdPutBody;
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdPut
      >
    >,
    TError,
    {
      announcementId: string;
      data: UpdateAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdPutBody;
    },
    TContext
  > => {
    const mutationOptions =
      getUpdateAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Delete an announcement.
 * @summary Delete Announcement
 */
export const deleteAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdDelete =
  (announcementId: string) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/announcements/${announcementId}`,
      method: 'DELETE'
    });
  };

export const getDeleteAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdDelete
        >
      >,
      TError,
      { announcementId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdDelete
      >
    >,
    TError,
    { announcementId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdDelete
        >
      >,
      { announcementId: string }
    > = (props) => {
      const { announcementId } = props ?? {};

      return deleteAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdDelete(
        announcementId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdDelete
      >
    >
  >;

export type DeleteAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Announcement
 */
export const useDeleteAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdDelete
          >
        >,
        TError,
        { announcementId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdDelete
      >
    >,
    TError,
    { announcementId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Publish an announcement.
 * @summary Publish Announcement
 */
export const publishAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdPublishPost =
  (announcementId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/announcements/${announcementId}/publish`,
      method: 'POST',
      signal
    });
  };

export const getPublishAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdPublishPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof publishAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdPublishPost
        >
      >,
      TError,
      { announcementId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof publishAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdPublishPost
      >
    >,
    TError,
    { announcementId: string },
    TContext
  > => {
    const mutationKey = [
      'publishAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdPublishPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof publishAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdPublishPost
        >
      >,
      { announcementId: string }
    > = (props) => {
      const { announcementId } = props ?? {};

      return publishAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdPublishPost(
        announcementId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PublishAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdPublishPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof publishAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdPublishPost
      >
    >
  >;

export type PublishAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdPublishPostMutationError =
  HTTPValidationError;

/**
 * @summary Publish Announcement
 */
export const usePublishAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdPublishPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof publishAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdPublishPost
          >
        >,
        TError,
        { announcementId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof publishAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdPublishPost
      >
    >,
    TError,
    { announcementId: string },
    TContext
  > => {
    const mutationOptions =
      getPublishAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdPublishPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Publish the pending content edits on an already-published announcement.

Does not resurface the announcement: `published_at` and the per-user
view/dismissal records are left alone, so users who already saw or dismissed
it do not see it again.
 * @summary Publish Announcement Changes
 */
export const publishAnnouncementChangesApiV1SoftwareFactoryAnnouncementsAnnouncementIdPublishChangesPost =
  (announcementId: string, signal?: AbortSignal) => {
    return customInstance<SfUserAnnouncement>({
      url: `/api/v1/software-factory/announcements/${announcementId}/publish-changes`,
      method: 'POST',
      signal
    });
  };

export const getPublishAnnouncementChangesApiV1SoftwareFactoryAnnouncementsAnnouncementIdPublishChangesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof publishAnnouncementChangesApiV1SoftwareFactoryAnnouncementsAnnouncementIdPublishChangesPost
        >
      >,
      TError,
      { announcementId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof publishAnnouncementChangesApiV1SoftwareFactoryAnnouncementsAnnouncementIdPublishChangesPost
      >
    >,
    TError,
    { announcementId: string },
    TContext
  > => {
    const mutationKey = [
      'publishAnnouncementChangesApiV1SoftwareFactoryAnnouncementsAnnouncementIdPublishChangesPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof publishAnnouncementChangesApiV1SoftwareFactoryAnnouncementsAnnouncementIdPublishChangesPost
        >
      >,
      { announcementId: string }
    > = (props) => {
      const { announcementId } = props ?? {};

      return publishAnnouncementChangesApiV1SoftwareFactoryAnnouncementsAnnouncementIdPublishChangesPost(
        announcementId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PublishAnnouncementChangesApiV1SoftwareFactoryAnnouncementsAnnouncementIdPublishChangesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof publishAnnouncementChangesApiV1SoftwareFactoryAnnouncementsAnnouncementIdPublishChangesPost
      >
    >
  >;

export type PublishAnnouncementChangesApiV1SoftwareFactoryAnnouncementsAnnouncementIdPublishChangesPostMutationError =
  HTTPValidationError;

/**
 * @summary Publish Announcement Changes
 */
export const usePublishAnnouncementChangesApiV1SoftwareFactoryAnnouncementsAnnouncementIdPublishChangesPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof publishAnnouncementChangesApiV1SoftwareFactoryAnnouncementsAnnouncementIdPublishChangesPost
          >
        >,
        TError,
        { announcementId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof publishAnnouncementChangesApiV1SoftwareFactoryAnnouncementsAnnouncementIdPublishChangesPost
      >
    >,
    TError,
    { announcementId: string },
    TContext
  > => {
    const mutationOptions =
      getPublishAnnouncementChangesApiV1SoftwareFactoryAnnouncementsAnnouncementIdPublishChangesPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Discard pending content edits, reverting to the published version.
 * @summary Discard Announcement Draft
 */
export const discardAnnouncementDraftApiV1SoftwareFactoryAnnouncementsAnnouncementIdDiscardDraftPost =
  (announcementId: string, signal?: AbortSignal) => {
    return customInstance<SfUserAnnouncement>({
      url: `/api/v1/software-factory/announcements/${announcementId}/discard-draft`,
      method: 'POST',
      signal
    });
  };

export const getDiscardAnnouncementDraftApiV1SoftwareFactoryAnnouncementsAnnouncementIdDiscardDraftPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof discardAnnouncementDraftApiV1SoftwareFactoryAnnouncementsAnnouncementIdDiscardDraftPost
        >
      >,
      TError,
      { announcementId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof discardAnnouncementDraftApiV1SoftwareFactoryAnnouncementsAnnouncementIdDiscardDraftPost
      >
    >,
    TError,
    { announcementId: string },
    TContext
  > => {
    const mutationKey = [
      'discardAnnouncementDraftApiV1SoftwareFactoryAnnouncementsAnnouncementIdDiscardDraftPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof discardAnnouncementDraftApiV1SoftwareFactoryAnnouncementsAnnouncementIdDiscardDraftPost
        >
      >,
      { announcementId: string }
    > = (props) => {
      const { announcementId } = props ?? {};

      return discardAnnouncementDraftApiV1SoftwareFactoryAnnouncementsAnnouncementIdDiscardDraftPost(
        announcementId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DiscardAnnouncementDraftApiV1SoftwareFactoryAnnouncementsAnnouncementIdDiscardDraftPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof discardAnnouncementDraftApiV1SoftwareFactoryAnnouncementsAnnouncementIdDiscardDraftPost
      >
    >
  >;

export type DiscardAnnouncementDraftApiV1SoftwareFactoryAnnouncementsAnnouncementIdDiscardDraftPostMutationError =
  HTTPValidationError;

/**
 * @summary Discard Announcement Draft
 */
export const useDiscardAnnouncementDraftApiV1SoftwareFactoryAnnouncementsAnnouncementIdDiscardDraftPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof discardAnnouncementDraftApiV1SoftwareFactoryAnnouncementsAnnouncementIdDiscardDraftPost
          >
        >,
        TError,
        { announcementId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof discardAnnouncementDraftApiV1SoftwareFactoryAnnouncementsAnnouncementIdDiscardDraftPost
      >
    >,
    TError,
    { announcementId: string },
    TContext
  > => {
    const mutationOptions =
      getDiscardAnnouncementDraftApiV1SoftwareFactoryAnnouncementsAnnouncementIdDiscardDraftPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * AI-translate the English draft into the requested languages and save them.

Translations are written to the DRAFT columns and use the same official
glossary the UI is translated against. Partial success: languages that
succeeded are saved and returned in `translated_languages`, the rest in
`failed_languages`.
 * @summary Generate Announcement Translations
 */
export const generateAnnouncementTranslationsApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsGeneratePost =
  (
    announcementId: string,
    generateAnnouncementTranslationsRequest: GenerateAnnouncementTranslationsRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<AnnouncementTranslationGenerationResult>({
      url: `/api/v1/software-factory/announcements/${announcementId}/translations/generate`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: generateAnnouncementTranslationsRequest,
      signal
    });
  };

export const getGenerateAnnouncementTranslationsApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsGeneratePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof generateAnnouncementTranslationsApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsGeneratePost
        >
      >,
      TError,
      { announcementId: string; data: GenerateAnnouncementTranslationsRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof generateAnnouncementTranslationsApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsGeneratePost
      >
    >,
    TError,
    { announcementId: string; data: GenerateAnnouncementTranslationsRequest },
    TContext
  > => {
    const mutationKey = [
      'generateAnnouncementTranslationsApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsGeneratePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof generateAnnouncementTranslationsApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsGeneratePost
        >
      >,
      { announcementId: string; data: GenerateAnnouncementTranslationsRequest }
    > = (props) => {
      const { announcementId, data } = props ?? {};

      return generateAnnouncementTranslationsApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsGeneratePost(
        announcementId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type GenerateAnnouncementTranslationsApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsGeneratePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof generateAnnouncementTranslationsApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsGeneratePost
      >
    >
  >;
export type GenerateAnnouncementTranslationsApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsGeneratePostMutationBody =
  GenerateAnnouncementTranslationsRequest;
export type GenerateAnnouncementTranslationsApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsGeneratePostMutationError =
  HTTPValidationError;

/**
 * @summary Generate Announcement Translations
 */
export const useGenerateAnnouncementTranslationsApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsGeneratePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof generateAnnouncementTranslationsApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsGeneratePost
          >
        >,
        TError,
        {
          announcementId: string;
          data: GenerateAnnouncementTranslationsRequest;
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof generateAnnouncementTranslationsApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsGeneratePost
      >
    >,
    TError,
    { announcementId: string; data: GenerateAnnouncementTranslationsRequest },
    TContext
  > => {
    const mutationOptions =
      getGenerateAnnouncementTranslationsApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsGeneratePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Return a published announcement to draft.
 * @summary Unpublish Announcement
 */
export const unpublishAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdUnpublishPost =
  (announcementId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/announcements/${announcementId}/unpublish`,
      method: 'POST',
      signal
    });
  };

export const getUnpublishAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdUnpublishPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof unpublishAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdUnpublishPost
        >
      >,
      TError,
      { announcementId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof unpublishAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdUnpublishPost
      >
    >,
    TError,
    { announcementId: string },
    TContext
  > => {
    const mutationKey = [
      'unpublishAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdUnpublishPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof unpublishAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdUnpublishPost
        >
      >,
      { announcementId: string }
    > = (props) => {
      const { announcementId } = props ?? {};

      return unpublishAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdUnpublishPost(
        announcementId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UnpublishAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdUnpublishPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof unpublishAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdUnpublishPost
      >
    >
  >;

export type UnpublishAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdUnpublishPostMutationError =
  HTTPValidationError;

/**
 * @summary Unpublish Announcement
 */
export const useUnpublishAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdUnpublishPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof unpublishAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdUnpublishPost
          >
        >,
        TError,
        { announcementId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof unpublishAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdUnpublishPost
      >
    >,
    TError,
    { announcementId: string },
    TContext
  > => {
    const mutationOptions =
      getUnpublishAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdUnpublishPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Archive an announcement.
 * @summary Archive Announcement
 */
export const archiveAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdArchivePost =
  (announcementId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/announcements/${announcementId}/archive`,
      method: 'POST',
      signal
    });
  };

export const getArchiveAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdArchivePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof archiveAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdArchivePost
        >
      >,
      TError,
      { announcementId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof archiveAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdArchivePost
      >
    >,
    TError,
    { announcementId: string },
    TContext
  > => {
    const mutationKey = [
      'archiveAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdArchivePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof archiveAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdArchivePost
        >
      >,
      { announcementId: string }
    > = (props) => {
      const { announcementId } = props ?? {};

      return archiveAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdArchivePost(
        announcementId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ArchiveAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdArchivePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof archiveAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdArchivePost
      >
    >
  >;

export type ArchiveAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdArchivePostMutationError =
  HTTPValidationError;

/**
 * @summary Archive Announcement
 */
export const useArchiveAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdArchivePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof archiveAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdArchivePost
          >
        >,
        TError,
        { announcementId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof archiveAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdArchivePost
      >
    >,
    TError,
    { announcementId: string },
    TContext
  > => {
    const mutationOptions =
      getArchiveAnnouncementApiV1SoftwareFactoryAnnouncementsAnnouncementIdArchivePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Get all translations for an announcement.
 * @summary Get Announcement Translations
 */
export const getAnnouncementTranslationsApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsGet =
  (announcementId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/announcements/${announcementId}/translations`,
      method: 'GET',
      signal
    });
  };

export const getGetAnnouncementTranslationsApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsGetQueryKey =
  (announcementId?: string) => {
    return [
      `/api/v1/software-factory/announcements/${announcementId}/translations`
    ] as const;
  };

export const getGetAnnouncementTranslationsApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getAnnouncementTranslationsApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsGet
      >
    >,
    TError = HTTPValidationError
  >(
    announcementId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getAnnouncementTranslationsApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetAnnouncementTranslationsApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsGetQueryKey(
        announcementId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getAnnouncementTranslationsApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsGet
        >
      >
    > = ({ signal }) =>
      getAnnouncementTranslationsApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsGet(
        announcementId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!announcementId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getAnnouncementTranslationsApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetAnnouncementTranslationsApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getAnnouncementTranslationsApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsGet
      >
    >
  >;
export type GetAnnouncementTranslationsApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsGetQueryError =
  HTTPValidationError;

export function useGetAnnouncementTranslationsApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsGet<
  TData = Awaited<
    ReturnType<
      typeof getAnnouncementTranslationsApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsGet
    >
  >,
  TError = HTTPValidationError
>(
  announcementId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAnnouncementTranslationsApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getAnnouncementTranslationsApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getAnnouncementTranslationsApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAnnouncementTranslationsApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsGet<
  TData = Awaited<
    ReturnType<
      typeof getAnnouncementTranslationsApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsGet
    >
  >,
  TError = HTTPValidationError
>(
  announcementId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAnnouncementTranslationsApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getAnnouncementTranslationsApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getAnnouncementTranslationsApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAnnouncementTranslationsApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsGet<
  TData = Awaited<
    ReturnType<
      typeof getAnnouncementTranslationsApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsGet
    >
  >,
  TError = HTTPValidationError
>(
  announcementId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAnnouncementTranslationsApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Announcement Translations
 */

export function useGetAnnouncementTranslationsApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsGet<
  TData = Awaited<
    ReturnType<
      typeof getAnnouncementTranslationsApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsGet
    >
  >,
  TError = HTTPValidationError
>(
  announcementId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAnnouncementTranslationsApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetAnnouncementTranslationsApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsGetQueryOptions(
      announcementId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create or update an announcement translation.
 * @summary Upsert Announcement Translation
 */
export const upsertAnnouncementTranslationApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsLanguagePut =
  (
    announcementId: string,
    language: string,
    upsertAnnouncementTranslationApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsLanguagePutBody: UpsertAnnouncementTranslationApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsLanguagePutBody
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/announcements/${announcementId}/translations/${language}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: upsertAnnouncementTranslationApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsLanguagePutBody
    });
  };

export const getUpsertAnnouncementTranslationApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsLanguagePutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof upsertAnnouncementTranslationApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsLanguagePut
        >
      >,
      TError,
      {
        announcementId: string;
        language: string;
        data: UpsertAnnouncementTranslationApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsLanguagePutBody;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof upsertAnnouncementTranslationApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsLanguagePut
      >
    >,
    TError,
    {
      announcementId: string;
      language: string;
      data: UpsertAnnouncementTranslationApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsLanguagePutBody;
    },
    TContext
  > => {
    const mutationKey = [
      'upsertAnnouncementTranslationApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsLanguagePut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof upsertAnnouncementTranslationApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsLanguagePut
        >
      >,
      {
        announcementId: string;
        language: string;
        data: UpsertAnnouncementTranslationApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsLanguagePutBody;
      }
    > = (props) => {
      const { announcementId, language, data } = props ?? {};

      return upsertAnnouncementTranslationApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsLanguagePut(
        announcementId,
        language,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpsertAnnouncementTranslationApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsLanguagePutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof upsertAnnouncementTranslationApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsLanguagePut
      >
    >
  >;
export type UpsertAnnouncementTranslationApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsLanguagePutMutationBody =
  UpsertAnnouncementTranslationApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsLanguagePutBody;
export type UpsertAnnouncementTranslationApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsLanguagePutMutationError =
  HTTPValidationError;

/**
 * @summary Upsert Announcement Translation
 */
export const useUpsertAnnouncementTranslationApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsLanguagePut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof upsertAnnouncementTranslationApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsLanguagePut
          >
        >,
        TError,
        {
          announcementId: string;
          language: string;
          data: UpsertAnnouncementTranslationApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsLanguagePutBody;
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof upsertAnnouncementTranslationApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsLanguagePut
      >
    >,
    TError,
    {
      announcementId: string;
      language: string;
      data: UpsertAnnouncementTranslationApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsLanguagePutBody;
    },
    TContext
  > => {
    const mutationOptions =
      getUpsertAnnouncementTranslationApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsLanguagePutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Delete an announcement translation.
 * @summary Delete Announcement Translation
 */
export const deleteAnnouncementTranslationApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsLanguageDelete =
  (announcementId: string, language: string) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/announcements/${announcementId}/translations/${language}`,
      method: 'DELETE'
    });
  };

export const getDeleteAnnouncementTranslationApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsLanguageDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteAnnouncementTranslationApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsLanguageDelete
        >
      >,
      TError,
      { announcementId: string; language: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteAnnouncementTranslationApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsLanguageDelete
      >
    >,
    TError,
    { announcementId: string; language: string },
    TContext
  > => {
    const mutationKey = [
      'deleteAnnouncementTranslationApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsLanguageDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteAnnouncementTranslationApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsLanguageDelete
        >
      >,
      { announcementId: string; language: string }
    > = (props) => {
      const { announcementId, language } = props ?? {};

      return deleteAnnouncementTranslationApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsLanguageDelete(
        announcementId,
        language
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteAnnouncementTranslationApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsLanguageDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteAnnouncementTranslationApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsLanguageDelete
      >
    >
  >;

export type DeleteAnnouncementTranslationApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsLanguageDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Announcement Translation
 */
export const useDeleteAnnouncementTranslationApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsLanguageDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteAnnouncementTranslationApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsLanguageDelete
          >
        >,
        TError,
        { announcementId: string; language: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteAnnouncementTranslationApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsLanguageDelete
      >
    >,
    TError,
    { announcementId: string; language: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteAnnouncementTranslationApiV1SoftwareFactoryAnnouncementsAnnouncementIdTranslationsLanguageDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Replace the work items linked to an announcement. Body: {"work_item_ids": [...]}.
 * @summary Set Announcement Work Items
 */
export const setAnnouncementWorkItemsApiV1SoftwareFactoryAnnouncementsAnnouncementIdWorkItemsPut =
  (
    announcementId: string,
    setAnnouncementWorkItemsApiV1SoftwareFactoryAnnouncementsAnnouncementIdWorkItemsPutBody: SetAnnouncementWorkItemsApiV1SoftwareFactoryAnnouncementsAnnouncementIdWorkItemsPutBody
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/announcements/${announcementId}/work-items`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: setAnnouncementWorkItemsApiV1SoftwareFactoryAnnouncementsAnnouncementIdWorkItemsPutBody
    });
  };

export const getSetAnnouncementWorkItemsApiV1SoftwareFactoryAnnouncementsAnnouncementIdWorkItemsPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof setAnnouncementWorkItemsApiV1SoftwareFactoryAnnouncementsAnnouncementIdWorkItemsPut
        >
      >,
      TError,
      {
        announcementId: string;
        data: SetAnnouncementWorkItemsApiV1SoftwareFactoryAnnouncementsAnnouncementIdWorkItemsPutBody;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof setAnnouncementWorkItemsApiV1SoftwareFactoryAnnouncementsAnnouncementIdWorkItemsPut
      >
    >,
    TError,
    {
      announcementId: string;
      data: SetAnnouncementWorkItemsApiV1SoftwareFactoryAnnouncementsAnnouncementIdWorkItemsPutBody;
    },
    TContext
  > => {
    const mutationKey = [
      'setAnnouncementWorkItemsApiV1SoftwareFactoryAnnouncementsAnnouncementIdWorkItemsPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof setAnnouncementWorkItemsApiV1SoftwareFactoryAnnouncementsAnnouncementIdWorkItemsPut
        >
      >,
      {
        announcementId: string;
        data: SetAnnouncementWorkItemsApiV1SoftwareFactoryAnnouncementsAnnouncementIdWorkItemsPutBody;
      }
    > = (props) => {
      const { announcementId, data } = props ?? {};

      return setAnnouncementWorkItemsApiV1SoftwareFactoryAnnouncementsAnnouncementIdWorkItemsPut(
        announcementId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type SetAnnouncementWorkItemsApiV1SoftwareFactoryAnnouncementsAnnouncementIdWorkItemsPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof setAnnouncementWorkItemsApiV1SoftwareFactoryAnnouncementsAnnouncementIdWorkItemsPut
      >
    >
  >;
export type SetAnnouncementWorkItemsApiV1SoftwareFactoryAnnouncementsAnnouncementIdWorkItemsPutMutationBody =
  SetAnnouncementWorkItemsApiV1SoftwareFactoryAnnouncementsAnnouncementIdWorkItemsPutBody;
export type SetAnnouncementWorkItemsApiV1SoftwareFactoryAnnouncementsAnnouncementIdWorkItemsPutMutationError =
  HTTPValidationError;

/**
 * @summary Set Announcement Work Items
 */
export const useSetAnnouncementWorkItemsApiV1SoftwareFactoryAnnouncementsAnnouncementIdWorkItemsPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof setAnnouncementWorkItemsApiV1SoftwareFactoryAnnouncementsAnnouncementIdWorkItemsPut
          >
        >,
        TError,
        {
          announcementId: string;
          data: SetAnnouncementWorkItemsApiV1SoftwareFactoryAnnouncementsAnnouncementIdWorkItemsPutBody;
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof setAnnouncementWorkItemsApiV1SoftwareFactoryAnnouncementsAnnouncementIdWorkItemsPut
      >
    >,
    TError,
    {
      announcementId: string;
      data: SetAnnouncementWorkItemsApiV1SoftwareFactoryAnnouncementsAnnouncementIdWorkItemsPutBody;
    },
    TContext
  > => {
    const mutationOptions =
      getSetAnnouncementWorkItemsApiV1SoftwareFactoryAnnouncementsAnnouncementIdWorkItemsPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Replace the initiatives linked to an announcement. Body: {"initiative_ids": [...]}.
 * @summary Set Announcement Initiatives
 */
export const setAnnouncementInitiativesApiV1SoftwareFactoryAnnouncementsAnnouncementIdInitiativesPut =
  (
    announcementId: string,
    setAnnouncementInitiativesApiV1SoftwareFactoryAnnouncementsAnnouncementIdInitiativesPutBody: SetAnnouncementInitiativesApiV1SoftwareFactoryAnnouncementsAnnouncementIdInitiativesPutBody
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/announcements/${announcementId}/initiatives`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: setAnnouncementInitiativesApiV1SoftwareFactoryAnnouncementsAnnouncementIdInitiativesPutBody
    });
  };

export const getSetAnnouncementInitiativesApiV1SoftwareFactoryAnnouncementsAnnouncementIdInitiativesPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof setAnnouncementInitiativesApiV1SoftwareFactoryAnnouncementsAnnouncementIdInitiativesPut
        >
      >,
      TError,
      {
        announcementId: string;
        data: SetAnnouncementInitiativesApiV1SoftwareFactoryAnnouncementsAnnouncementIdInitiativesPutBody;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof setAnnouncementInitiativesApiV1SoftwareFactoryAnnouncementsAnnouncementIdInitiativesPut
      >
    >,
    TError,
    {
      announcementId: string;
      data: SetAnnouncementInitiativesApiV1SoftwareFactoryAnnouncementsAnnouncementIdInitiativesPutBody;
    },
    TContext
  > => {
    const mutationKey = [
      'setAnnouncementInitiativesApiV1SoftwareFactoryAnnouncementsAnnouncementIdInitiativesPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof setAnnouncementInitiativesApiV1SoftwareFactoryAnnouncementsAnnouncementIdInitiativesPut
        >
      >,
      {
        announcementId: string;
        data: SetAnnouncementInitiativesApiV1SoftwareFactoryAnnouncementsAnnouncementIdInitiativesPutBody;
      }
    > = (props) => {
      const { announcementId, data } = props ?? {};

      return setAnnouncementInitiativesApiV1SoftwareFactoryAnnouncementsAnnouncementIdInitiativesPut(
        announcementId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type SetAnnouncementInitiativesApiV1SoftwareFactoryAnnouncementsAnnouncementIdInitiativesPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof setAnnouncementInitiativesApiV1SoftwareFactoryAnnouncementsAnnouncementIdInitiativesPut
      >
    >
  >;
export type SetAnnouncementInitiativesApiV1SoftwareFactoryAnnouncementsAnnouncementIdInitiativesPutMutationBody =
  SetAnnouncementInitiativesApiV1SoftwareFactoryAnnouncementsAnnouncementIdInitiativesPutBody;
export type SetAnnouncementInitiativesApiV1SoftwareFactoryAnnouncementsAnnouncementIdInitiativesPutMutationError =
  HTTPValidationError;

/**
 * @summary Set Announcement Initiatives
 */
export const useSetAnnouncementInitiativesApiV1SoftwareFactoryAnnouncementsAnnouncementIdInitiativesPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof setAnnouncementInitiativesApiV1SoftwareFactoryAnnouncementsAnnouncementIdInitiativesPut
          >
        >,
        TError,
        {
          announcementId: string;
          data: SetAnnouncementInitiativesApiV1SoftwareFactoryAnnouncementsAnnouncementIdInitiativesPutBody;
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof setAnnouncementInitiativesApiV1SoftwareFactoryAnnouncementsAnnouncementIdInitiativesPut
      >
    >,
    TError,
    {
      announcementId: string;
      data: SetAnnouncementInitiativesApiV1SoftwareFactoryAnnouncementsAnnouncementIdInitiativesPutBody;
    },
    TContext
  > => {
    const mutationOptions =
      getSetAnnouncementInitiativesApiV1SoftwareFactoryAnnouncementsAnnouncementIdInitiativesPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Record that the current user viewed an announcement. Body: {"dismissed": bool}.
 * @summary Record Announcement View
 */
export const recordAnnouncementViewApiV1SoftwareFactoryAnnouncementsAnnouncementIdViewPost =
  (
    announcementId: string,
    recordAnnouncementViewApiV1SoftwareFactoryAnnouncementsAnnouncementIdViewPostBody: RecordAnnouncementViewApiV1SoftwareFactoryAnnouncementsAnnouncementIdViewPostBody,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/announcements/${announcementId}/view`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: recordAnnouncementViewApiV1SoftwareFactoryAnnouncementsAnnouncementIdViewPostBody,
      signal
    });
  };

export const getRecordAnnouncementViewApiV1SoftwareFactoryAnnouncementsAnnouncementIdViewPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof recordAnnouncementViewApiV1SoftwareFactoryAnnouncementsAnnouncementIdViewPost
        >
      >,
      TError,
      {
        announcementId: string;
        data: RecordAnnouncementViewApiV1SoftwareFactoryAnnouncementsAnnouncementIdViewPostBody;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof recordAnnouncementViewApiV1SoftwareFactoryAnnouncementsAnnouncementIdViewPost
      >
    >,
    TError,
    {
      announcementId: string;
      data: RecordAnnouncementViewApiV1SoftwareFactoryAnnouncementsAnnouncementIdViewPostBody;
    },
    TContext
  > => {
    const mutationKey = [
      'recordAnnouncementViewApiV1SoftwareFactoryAnnouncementsAnnouncementIdViewPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof recordAnnouncementViewApiV1SoftwareFactoryAnnouncementsAnnouncementIdViewPost
        >
      >,
      {
        announcementId: string;
        data: RecordAnnouncementViewApiV1SoftwareFactoryAnnouncementsAnnouncementIdViewPostBody;
      }
    > = (props) => {
      const { announcementId, data } = props ?? {};

      return recordAnnouncementViewApiV1SoftwareFactoryAnnouncementsAnnouncementIdViewPost(
        announcementId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RecordAnnouncementViewApiV1SoftwareFactoryAnnouncementsAnnouncementIdViewPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof recordAnnouncementViewApiV1SoftwareFactoryAnnouncementsAnnouncementIdViewPost
      >
    >
  >;
export type RecordAnnouncementViewApiV1SoftwareFactoryAnnouncementsAnnouncementIdViewPostMutationBody =
  RecordAnnouncementViewApiV1SoftwareFactoryAnnouncementsAnnouncementIdViewPostBody;
export type RecordAnnouncementViewApiV1SoftwareFactoryAnnouncementsAnnouncementIdViewPostMutationError =
  HTTPValidationError;

/**
 * @summary Record Announcement View
 */
export const useRecordAnnouncementViewApiV1SoftwareFactoryAnnouncementsAnnouncementIdViewPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof recordAnnouncementViewApiV1SoftwareFactoryAnnouncementsAnnouncementIdViewPost
          >
        >,
        TError,
        {
          announcementId: string;
          data: RecordAnnouncementViewApiV1SoftwareFactoryAnnouncementsAnnouncementIdViewPostBody;
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof recordAnnouncementViewApiV1SoftwareFactoryAnnouncementsAnnouncementIdViewPost
      >
    >,
    TError,
    {
      announcementId: string;
      data: RecordAnnouncementViewApiV1SoftwareFactoryAnnouncementsAnnouncementIdViewPostBody;
    },
    TContext
  > => {
    const mutationOptions =
      getRecordAnnouncementViewApiV1SoftwareFactoryAnnouncementsAnnouncementIdViewPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Dashboard overview: work-item pipeline counts, module grid + maturity, recent
changelog, and deploy-debt health.

On the shared KPI substrate (docs/platform/dashboard-kpi-endpoints.md): a
schema-first ``response_model`` served through ``cached_kpi`` (per-viewer key +
``admin_scope`` variant). The ``software_factory.work_item`` scope is resolved
here, outside ``cached_kpi``, per the ordering invariant, and threaded through
every work-item aggregate; module / changelog / deploy-debt aggregates are
ungoverned and stay tenant-wide.
 * @summary Get Dashboard
 */
export const getDashboardApiV1SoftwareFactoryDashboardGet = (
  params?: GetDashboardApiV1SoftwareFactoryDashboardGetParams,
  signal?: AbortSignal
) => {
  return customInstance<SoftwareFactoryDashboard>({
    url: `/api/v1/software-factory/dashboard`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetDashboardApiV1SoftwareFactoryDashboardGetQueryKey = (
  params?: GetDashboardApiV1SoftwareFactoryDashboardGetParams
) => {
  return [
    `/api/v1/software-factory/dashboard`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetDashboardApiV1SoftwareFactoryDashboardGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getDashboardApiV1SoftwareFactoryDashboardGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetDashboardApiV1SoftwareFactoryDashboardGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDashboardApiV1SoftwareFactoryDashboardGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDashboardApiV1SoftwareFactoryDashboardGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDashboardApiV1SoftwareFactoryDashboardGet>>
  > = ({ signal }) =>
    getDashboardApiV1SoftwareFactoryDashboardGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDashboardApiV1SoftwareFactoryDashboardGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetDashboardApiV1SoftwareFactoryDashboardGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getDashboardApiV1SoftwareFactoryDashboardGet>>
  >;
export type GetDashboardApiV1SoftwareFactoryDashboardGetQueryError =
  HTTPValidationError;

export function useGetDashboardApiV1SoftwareFactoryDashboardGet<
  TData = Awaited<
    ReturnType<typeof getDashboardApiV1SoftwareFactoryDashboardGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | GetDashboardApiV1SoftwareFactoryDashboardGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDashboardApiV1SoftwareFactoryDashboardGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getDashboardApiV1SoftwareFactoryDashboardGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getDashboardApiV1SoftwareFactoryDashboardGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDashboardApiV1SoftwareFactoryDashboardGet<
  TData = Awaited<
    ReturnType<typeof getDashboardApiV1SoftwareFactoryDashboardGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetDashboardApiV1SoftwareFactoryDashboardGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDashboardApiV1SoftwareFactoryDashboardGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getDashboardApiV1SoftwareFactoryDashboardGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getDashboardApiV1SoftwareFactoryDashboardGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDashboardApiV1SoftwareFactoryDashboardGet<
  TData = Awaited<
    ReturnType<typeof getDashboardApiV1SoftwareFactoryDashboardGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetDashboardApiV1SoftwareFactoryDashboardGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDashboardApiV1SoftwareFactoryDashboardGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Dashboard
 */

export function useGetDashboardApiV1SoftwareFactoryDashboardGet<
  TData = Awaited<
    ReturnType<typeof getDashboardApiV1SoftwareFactoryDashboardGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetDashboardApiV1SoftwareFactoryDashboardGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDashboardApiV1SoftwareFactoryDashboardGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetDashboardApiV1SoftwareFactoryDashboardGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Portfolio/exec view: initiatives with health, progress rollup, and
next-milestone countdown — grouped by quarter and module on the client.
 * @summary Get Portfolio
 */
export const getPortfolioApiV1SoftwareFactoryPortfolioGet = (
  params?: GetPortfolioApiV1SoftwareFactoryPortfolioGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/software-factory/portfolio`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetPortfolioApiV1SoftwareFactoryPortfolioGetQueryKey = (
  params?: GetPortfolioApiV1SoftwareFactoryPortfolioGetParams
) => {
  return [
    `/api/v1/software-factory/portfolio`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetPortfolioApiV1SoftwareFactoryPortfolioGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getPortfolioApiV1SoftwareFactoryPortfolioGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetPortfolioApiV1SoftwareFactoryPortfolioGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getPortfolioApiV1SoftwareFactoryPortfolioGet>
        >,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetPortfolioApiV1SoftwareFactoryPortfolioGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPortfolioApiV1SoftwareFactoryPortfolioGet>>
  > = ({ signal }) =>
    getPortfolioApiV1SoftwareFactoryPortfolioGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPortfolioApiV1SoftwareFactoryPortfolioGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetPortfolioApiV1SoftwareFactoryPortfolioGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getPortfolioApiV1SoftwareFactoryPortfolioGet>>
  >;
export type GetPortfolioApiV1SoftwareFactoryPortfolioGetQueryError =
  HTTPValidationError;

export function useGetPortfolioApiV1SoftwareFactoryPortfolioGet<
  TData = Awaited<
    ReturnType<typeof getPortfolioApiV1SoftwareFactoryPortfolioGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | GetPortfolioApiV1SoftwareFactoryPortfolioGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getPortfolioApiV1SoftwareFactoryPortfolioGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getPortfolioApiV1SoftwareFactoryPortfolioGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getPortfolioApiV1SoftwareFactoryPortfolioGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetPortfolioApiV1SoftwareFactoryPortfolioGet<
  TData = Awaited<
    ReturnType<typeof getPortfolioApiV1SoftwareFactoryPortfolioGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetPortfolioApiV1SoftwareFactoryPortfolioGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getPortfolioApiV1SoftwareFactoryPortfolioGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getPortfolioApiV1SoftwareFactoryPortfolioGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getPortfolioApiV1SoftwareFactoryPortfolioGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetPortfolioApiV1SoftwareFactoryPortfolioGet<
  TData = Awaited<
    ReturnType<typeof getPortfolioApiV1SoftwareFactoryPortfolioGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetPortfolioApiV1SoftwareFactoryPortfolioGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getPortfolioApiV1SoftwareFactoryPortfolioGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Portfolio
 */

export function useGetPortfolioApiV1SoftwareFactoryPortfolioGet<
  TData = Awaited<
    ReturnType<typeof getPortfolioApiV1SoftwareFactoryPortfolioGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetPortfolioApiV1SoftwareFactoryPortfolioGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getPortfolioApiV1SoftwareFactoryPortfolioGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetPortfolioApiV1SoftwareFactoryPortfolioGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get shipping velocity report: work items closed per time bucket, broken down by a chosen dimension.
 * @summary Get Shipping Report
 */
export const getShippingReportApiV1SoftwareFactoryReportsShippingGet = (
  params: GetShippingReportApiV1SoftwareFactoryReportsShippingGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/software-factory/reports/shipping`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetShippingReportApiV1SoftwareFactoryReportsShippingGetQueryKey =
  (params?: GetShippingReportApiV1SoftwareFactoryReportsShippingGetParams) => {
    return [
      `/api/v1/software-factory/reports/shipping`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetShippingReportApiV1SoftwareFactoryReportsShippingGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getShippingReportApiV1SoftwareFactoryReportsShippingGet>
    >,
    TError = HTTPValidationError
  >(
    params: GetShippingReportApiV1SoftwareFactoryReportsShippingGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getShippingReportApiV1SoftwareFactoryReportsShippingGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetShippingReportApiV1SoftwareFactoryReportsShippingGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getShippingReportApiV1SoftwareFactoryReportsShippingGet
        >
      >
    > = ({ signal }) =>
      getShippingReportApiV1SoftwareFactoryReportsShippingGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getShippingReportApiV1SoftwareFactoryReportsShippingGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetShippingReportApiV1SoftwareFactoryReportsShippingGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getShippingReportApiV1SoftwareFactoryReportsShippingGet>
    >
  >;
export type GetShippingReportApiV1SoftwareFactoryReportsShippingGetQueryError =
  HTTPValidationError;

export function useGetShippingReportApiV1SoftwareFactoryReportsShippingGet<
  TData = Awaited<
    ReturnType<typeof getShippingReportApiV1SoftwareFactoryReportsShippingGet>
  >,
  TError = HTTPValidationError
>(
  params: GetShippingReportApiV1SoftwareFactoryReportsShippingGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getShippingReportApiV1SoftwareFactoryReportsShippingGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getShippingReportApiV1SoftwareFactoryReportsShippingGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getShippingReportApiV1SoftwareFactoryReportsShippingGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetShippingReportApiV1SoftwareFactoryReportsShippingGet<
  TData = Awaited<
    ReturnType<typeof getShippingReportApiV1SoftwareFactoryReportsShippingGet>
  >,
  TError = HTTPValidationError
>(
  params: GetShippingReportApiV1SoftwareFactoryReportsShippingGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getShippingReportApiV1SoftwareFactoryReportsShippingGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getShippingReportApiV1SoftwareFactoryReportsShippingGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getShippingReportApiV1SoftwareFactoryReportsShippingGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetShippingReportApiV1SoftwareFactoryReportsShippingGet<
  TData = Awaited<
    ReturnType<typeof getShippingReportApiV1SoftwareFactoryReportsShippingGet>
  >,
  TError = HTTPValidationError
>(
  params: GetShippingReportApiV1SoftwareFactoryReportsShippingGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getShippingReportApiV1SoftwareFactoryReportsShippingGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Shipping Report
 */

export function useGetShippingReportApiV1SoftwareFactoryReportsShippingGet<
  TData = Awaited<
    ReturnType<typeof getShippingReportApiV1SoftwareFactoryReportsShippingGet>
  >,
  TError = HTTPValidationError
>(
  params: GetShippingReportApiV1SoftwareFactoryReportsShippingGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getShippingReportApiV1SoftwareFactoryReportsShippingGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetShippingReportApiV1SoftwareFactoryReportsShippingGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List Scoring Frameworks
 */
export const listScoringFrameworksApiV1SoftwareFactoryScoringFrameworksGet = (
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/software-factory/scoring-frameworks`,
    method: 'GET',
    signal
  });
};

export const getListScoringFrameworksApiV1SoftwareFactoryScoringFrameworksGetQueryKey =
  () => {
    return [`/api/v1/software-factory/scoring-frameworks`] as const;
  };

export const getListScoringFrameworksApiV1SoftwareFactoryScoringFrameworksGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listScoringFrameworksApiV1SoftwareFactoryScoringFrameworksGet
      >
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listScoringFrameworksApiV1SoftwareFactoryScoringFrameworksGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListScoringFrameworksApiV1SoftwareFactoryScoringFrameworksGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listScoringFrameworksApiV1SoftwareFactoryScoringFrameworksGet
        >
      >
    > = ({ signal }) =>
      listScoringFrameworksApiV1SoftwareFactoryScoringFrameworksGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listScoringFrameworksApiV1SoftwareFactoryScoringFrameworksGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListScoringFrameworksApiV1SoftwareFactoryScoringFrameworksGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listScoringFrameworksApiV1SoftwareFactoryScoringFrameworksGet
      >
    >
  >;
export type ListScoringFrameworksApiV1SoftwareFactoryScoringFrameworksGetQueryError =
  unknown;

export function useListScoringFrameworksApiV1SoftwareFactoryScoringFrameworksGet<
  TData = Awaited<
    ReturnType<
      typeof listScoringFrameworksApiV1SoftwareFactoryScoringFrameworksGet
    >
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listScoringFrameworksApiV1SoftwareFactoryScoringFrameworksGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listScoringFrameworksApiV1SoftwareFactoryScoringFrameworksGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listScoringFrameworksApiV1SoftwareFactoryScoringFrameworksGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListScoringFrameworksApiV1SoftwareFactoryScoringFrameworksGet<
  TData = Awaited<
    ReturnType<
      typeof listScoringFrameworksApiV1SoftwareFactoryScoringFrameworksGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listScoringFrameworksApiV1SoftwareFactoryScoringFrameworksGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listScoringFrameworksApiV1SoftwareFactoryScoringFrameworksGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listScoringFrameworksApiV1SoftwareFactoryScoringFrameworksGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListScoringFrameworksApiV1SoftwareFactoryScoringFrameworksGet<
  TData = Awaited<
    ReturnType<
      typeof listScoringFrameworksApiV1SoftwareFactoryScoringFrameworksGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listScoringFrameworksApiV1SoftwareFactoryScoringFrameworksGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Scoring Frameworks
 */

export function useListScoringFrameworksApiV1SoftwareFactoryScoringFrameworksGet<
  TData = Awaited<
    ReturnType<
      typeof listScoringFrameworksApiV1SoftwareFactoryScoringFrameworksGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listScoringFrameworksApiV1SoftwareFactoryScoringFrameworksGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListScoringFrameworksApiV1SoftwareFactoryScoringFrameworksGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List Exception Log Sources
 */
export const listExceptionLogSourcesApiV1SoftwareFactoryExceptionsLogSourcesGet =
  (signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/exceptions/log-sources`,
      method: 'GET',
      signal
    });
  };

export const getListExceptionLogSourcesApiV1SoftwareFactoryExceptionsLogSourcesGetQueryKey =
  () => {
    return [`/api/v1/software-factory/exceptions/log-sources`] as const;
  };

export const getListExceptionLogSourcesApiV1SoftwareFactoryExceptionsLogSourcesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listExceptionLogSourcesApiV1SoftwareFactoryExceptionsLogSourcesGet
      >
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listExceptionLogSourcesApiV1SoftwareFactoryExceptionsLogSourcesGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListExceptionLogSourcesApiV1SoftwareFactoryExceptionsLogSourcesGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listExceptionLogSourcesApiV1SoftwareFactoryExceptionsLogSourcesGet
        >
      >
    > = ({ signal }) =>
      listExceptionLogSourcesApiV1SoftwareFactoryExceptionsLogSourcesGet(
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listExceptionLogSourcesApiV1SoftwareFactoryExceptionsLogSourcesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListExceptionLogSourcesApiV1SoftwareFactoryExceptionsLogSourcesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listExceptionLogSourcesApiV1SoftwareFactoryExceptionsLogSourcesGet
      >
    >
  >;
export type ListExceptionLogSourcesApiV1SoftwareFactoryExceptionsLogSourcesGetQueryError =
  unknown;

export function useListExceptionLogSourcesApiV1SoftwareFactoryExceptionsLogSourcesGet<
  TData = Awaited<
    ReturnType<
      typeof listExceptionLogSourcesApiV1SoftwareFactoryExceptionsLogSourcesGet
    >
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listExceptionLogSourcesApiV1SoftwareFactoryExceptionsLogSourcesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listExceptionLogSourcesApiV1SoftwareFactoryExceptionsLogSourcesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listExceptionLogSourcesApiV1SoftwareFactoryExceptionsLogSourcesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListExceptionLogSourcesApiV1SoftwareFactoryExceptionsLogSourcesGet<
  TData = Awaited<
    ReturnType<
      typeof listExceptionLogSourcesApiV1SoftwareFactoryExceptionsLogSourcesGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listExceptionLogSourcesApiV1SoftwareFactoryExceptionsLogSourcesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listExceptionLogSourcesApiV1SoftwareFactoryExceptionsLogSourcesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listExceptionLogSourcesApiV1SoftwareFactoryExceptionsLogSourcesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListExceptionLogSourcesApiV1SoftwareFactoryExceptionsLogSourcesGet<
  TData = Awaited<
    ReturnType<
      typeof listExceptionLogSourcesApiV1SoftwareFactoryExceptionsLogSourcesGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listExceptionLogSourcesApiV1SoftwareFactoryExceptionsLogSourcesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Exception Log Sources
 */

export function useListExceptionLogSourcesApiV1SoftwareFactoryExceptionsLogSourcesGet<
  TData = Awaited<
    ReturnType<
      typeof listExceptionLogSourcesApiV1SoftwareFactoryExceptionsLogSourcesGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listExceptionLogSourcesApiV1SoftwareFactoryExceptionsLogSourcesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListExceptionLogSourcesApiV1SoftwareFactoryExceptionsLogSourcesGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Exception Log Source
 */
export const createExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesPost =
  (
    createExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesPostBody: CreateExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesPostBody,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/exceptions/log-sources`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesPostBody,
      signal
    });
  };

export const getCreateExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesPost
        >
      >,
      TError,
      {
        data: CreateExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesPostBody;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesPost
      >
    >,
    TError,
    {
      data: CreateExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesPostBody;
    },
    TContext
  > => {
    const mutationKey = [
      'createExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesPost
        >
      >,
      {
        data: CreateExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesPostBody;
      }
    > = (props) => {
      const { data } = props ?? {};

      return createExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesPost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesPost
      >
    >
  >;
export type CreateExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesPostMutationBody =
  CreateExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesPostBody;
export type CreateExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Exception Log Source
 */
export const useCreateExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof createExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesPost
          >
        >,
        TError,
        {
          data: CreateExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesPostBody;
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof createExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesPost
      >
    >,
    TError,
    {
      data: CreateExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesPostBody;
    },
    TContext
  > => {
    const mutationOptions =
      getCreateExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * @summary Update Exception Log Source
 */
export const updateExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdPut =
  (
    sourceId: string,
    updateExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdPutBody: UpdateExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdPutBody
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/exceptions/log-sources/${sourceId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdPutBody
    });
  };

export const getUpdateExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdPut
        >
      >,
      TError,
      {
        sourceId: string;
        data: UpdateExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdPutBody;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdPut
      >
    >,
    TError,
    {
      sourceId: string;
      data: UpdateExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdPutBody;
    },
    TContext
  > => {
    const mutationKey = [
      'updateExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdPut
        >
      >,
      {
        sourceId: string;
        data: UpdateExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdPutBody;
      }
    > = (props) => {
      const { sourceId, data } = props ?? {};

      return updateExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdPut(
        sourceId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdPut
      >
    >
  >;
export type UpdateExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdPutMutationBody =
  UpdateExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdPutBody;
export type UpdateExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Exception Log Source
 */
export const useUpdateExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdPut
          >
        >,
        TError,
        {
          sourceId: string;
          data: UpdateExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdPutBody;
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdPut
      >
    >,
    TError,
    {
      sourceId: string;
      data: UpdateExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdPutBody;
    },
    TContext
  > => {
    const mutationOptions =
      getUpdateExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * @summary Delete Exception Log Source
 */
export const deleteExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdDelete =
  (sourceId: string) => {
    return customInstance<void>({
      url: `/api/v1/software-factory/exceptions/log-sources/${sourceId}`,
      method: 'DELETE'
    });
  };

export const getDeleteExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdDelete
        >
      >,
      TError,
      { sourceId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdDelete
      >
    >,
    TError,
    { sourceId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdDelete
        >
      >,
      { sourceId: string }
    > = (props) => {
      const { sourceId } = props ?? {};

      return deleteExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdDelete(
        sourceId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdDelete
      >
    >
  >;

export type DeleteExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Exception Log Source
 */
export const useDeleteExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdDelete
          >
        >,
        TError,
        { sourceId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdDelete
      >
    >,
    TError,
    { sourceId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * @summary Test Exception Log Source
 */
export const testExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdTestPost =
  (sourceId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/exceptions/log-sources/${sourceId}/test`,
      method: 'POST',
      signal
    });
  };

export const getTestExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdTestPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof testExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdTestPost
        >
      >,
      TError,
      { sourceId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof testExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdTestPost
      >
    >,
    TError,
    { sourceId: string },
    TContext
  > => {
    const mutationKey = [
      'testExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdTestPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof testExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdTestPost
        >
      >,
      { sourceId: string }
    > = (props) => {
      const { sourceId } = props ?? {};

      return testExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdTestPost(
        sourceId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type TestExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdTestPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof testExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdTestPost
      >
    >
  >;

export type TestExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdTestPostMutationError =
  HTTPValidationError;

/**
 * @summary Test Exception Log Source
 */
export const useTestExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdTestPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof testExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdTestPost
          >
        >,
        TError,
        { sourceId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof testExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdTestPost
      >
    >,
    TError,
    { sourceId: string },
    TContext
  > => {
    const mutationOptions =
      getTestExceptionLogSourceApiV1SoftwareFactoryExceptionsLogSourcesSourceIdTestPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * @summary List Exception Fingerprints
 */
export const listExceptionFingerprintsApiV1SoftwareFactoryExceptionsFingerprintsGet =
  (
    params?: ListExceptionFingerprintsApiV1SoftwareFactoryExceptionsFingerprintsGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/exceptions/fingerprints`,
      method: 'GET',
      params,
      signal
    });
  };

export const getListExceptionFingerprintsApiV1SoftwareFactoryExceptionsFingerprintsGetQueryKey =
  (
    params?: ListExceptionFingerprintsApiV1SoftwareFactoryExceptionsFingerprintsGetParams
  ) => {
    return [
      `/api/v1/software-factory/exceptions/fingerprints`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListExceptionFingerprintsApiV1SoftwareFactoryExceptionsFingerprintsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listExceptionFingerprintsApiV1SoftwareFactoryExceptionsFingerprintsGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: ListExceptionFingerprintsApiV1SoftwareFactoryExceptionsFingerprintsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listExceptionFingerprintsApiV1SoftwareFactoryExceptionsFingerprintsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListExceptionFingerprintsApiV1SoftwareFactoryExceptionsFingerprintsGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listExceptionFingerprintsApiV1SoftwareFactoryExceptionsFingerprintsGet
        >
      >
    > = ({ signal }) =>
      listExceptionFingerprintsApiV1SoftwareFactoryExceptionsFingerprintsGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listExceptionFingerprintsApiV1SoftwareFactoryExceptionsFingerprintsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListExceptionFingerprintsApiV1SoftwareFactoryExceptionsFingerprintsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listExceptionFingerprintsApiV1SoftwareFactoryExceptionsFingerprintsGet
      >
    >
  >;
export type ListExceptionFingerprintsApiV1SoftwareFactoryExceptionsFingerprintsGetQueryError =
  HTTPValidationError;

export function useListExceptionFingerprintsApiV1SoftwareFactoryExceptionsFingerprintsGet<
  TData = Awaited<
    ReturnType<
      typeof listExceptionFingerprintsApiV1SoftwareFactoryExceptionsFingerprintsGet
    >
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | ListExceptionFingerprintsApiV1SoftwareFactoryExceptionsFingerprintsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listExceptionFingerprintsApiV1SoftwareFactoryExceptionsFingerprintsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listExceptionFingerprintsApiV1SoftwareFactoryExceptionsFingerprintsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listExceptionFingerprintsApiV1SoftwareFactoryExceptionsFingerprintsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListExceptionFingerprintsApiV1SoftwareFactoryExceptionsFingerprintsGet<
  TData = Awaited<
    ReturnType<
      typeof listExceptionFingerprintsApiV1SoftwareFactoryExceptionsFingerprintsGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListExceptionFingerprintsApiV1SoftwareFactoryExceptionsFingerprintsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listExceptionFingerprintsApiV1SoftwareFactoryExceptionsFingerprintsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listExceptionFingerprintsApiV1SoftwareFactoryExceptionsFingerprintsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listExceptionFingerprintsApiV1SoftwareFactoryExceptionsFingerprintsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListExceptionFingerprintsApiV1SoftwareFactoryExceptionsFingerprintsGet<
  TData = Awaited<
    ReturnType<
      typeof listExceptionFingerprintsApiV1SoftwareFactoryExceptionsFingerprintsGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListExceptionFingerprintsApiV1SoftwareFactoryExceptionsFingerprintsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listExceptionFingerprintsApiV1SoftwareFactoryExceptionsFingerprintsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Exception Fingerprints
 */

export function useListExceptionFingerprintsApiV1SoftwareFactoryExceptionsFingerprintsGet<
  TData = Awaited<
    ReturnType<
      typeof listExceptionFingerprintsApiV1SoftwareFactoryExceptionsFingerprintsGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListExceptionFingerprintsApiV1SoftwareFactoryExceptionsFingerprintsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listExceptionFingerprintsApiV1SoftwareFactoryExceptionsFingerprintsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListExceptionFingerprintsApiV1SoftwareFactoryExceptionsFingerprintsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Exception Fingerprint
 */
export const getExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdGet =
  (fingerprintId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/exceptions/fingerprints/${fingerprintId}`,
      method: 'GET',
      signal
    });
  };

export const getGetExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdGetQueryKey =
  (fingerprintId?: string) => {
    return [
      `/api/v1/software-factory/exceptions/fingerprints/${fingerprintId}`
    ] as const;
  };

export const getGetExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdGet
      >
    >,
    TError = HTTPValidationError
  >(
    fingerprintId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdGetQueryKey(
        fingerprintId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdGet
        >
      >
    > = ({ signal }) =>
      getExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdGet(
        fingerprintId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!fingerprintId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdGet
      >
    >
  >;
export type GetExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdGetQueryError =
  HTTPValidationError;

export function useGetExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdGet<
  TData = Awaited<
    ReturnType<
      typeof getExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdGet
    >
  >,
  TError = HTTPValidationError
>(
  fingerprintId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdGet<
  TData = Awaited<
    ReturnType<
      typeof getExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdGet
    >
  >,
  TError = HTTPValidationError
>(
  fingerprintId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdGet<
  TData = Awaited<
    ReturnType<
      typeof getExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdGet
    >
  >,
  TError = HTTPValidationError
>(
  fingerprintId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Exception Fingerprint
 */

export function useGetExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdGet<
  TData = Awaited<
    ReturnType<
      typeof getExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdGet
    >
  >,
  TError = HTTPValidationError
>(
  fingerprintId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdGetQueryOptions(
      fingerprintId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Mute Exception Fingerprint
 */
export const muteExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdMutePut =
  (
    fingerprintId: string,
    muteExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdMutePutBody: MuteExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdMutePutBody
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/exceptions/fingerprints/${fingerprintId}/mute`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: muteExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdMutePutBody
    });
  };

export const getMuteExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdMutePutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof muteExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdMutePut
        >
      >,
      TError,
      {
        fingerprintId: string;
        data: MuteExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdMutePutBody;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof muteExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdMutePut
      >
    >,
    TError,
    {
      fingerprintId: string;
      data: MuteExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdMutePutBody;
    },
    TContext
  > => {
    const mutationKey = [
      'muteExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdMutePut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof muteExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdMutePut
        >
      >,
      {
        fingerprintId: string;
        data: MuteExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdMutePutBody;
      }
    > = (props) => {
      const { fingerprintId, data } = props ?? {};

      return muteExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdMutePut(
        fingerprintId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type MuteExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdMutePutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof muteExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdMutePut
      >
    >
  >;
export type MuteExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdMutePutMutationBody =
  MuteExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdMutePutBody;
export type MuteExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdMutePutMutationError =
  HTTPValidationError;

/**
 * @summary Mute Exception Fingerprint
 */
export const useMuteExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdMutePut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof muteExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdMutePut
          >
        >,
        TError,
        {
          fingerprintId: string;
          data: MuteExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdMutePutBody;
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof muteExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdMutePut
      >
    >,
    TError,
    {
      fingerprintId: string;
      data: MuteExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdMutePutBody;
    },
    TContext
  > => {
    const mutationOptions =
      getMuteExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdMutePutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * @summary Unmute Exception Fingerprint
 */
export const unmuteExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdUnmutePut =
  (fingerprintId: string) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/exceptions/fingerprints/${fingerprintId}/unmute`,
      method: 'PUT'
    });
  };

export const getUnmuteExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdUnmutePutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof unmuteExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdUnmutePut
        >
      >,
      TError,
      { fingerprintId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof unmuteExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdUnmutePut
      >
    >,
    TError,
    { fingerprintId: string },
    TContext
  > => {
    const mutationKey = [
      'unmuteExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdUnmutePut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof unmuteExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdUnmutePut
        >
      >,
      { fingerprintId: string }
    > = (props) => {
      const { fingerprintId } = props ?? {};

      return unmuteExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdUnmutePut(
        fingerprintId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UnmuteExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdUnmutePutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof unmuteExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdUnmutePut
      >
    >
  >;

export type UnmuteExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdUnmutePutMutationError =
  HTTPValidationError;

/**
 * @summary Unmute Exception Fingerprint
 */
export const useUnmuteExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdUnmutePut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof unmuteExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdUnmutePut
          >
        >,
        TError,
        { fingerprintId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof unmuteExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdUnmutePut
      >
    >,
    TError,
    { fingerprintId: string },
    TContext
  > => {
    const mutationOptions =
      getUnmuteExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdUnmutePutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * @summary Resolve Exception Fingerprint
 */
export const resolveExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdResolvePut =
  (fingerprintId: string) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/exceptions/fingerprints/${fingerprintId}/resolve`,
      method: 'PUT'
    });
  };

export const getResolveExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdResolvePutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof resolveExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdResolvePut
        >
      >,
      TError,
      { fingerprintId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof resolveExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdResolvePut
      >
    >,
    TError,
    { fingerprintId: string },
    TContext
  > => {
    const mutationKey = [
      'resolveExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdResolvePut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof resolveExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdResolvePut
        >
      >,
      { fingerprintId: string }
    > = (props) => {
      const { fingerprintId } = props ?? {};

      return resolveExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdResolvePut(
        fingerprintId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ResolveExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdResolvePutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof resolveExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdResolvePut
      >
    >
  >;

export type ResolveExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdResolvePutMutationError =
  HTTPValidationError;

/**
 * @summary Resolve Exception Fingerprint
 */
export const useResolveExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdResolvePut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof resolveExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdResolvePut
          >
        >,
        TError,
        { fingerprintId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof resolveExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdResolvePut
      >
    >,
    TError,
    { fingerprintId: string },
    TContext
  > => {
    const mutationOptions =
      getResolveExceptionFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdResolvePutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * @summary Create Work Item For Fingerprint
 */
export const createWorkItemForFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdCreateItemPost =
  (fingerprintId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/software-factory/exceptions/fingerprints/${fingerprintId}/create-item`,
      method: 'POST',
      signal
    });
  };

export const getCreateWorkItemForFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdCreateItemPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createWorkItemForFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdCreateItemPost
        >
      >,
      TError,
      { fingerprintId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createWorkItemForFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdCreateItemPost
      >
    >,
    TError,
    { fingerprintId: string },
    TContext
  > => {
    const mutationKey = [
      'createWorkItemForFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdCreateItemPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createWorkItemForFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdCreateItemPost
        >
      >,
      { fingerprintId: string }
    > = (props) => {
      const { fingerprintId } = props ?? {};

      return createWorkItemForFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdCreateItemPost(
        fingerprintId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateWorkItemForFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdCreateItemPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createWorkItemForFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdCreateItemPost
      >
    >
  >;

export type CreateWorkItemForFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdCreateItemPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Work Item For Fingerprint
 */
export const useCreateWorkItemForFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdCreateItemPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof createWorkItemForFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdCreateItemPost
          >
        >,
        TError,
        { fingerprintId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof createWorkItemForFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdCreateItemPost
      >
    >,
    TError,
    { fingerprintId: string },
    TContext
  > => {
    const mutationOptions =
      getCreateWorkItemForFingerprintApiV1SoftwareFactoryExceptionsFingerprintsFingerprintIdCreateItemPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * @summary Get Exception Stats
 */
export const getExceptionStatsApiV1SoftwareFactoryExceptionsStatsGet = (
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/software-factory/exceptions/stats`,
    method: 'GET',
    signal
  });
};

export const getGetExceptionStatsApiV1SoftwareFactoryExceptionsStatsGetQueryKey =
  () => {
    return [`/api/v1/software-factory/exceptions/stats`] as const;
  };

export const getGetExceptionStatsApiV1SoftwareFactoryExceptionsStatsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getExceptionStatsApiV1SoftwareFactoryExceptionsStatsGet>
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getExceptionStatsApiV1SoftwareFactoryExceptionsStatsGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetExceptionStatsApiV1SoftwareFactoryExceptionsStatsGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getExceptionStatsApiV1SoftwareFactoryExceptionsStatsGet
        >
      >
    > = ({ signal }) =>
      getExceptionStatsApiV1SoftwareFactoryExceptionsStatsGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getExceptionStatsApiV1SoftwareFactoryExceptionsStatsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetExceptionStatsApiV1SoftwareFactoryExceptionsStatsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getExceptionStatsApiV1SoftwareFactoryExceptionsStatsGet>
    >
  >;
export type GetExceptionStatsApiV1SoftwareFactoryExceptionsStatsGetQueryError =
  unknown;

export function useGetExceptionStatsApiV1SoftwareFactoryExceptionsStatsGet<
  TData = Awaited<
    ReturnType<typeof getExceptionStatsApiV1SoftwareFactoryExceptionsStatsGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getExceptionStatsApiV1SoftwareFactoryExceptionsStatsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getExceptionStatsApiV1SoftwareFactoryExceptionsStatsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getExceptionStatsApiV1SoftwareFactoryExceptionsStatsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetExceptionStatsApiV1SoftwareFactoryExceptionsStatsGet<
  TData = Awaited<
    ReturnType<typeof getExceptionStatsApiV1SoftwareFactoryExceptionsStatsGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getExceptionStatsApiV1SoftwareFactoryExceptionsStatsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getExceptionStatsApiV1SoftwareFactoryExceptionsStatsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getExceptionStatsApiV1SoftwareFactoryExceptionsStatsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetExceptionStatsApiV1SoftwareFactoryExceptionsStatsGet<
  TData = Awaited<
    ReturnType<typeof getExceptionStatsApiV1SoftwareFactoryExceptionsStatsGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getExceptionStatsApiV1SoftwareFactoryExceptionsStatsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Exception Stats
 */

export function useGetExceptionStatsApiV1SoftwareFactoryExceptionsStatsGet<
  TData = Awaited<
    ReturnType<typeof getExceptionStatsApiV1SoftwareFactoryExceptionsStatsGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getExceptionStatsApiV1SoftwareFactoryExceptionsStatsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetExceptionStatsApiV1SoftwareFactoryExceptionsStatsGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
